var tianzhao = require('./skill-tianzhao.js')
var shiyu = require('./skill-shiyu.js')
var data = {
    "guangren": [{
        "skillName": "斩风",
        "skillProperty": ["物理攻击", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_bbb7fb16-dacd-4dc5-a555-7f483f284cde_1301",
        "skillDescribe": {
            "main": "对前方区域的所有敌方造成少量伤害",
            "static": ["对前方敌方造成少量物理伤害，第三刀伤害和冷却时间翻倍"],
            "addition": [],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提升4%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提升8%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“杀意”状态下,本技能有10%的概率使敌人获得“破甲”效果"
                },
                {
                    "layer": 9,
                    "value": "在“杀意”状态下,本技能有20%的概率使敌人获得“破甲”效果"
                },
                {
                    "layer": 10,
                    "value": "在“杀意”状态下,本技能有30%的概率使敌人获得“破甲”效果"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“杀意”状态下,本技能的第三刀有30%概率造成“断筋”效果,移动速度降低50%,持续3秒"
                },
                {
                    "layer": 14,
                    "value": "在“杀意”状态下,本技能的第三刀有60%概率造成“断筋”效果,移动速度降低50%,持续3秒"
                },
                {
                    "layer": 15,
                    "value": "在“杀意”状态下,本技能的第三刀有100%概率造成“断筋”效果,移动速度降低50%,持续3秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高6%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高12%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "成功施放本技能获得的战意值提高10%"
                },
                {
                    "layer": 4,
                    "value": "成功施放本技能获得的战意值提高30%"
                },
                {
                    "layer": 5,
                    "value": "成功施放本技能获得的战意值提高50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“道意”状态下,本技能有5%的概率对目标造成“削弱”效果,持续3秒"
                },
                {
                    "layer": 9,
                    "value": "在“道意”状态下,本技能有10%的概率对目标造成“削弱”效果,持续3秒"
                },
                {
                    "layer": 10,
                    "value": "在“道意”状态下,本技能有15%的概率对目标造成“削弱”效果,持续3秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“道意”状态下,本技能有10%的概率使不动山的冷却时间减少1秒"
                },
                {
                    "layer": 14,
                    "value": "在“道意”状态下,本技能有20%的概率使不动山的冷却时间减少1秒"
                },
                {
                    "layer": 15,
                    "value": "在“道意”状态下,本技能有30%的概率使不动山的冷却时间减少1秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "狂杀",
        "skillProperty": ["物理攻击", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_8a064846-d02d-4a64-a74a-8a942dc2ed33_1304",
        "skillDescribe": {
            "main": "拔起双刀向前方挥舞，最多可连续<em class='green'>7</em>次",
            "static": ["每次使用会发动狂杀追击，每一击造成一定的物理伤害", "最后一击造成大量伤害"],
            "addition": [{
                "initiative": "每次挥砍击中敌方，自身有<em class='green'>50%</em>概率获得破伤效果，持续<em class='green'>10</em>秒，最多可叠加<em class='green'>5</em>层",
                "passivity": "破伤：每层破伤状态提升5%攻击力"
            },
            {
                "initiative": "最后一击使敌方获得击倒状态<em class='green'>3</em>秒",
                "passivity": "击倒：自身倒地，无法移动和释放技能"
            }],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "造成的“破伤”状态持续时间延长5秒（包括自身其他技能产生的“破伤”效果）"
                },
                {
                    "layer": 9,
                    "value": "造成的“破伤”状态持续时间延长10秒（包括自身其他技能产生的“破伤”效果）"
                },
                {
                    "layer": 10,
                    "value": "造成的“破伤”状态持续时间延长15秒（包括自身其他技能产生的“破伤”效果）"
                }],
                "require": {
                    "books": "中级狂杀卷一*杀",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "狂杀攻击的次数减少1次"
                },
                {
                    "layer": 9,
                    "value": "狂杀攻击的次数减少2次"
                },
                {
                    "layer": 10,
                    "value": "狂杀攻击的次数减少3次"
                }],
                "require": {
                    "books": "中级狂杀卷二*杀",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“杀意”状态下,本技能造成的“破伤”效果概率提高为75%"
                },
                {
                    "layer": 14,
                    "value": "在“杀意”状态下,本技能造成的“破伤”效果概率提高为100%"
                }],
                "require": {
                    "books": "高级狂杀卷二*杀",
                    "preNum": 3,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "在“道意”状态下,本技能每次攻击都有10%概率造成目标“削弱”效果,持续5秒"
                },
                {
                    "layer": 4,
                    "value": "在“道意”状态下,本技能每次攻击都有20%概率造成目标“削弱”效果,持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“道意”状态下,本技能每次击中敌人不再获得“破伤”状态,有50%概率使自身获得“剑道”状态,最多叠加2层"
                },
                {
                    "layer": 9,
                    "value": "在“道意”状态下,本技能每次击中敌人不再获得“破伤”状态,有75%概率使自身获得“剑道”状态,最多叠加2层"
                },
                {
                    "layer": 10,
                    "value": "在“道意”状态下,本技能每次击中敌人不再获得“破伤”状态,有100%概率使自身获得“剑道”状态,最多叠加2层"
                }],
                "require": {
                    "books": "中级狂杀卷一*道",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "狂杀攻击的次数增加1次（学习了中级狂杀卷二*杀则无效）"
                },
                {
                    "layer": 14,
                    "value": "狂杀攻击的次数增加2次（学习了中级狂杀卷二*杀则无效）"
                },
                {
                    "layer": 15,
                    "value": "狂杀攻击的次数增加3次（学习了中级狂杀卷二*杀则无效）"
                }],
                "require": {
                    "preNum": 3,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能每次使用都立即恢复自身0.5点轻功值"
                },
                {
                    "layer": 4,
                    "value": "本技能每次使用都立即恢复自身1点轻功值"
                },
                {
                    "layer": 5,
                    "value": "本技能每次使用都立即恢复自身1.5点轻功值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "道意状态下，每次攻击有30%的概率随机封印目标1个技能，最多封印10个技能。持续3秒"
                },
                {
                    "layer": 14,
                    "value": "道意状态下，每次攻击有60%的概率随机封印目标1个技能，最多封印10个技能。持续3秒"
                },
                {
                    "layer": 15,
                    "value": "道意状态下，每次攻击有100%的概率随机封印目标1个技能，最多封印10个技能。持续3秒"
                }],
                "require": {
                    "books": "中级狂杀卷二*道",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}]]
        }
    },
    {
        "skillName": "斩青云",
        "skillProperty": ["物理攻击", "引导技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a06db556-dea4-4231-a1ab-08d916f25521_1313",
        "skillDescribe": {
            "main": "<em class='green'>1.7</em>秒内持续对自身周围敌方造成伤害",
            "static": ["每0.5秒对周围敌方造成一次伤害"],
            "addition": [{
                "initiative": "每次伤害<em class='green'>20%</em>概率自身进入剑道状态，持续<em class='green'>10</em>秒，最多可叠加<em class='green'>2</em>层",
                "passivity": "剑道：每层提高160点格挡"
            }],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "对自己赋予“破甲”的敌人造成的伤害增加10%"
                },
                {
                    "layer": 9,
                    "value": "对自己赋予“破甲”的敌人造成的伤害增加20%"
                },
                {
                    "layer": 10,
                    "value": "对自己赋予“破甲”的敌人造成的伤害增加30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "对“击倒”的敌人造成的伤害增加20%"
                },
                {
                    "layer": 14,
                    "value": "对“击倒”的敌人造成的伤害增加30%"
                },
                {
                    "layer": 15,
                    "value": "对“击倒”的敌人造成的伤害增加40%"
                }],
                "require": {
                    "books": "高级斩青云卷一*杀",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成“剑道”状态的概率提高至30%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成“剑道”状态的概率提高至40%"
                },
                {
                    "layer": 5,
                    "value": "本技能造成“剑道”状态的概率提高至50%"
                }],
                "require": {
                    "books": "初级斩青云卷一*道",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "造成的“剑道”状态增加的格挡提高10%"
                },
                {
                    "layer": 9,
                    "value": "造成的“剑道”状态增加的格挡提高20%"
                },
                {
                    "layer": 10,
                    "value": "造成的“剑道”状态增加的格挡提高30%"
                }],
                "require": {
                    "books": "中级斩青云卷一*道",
                    "preNum": 3,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "造成的“剑道”状态最多可叠加3层"
                },
                {
                    "layer": 14,
                    "value": "造成的“剑道”状态最多可叠加4层"
                },
                {
                    "layer": 15,
                    "value": "造成的“剑道”状态最多可叠加5层"
                }],
                "require": {
                    "books": "高级斩青云卷一*道",
                    "preNum": 3,
                    "totolNum": 6,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "施放本技能期间,自身受到的伤害降低3%"
                },
                {
                    "layer": 4,
                    "value": "施放本技能期间,自身受到的伤害降低6%"
                },
                {
                    "layer": 5,
                    "value": "施放本技能期间,自身受到的伤害降低9%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“道意”状态下,本技能每次攻击有10%概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
                },
                {
                    "layer": 14,
                    "value": "在“道意”状态下,本技能每次攻击有20%概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
                },
                {
                    "layer": 15,
                    "value": "在“道意”状态下,本技能每次攻击有30%概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
                }],
                "require": {
                    "books": "高级斩青云卷二*道",
                    "preNum": 0,
                    "totolNum": 6,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "战意诀",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_5e2006cd-66de-40fe-a660-04a0b307c413_1303",
        "skillDescribe": {
            "main": "战斗的过程中会增加战意值，使用后释放聚集的全部战意，强化自身",
            "static": ["杀意：获得战意*杀状态，提升暴击力", "道意：获得战意*道状态，提升格挡力"],
            "addition": [{
                "initiative": "释放杀意可以获得战意*杀状态，持续<em class='green'>30</em>秒",
                "passivity": "提升0.5*战意点的暴击力"
            },
            {
                "initiative": "释放道意可以获得战意*道状态，持续<em class='green'>30</em>秒",
                "passivity": "提升0.5*战意点的格挡力"
            }],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "“杀意”状态下,自身受到的治疗效果提高10%"
                },
                {
                    "layer": 4,
                    "value": "“杀意”状态下,自身受到的治疗效果提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“杀意”状态下,每次对敌人造成暴击伤害可以使自身获得“无情”状态,自身的物理破防率增加1.6%,持续10秒,最多可叠加2层,该效果每秒最多触发一次"
                },
                {
                    "layer": 9,
                    "value": "在“杀意”状态下,每次对敌人造成暴击伤害可以使自身获得“无情”状态,自身的物理破防率增加1.6%,持续10秒,最多可叠加3层,该效果每秒最多触发一次"
                },
                {
                    "layer": 10,
                    "value": "在“杀意”状态下,每次对敌人造成暴击伤害可以使自身获得“无情”状态,自身的物理破防率增加1.6%,持续10秒,最多可叠加5层,该效果每秒最多触发一次"
                }],
                "require": {
                    "books": "中级战意卷一*杀",
                    "preNum": 2,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“杀意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
                },
                {
                    "layer": 14,
                    "value": "“杀意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
                },
                {
                    "layer": 15,
                    "value": "“杀意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
                }],
                "require": {
                    "preNum": 3,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "在“杀意”状态下,自身对的怪物伤害增加1%"
                },
                {
                    "layer": 4,
                    "value": "在“杀意”状态下,自身对的怪物伤害增加2%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "战意值上限提高10%"
                },
                {
                    "layer": 4,
                    "value": "战意值上限提高15%"
                },
                {
                    "layer": 5,
                    "value": "战意值上限提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "“道意”状态下,自身受到的治疗效果提高10%"
                },
                {
                    "layer": 4,
                    "value": "“道意”状态下,自身受到的治疗效果提高20%"
                }],
                "require": {
                    "books": "初级战意卷一*道",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“道意”状态下,每30秒内成功格挡敌人一次伤害可以使自身获得“无念”状态,自身的防御力提高5%,持续10秒"
                },
                {
                    "layer": 9,
                    "value": "在“道意”状态下,每30秒内成功格挡敌人一次伤害可以使自身获得“无念”状态,自身的防御力提高5%,持续20秒"
                },
                {
                    "layer": 10,
                    "value": "在“道意”状态下,每30秒内成功格挡敌人一次伤害可以使自身获得“无念”状态,自身的防御力提高5%,持续35秒"
                }],
                "require": {
                    "books": "中级战意卷一*道",
                    "preNum": 2,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“道意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
                },
                {
                    "layer": 14,
                    "value": "“道意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
                },
                {
                    "layer": 15,
                    "value": "“道意”状态下,每次技能对敌人造成暴击伤害则立即回复自身1.5%生命上限,该效果每10秒最多触发一次"
                }],
                "require": {
                    "preNum": 3,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "在“道意”状态下,自身受到的怪物伤害降低1%"
                },
                {
                    "layer": 4,
                    "value": "在“道意”状态下,自身受到的怪物伤害降低1%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "破空斩",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_bfcee7d6-c032-4af7-8367-69fadc1cb4ec_1319",
        "skillDescribe": {
            "main": "向前方释放一道剑气，对所有敌方造成伤害",
            "static": ["对前方直线范围内敌方造成物理伤害"],
            "addition": [{
                "initiative": "<em class='green'>20%</em>概率使敌方进入削弱状态，持续<em class='green'>5</em>秒，最多可叠加<em class='green'>3</em>层",
                "passivity": "削弱：每层降低5%的攻击力"
            }],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对处于“破甲”的敌人造成伤害提高8%"
                },
                {
                    "layer": 9,
                    "value": "本技能对处于“破甲”的敌人造成伤害提高16%"
                },
                {
                    "layer": 10,
                    "value": "本技能对处于“破甲”的敌人造成伤害提高25%"
                }],
                "require": {
                    "books": "中级破空斩卷一*杀",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "使用本技能后,则立即增长自身1点问情系无双值"
                },
                {
                    "layer": 14,
                    "value": "使用本技能后,则立即增长自身2点问情系无双值"
                }],
                "require": {
                    "books": "高级破空斩卷一*杀",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高10%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“杀意”状态下,本技能对处于10米外的敌人造成伤害提高10%"
                },
                {
                    "layer": 9,
                    "value": "在“杀意”状态下,本技能对处于10米外的敌人造成伤害提高20%"
                },
                {
                    "layer": 10,
                    "value": "在“杀意”状态下,本技能对处于10米外的敌人造成伤害提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低0.5秒"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低1秒"
                }],
                "require": {
                    "books": "中级破空斩卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的“削弱”效果的概率提高为30%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的“削弱”效果的概率提高为40%"
                },
                {
                    "layer": 5,
                    "value": "本技能造成的“削弱”效果的概率提高为50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能造成的“削弱”效果最多可叠加4层（包括自身其他技能产生的“削弱”效果）"
                },
                {
                    "layer": 9,
                    "value": "技能造成的“削弱”效果最多可叠加5层（包括自身其他技能产生的“削弱”效果）"
                }],
                "require": {
                    "books": "中级破空斩卷一*道",
                    "preNum": 3,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "技能造成的“削弱”效果持续时间提高3秒（包括自身其他技能产生的“削弱”效果）"
                },
                {
                    "layer": 14,
                    "value": "技能造成的“削弱”效果持续时间提高5秒（包括自身其他技能产生的“削弱”效果）"
                },
                {
                    "layer": 15,
                    "value": "技能造成的“削弱”效果持续时间提高7秒（包括自身其他技能产生的“削弱”效果）"
                }],
                "require": {
                    "books": "高级破空斩卷一*道",
                    "preNum": 2,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "成功施放本技能获得的战意值提高10%"
                },
                {
                    "layer": 4,
                    "value": "成功施放本技能获得的战意值提高30%"
                },
                {
                    "layer": 5,
                    "value": "成功施放本技能获得的战意值提高50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "破影",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_6228614a-5359-4792-90d2-be484691fa6e_1316",
        "skillDescribe": {
            "main": "连续按键对前方发动攻击，最多发动<em class='green'>4</em>次攻击",
            "static": ["每次按键对敌方造成一定的物理伤害"],
            "addition": [{
                "initiative": "造成破甲效果，持续<em class='green'>10</em>秒，最多可叠加<em class='green'>5</em>层",
                "passivity": "破甲：每层降低206点物理防御力"
            }],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "自身处于“破伤”时破影造成伤害提高8%"
                },
                {
                    "layer": 9,
                    "value": "自身处于“破伤”时破影造成伤害提高16%"
                },
                {
                    "layer": 10,
                    "value": "自身处于“破伤”时破影造成伤害提高25%"
                }],
                "require": {
                    "books": "中级破影卷一*杀",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“杀意”状态下,每次攻击有50%概率随机封印目标1个技能,持续3秒"
                },
                {
                    "layer": 14,
                    "value": "在“杀意”状态下,每次攻击有50%概率随机封印目标2个技能,持续3秒"
                },
                {
                    "layer": 15,
                    "value": "在“杀意”状态下,每次攻击有50%概率随机封印目标3个技能,持续3秒"
                }],
                "require": {
                    "books": "高级破影卷一*杀",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "自身每1层“破伤”额外提升本技能5%的伤害"
                },
                {
                    "layer": 14,
                    "value": "自身每1层“破伤”额外提升本技能10%的伤害"
                }],
                "require": {
                    "books": "高级破影卷二*杀",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "books": "中级破影卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的“破甲”状态持续时间延长5秒（包括自身其他技能产生的“破甲”效果）"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的“破甲”状态持续时间延长10秒（包括自身其他技能产生的“破甲”效果）"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "造成的“破甲”状态降低的物理防御力提高6%（包括自身其他技能产生的“破甲”效果）"
                },
                {
                    "layer": 9,
                    "value": "造成的“破甲”状态降低的物理防御力提高12%（包括自身其他技能产生的“破甲”效果）"
                },
                {
                    "layer": 10,
                    "value": "造成的“破甲”状态降低的物理防御力提高20%（包括自身其他技能产生的“破甲”效果）"
                }],
                "require": {
                    "books": "中级破影卷一*道",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“道意”状态下,本技能每次攻击都有15%的概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
                },
                {
                    "layer": 14,
                    "value": "在“道意”状态下,本技能每次攻击都有30%的概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
                },
                {
                    "layer": 15,
                    "value": "在“道意”状态下,本技能每次攻击都有50%的概率对敌人造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
                }],
                "require": {
                    "books": "高级破影卷一*道",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能施放后,使自身获得“风行”状态,移动速度提高20%,持续3秒"
                },
                {
                    "layer": 4,
                    "value": "本技能施放后,使自身获得“风行”状态,移动速度提高30%,持续3秒"
                },
                {
                    "layer": 5,
                    "value": "本技能施放后,使自身获得“风行”状态,移动速度提高40%,持续3秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "追命",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_37ecb19a-7823-4c4c-b228-d2b0817300db_1302",
        "skillDescribe": {
            "main": "冲向目标，对前方的敌方造成伤害",
            "static": ["冲向目标位置", "<em class='green'>2</em>秒内再次按键可向前方区域拔刀挥砍，对敌方造成物理伤害并击飞<em class='green'>3</em>米"],
            "addition": [{
                "initiative": "受击单位获得定身状态<em class='green'>1</em>秒",
                "passivity": "定身：无法移动和使用轻功"
            }],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提升10%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提升20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "冲向目标后,有30%概率对目标造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
                },
                {
                    "layer": 9,
                    "value": "冲向目标后,有60%概率对目标造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
                },
                {
                    "layer": 10,
                    "value": "冲向目标后,有100%概率对目标造成“迟钝”效果,移动速度降低50%,无法使用轻功,持续3秒"
                }],
                "require": {
                    "books": "中级追命卷一*杀",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能的最远射程提高1米"
                },
                {
                    "layer": 14,
                    "value": "本技能的最远射程提高2米"
                },
                {
                    "layer": 15,
                    "value": "本技能的最远射程提高3米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“杀意”状态下,本技能施放后,自身获得霸体效果,持续1秒"
                },
                {
                    "layer": 14,
                    "value": "在“杀意”状态下,本技能施放后,自身获得霸体效果,持续2秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "books": "中级追命卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能有50%的概率迫使怪物5秒内强制攻击自己"
                },
                {
                    "layer": 4,
                    "value": "本技能有100%的概率迫使怪物5秒内强制攻击自己"
                }],
                "require": {
                    "books": "初级追命卷一*道",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“道意”状态下,冲向目标后,立即打断目标技能吟唱和引导,并随机封印目标1个技能,持续3秒"
                },
                {
                    "layer": 9,
                    "value": "在“道意”状态下,冲向目标后,立即打断目标技能吟唱和引导,并随机封印目标2个技能,持续3秒"
                },
                {
                    "layer": 10,
                    "value": "在“道意”状态下,冲向目标后,立即打断目标技能吟唱和引导,并随机封印目标3个技能,持续3秒"
                }],
                "require": {
                    "books": "中级追命卷一*道",
                    "preNum": 0,
                    "totolNum": 1,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“道意”状态下,追命二斩的攻击范围增加3米"
                },
                {
                    "layer": 14,
                    "value": "在“道意”状态下,追命二斩的攻击范围增加6米"
                }],
                "require": {
                    "books": "高级追命卷一*道",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "不动山",
        "skillProperty": ["物理技能", "引导技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9e836662-764c-4954-8aac-adbf84564b5b_1314",
        "skillDescribe": {
            "main": "进入格挡状态，持续<em class='green'>2</em>秒，免疫控制",
            "static": ["按键后进入不动山姿态，格挡伤害，主动使用闪避可取消"],
            "addition": [{
                "initiative": "自身进入<em class='green'>不动山</em>姿态",
                "passivity": "不动山：免疫控制，对所有受到的伤害造成格挡效果，自身的格挡加成提高"
            }],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "格挡姿态下,再次按键可立即向前方发动反击,造成敌人86%基础物理攻击力的物理伤害"
                },
                {
                    "layer": 4,
                    "value": "格挡姿态下,再次按键可立即向前方发动反击,造成敌人172%基础物理攻击力的物理伤害"
                },
                {
                    "layer": 5,
                    "value": "格挡姿态下,再次按键可立即向前方发动反击,造成敌人258%基础物理攻击力的物理伤害"
                }],
                "require": {
                    "books": "初级不动山卷一*杀",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "反击造成的伤害10%立即转化为自己的生命上限，最多回复自身总血量10%的生命上限"
                },
                {
                    "layer": 9,
                    "value": "反击造成的伤害10%立即转化为自己的生命上限，最多回复自身总血量20%的生命上限"
                },
                {
                    "layer": 10,
                    "value": "反击造成的伤害10%立即转化为自己的生命上限，最多回复自身总血量30%的生命上限"
                }],
                "require": {
                    "books": "中级不动山卷一*杀",
                    "preNum": 3,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "反击有20%概率将敌人击倒3秒"
                },
                {
                    "layer": 14,
                    "value": "反击有40%概率将敌人击倒3秒"
                }],
                "require": {
                    "books": "高级不动山卷一*杀",
                    "preNum": 3,
                    "totolNum": 6,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级不动山卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "格挡姿态的持续时间增加0.5秒"
                },
                {
                    "layer": 4,
                    "value": "格挡姿态的持续时间增加1秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "该技能的格挡加成效果额外提升8%"
                },
                {
                    "layer": 9,
                    "value": "该技能的格挡加成效果额外提升16%"
                },
                {
                    "layer": 10,
                    "value": "该技能的格挡加成效果额外提升25%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "当自身生命上限低于30%时,该技能的格挡加成效果额外提升15%"
                },
                {
                    "layer": 14,
                    "value": "当自身生命上限低于30%时,该技能的格挡加成效果额外提升30%"
                }],
                "require": {
                    "books": "高级不动山卷一*道",
                    "preNum": 3,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "格挡姿态下,每次成功格挡敌人伤害会使自身获得3%的生命上限,该效果每5秒最多触发一次"
                },
                {
                    "layer": 14,
                    "value": "格挡姿态下,每次成功格挡敌人伤害会使自身获得6%的生命上限,该效果每5秒最多触发一次"
                }],
                "require": {
                    "books": "高级不动山卷二*道",
                    "preNum": 0,
                    "totolNum": 5,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "定风波",
        "skillProperty": ["物理技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_c82680df-39f5-4229-86b8-910c8c5d30ac_1311",
        "skillDescribe": {
            "main": "<em class='green'>击倒</em>前方区域的所有敌方并造成伤害",
            "static": ["击倒前方直线敌方并造成物理伤害"],
            "addition": [{
                "initiative": "敌方获得击倒状态<em class='green'>3</em>秒",
                "passivity": "击倒：无法移动和使用技能、轻功"
            }],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "在“杀意”状态下,2秒内再次按键可施放定风波二斩,向前跳跃5米,对前方所有敌人造成60%基础物理攻击力的物理伤害"
                },
                {
                    "layer": 4,
                    "value": "在“杀意”状态下,2秒内再次按键可施放定风波二斩,向前跳跃5米,对前方所有敌人造成120%基础物理攻击力的物理伤害"
                },
                {
                    "layer": 5,
                    "value": "在“杀意”状态下,2秒内再次按键可施放定风波二斩,向前跳跃5米,对前方所有敌人造成180%基础物理攻击力的物理伤害"
                }],
                "require": {
                    "books": "初级定风波卷一*杀",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "定风波二斩造成的伤害提高20%"
                },
                {
                    "layer": 9,
                    "value": "定风波二斩造成的伤害提高40%"
                }],
                "require": {
                    "preNum": 3,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "定风波二斩对处于“击倒”状态的敌人造成的伤害提高30%"
                },
                {
                    "layer": 14,
                    "value": "定风波二斩对处于“击倒”状态的敌人造成的伤害提高60%"
                }],
                "require": {
                    "preNum": 2,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "定风波二斩可以在自身处于被控制状态施放,并解除自身的受控制状态"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "books": "高级不动山卷二*杀",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级定风波卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "降低定风波0.5秒的吟唱时间"
                }],
                "require": {
                    "books": "高级定风波卷一*悟",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能的控制等级增加10点"
                },
                {
                    "layer": 4,
                    "value": "本技能的控制等级增加20点"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“道意”状态下,本技能对怪物造成的物理伤害额外提高25%,并造成大量仇恨"
                },
                {
                    "layer": 9,
                    "value": "在“道意”状态下,本技能对怪物造成的物理伤害额外提高50%,并造成大量仇恨"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“道意”状态下,本技能有50%概率立即重置追命的冷却时间"
                },
                {
                    "layer": 14,
                    "value": "在“道意”状态下,本技能有75%概率立即重置追命的冷却时间"
                },
                {
                    "layer": 15,
                    "value": "在“道意”状态下,本技能有100%概率立即重置追命的冷却时间"
                }],
                "require": {
                    "books": "高级定风波卷一*道",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "破月",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9d623569-3504-4a33-9268-9f5b2b9b030e_1312",
        "skillDescribe": {
            "main": "解除控制效果并进入<em class='green'>霸体</em>状态，持续<em class='green'>3</em>秒，并对前方敌方并造成伤害",
            "static": ["解除自身控制状态", "对前方敌方造成物理伤害"],
            "addition": [{
                "initiative": "自身进入<em class='green'>霸体</em>状态<em class='green'>3</em>秒",
                "passivity": "霸体：免疫所有控制效果"
            }],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "对被击中的敌人造成“迟钝”效果，降低50%的移动速度，无法使用轻功，持续3秒"
                },
                {
                    "layer": 4,
                    "value": "对被击中的敌人造成“迟钝”效果，降低50%的移动速度，无法使用轻功，持续5秒"
                }],
                "require": {
                    "books": "初级破月卷一*杀",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“霸体”状态下,自身的物理攻击力提高5%"
                },
                {
                    "layer": 9,
                    "value": "“霸体”状态下,自身的物理攻击力提高10%"
                },
                {
                    "layer": 10,
                    "value": "“霸体”状态下,自身的物理攻击力提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能产生的“霸体”状态持续时间增加0.5秒"
                },
                {
                    "layer": 14,
                    "value": "本技能产生的“霸体”状态持续时间增加1秒"
                },
                {
                    "layer": 15,
                    "value": "本技能产生的“霸体”状态持续时间增加1.5秒"
                }],
                "require": {
                    "books": "高级破月卷一*杀",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级破月卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "“霸体”状态下,自身的移动速度提高15%"
                },
                {
                    "layer": 4,
                    "value": "“霸体”状态下,自身的移动速度提高30%"
                },
                {
                    "layer": 5,
                    "value": "“霸体”状态下,自身的移动速度提高50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“霸体”状态下,自身的物理和法术防御力提高5%"
                },
                {
                    "layer": 9,
                    "value": "“霸体”状态下,自身的物理和法术防御力提高10%"
                },
                {
                    "layer": 10,
                    "value": "“霸体”状态下,自身的物理和法术防御力提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“道意”状态下,本技能可解除自身所有不良状态"
                }],
                "require": {
                    "books": "高级破月卷一*道",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "猎光",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_dde85a40-9924-424c-a7e0-0dc7b657239b_1305",
        "skillDescribe": {
            "main": "对区域内所有敌方造成大量物理伤害",
            "static": ["对前方区域敌方造成极大量物理伤害"],
            "addition": [],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的物理伤害可忽视敌人8%的物理防御力"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的物理伤害可忽视敌人16%的物理防御力"
                },
                {
                    "layer": 10,
                    "value": "本技能造成的物理伤害可忽视敌人25%的物理防御力"
                }],
                "require": {
                    "books": "中级猎光卷一*杀",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "当敌人的生命上限低于50%时,本技能造成的物理伤害额外提高20%"
                },
                {
                    "layer": 14,
                    "value": "当敌人的生命上限低于50%时,本技能造成的物理伤害额外提高30%"
                },
                {
                    "layer": 15,
                    "value": "当敌人的生命上限低于50%时,本技能造成的物理伤害额外提高40%"
                }],
                "require": {
                    "books": "高级猎光卷一*杀",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "books": "中级猎光卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能立即驱散目标1个正面状态"
                },
                {
                    "layer": 4,
                    "value": "本技能立即驱散目标2个正面状态"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "道意状态下，本技能成功驱散目标状态后立即回复自身30×技能等级×驱散状态数的生命上限"
                },
                {
                    "layer": 9,
                    "value": "道意状态下，本技能成功驱散目标状态后立即回复自身60×技能等级×驱散状态数的生命上限"
                },
                {
                    "layer": 10,
                    "value": "道意状态下，本技能成功驱散目标状态后立即回复自身90×技能等级×驱散状态数的生命上限"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“道意”状态下,本技能立即增加3点问道系无双值"
                },
                {
                    "layer": 14,
                    "value": "在“道意”状态下,本技能立即增加5点问道系无双值"
                },
                {
                    "layer": 15,
                    "value": "在“道意”状态下,本技能立即增加7点问道系无双值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "在“道意”状态下,本技能对怪物造成仇恨提高100%"
                },
                {
                    "layer": 4,
                    "value": "在“道意”状态下,本技能对怪物造成仇恨提高200%"
                },
                {
                    "layer": 5,
                    "value": "在“道意”状态下,本技能对怪物造成仇恨提高300%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "血绽诀",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_e6adde71-6f5c-4a1a-972c-045df5bb0e95_1306",
        "skillDescribe": {
            "main": "进入血绽状态，免疫一切控制和状态，持续<em class='green'>5</em>秒",
            "static": ["解除自身控制状态", "生命值降为1，同时战意值增加到上限"],
            "addition": [{
                "initiative": "自身进入<em class='green'>血绽</em>状态",
                "passivity": "血绽：免疫所有伤害和控制效果，且每次伤害回复自身造成伤害值20%生命值，最多回复相当于自身总血量50%的生命值"
            }],
            "trainingName": ["弑", "悟", "道"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "“血绽”状态下,自身的移动速度提高30%"
                },
                {
                    "layer": 4,
                    "value": "“血绽”状态下,自身的移动速度提高60%"
                },
                {
                    "layer": 5,
                    "value": "“血绽”状态下,自身的移动速度提高100%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能使用后,立即使所有技能冷却时间减少10%"
                },
                {
                    "layer": 9,
                    "value": "技能使用后,立即使所有技能冷却时间减少20%"
                },
                {
                    "layer": 10,
                    "value": "技能使用后,立即使所有技能冷却时间减少30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "技能使用后,立即增加两系无双各3点"
                },
                {
                    "layer": 14,
                    "value": "技能使用后,立即增加两系无双各6点"
                },
                {
                    "layer": 15,
                    "value": "技能使用后,立即增加两系无双各10点"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "“血绽”状态下,自身受到的治疗效果提高10%"
                },
                {
                    "layer": 4,
                    "value": "“血绽”状态下,自身受到的治疗效果提高20%"
                },
                {
                    "layer": 5,
                    "value": "“血绽”状态下,自身受到的治疗效果提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能使用后,使周围30米范围内的所有队友获得4%的吸血效果,持续5秒"
                },
                {
                    "layer": 9,
                    "value": "技能使用后,使周围30米范围内的所有队友获得8%的吸血效果,持续5秒"
                },
                {
                    "layer": 10,
                    "value": "技能使用后,使周围30米范围内的所有队友获得12%的吸血效果,持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“血绽”状态的持续时间增加1秒"
                },
                {
                    "layer": 14,
                    "value": "“血绽”状态的持续时间增加2秒"
                }],
                "require": {
                    "books": "高级血绽诀卷一*道",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“血绽”状态下，自身对怪物造成的伤害提高25%"
                },
                {
                    "layer": 9,
                    "value": "在“血绽”状态下，自身对怪物造成的伤害提高50%"
                }],
                "require": {
                    "books": "中级血绽诀卷二*道",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}]]
        }
    }],
    "yantian": [{
        "skillName": "疾风弹",
        "skillProperty": ["物理攻击", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_6cdcfdaf-09f3-41c1-a19d-0591a6aad023_1501",
        "skillDescribe": {
            "main": "对敌方单体造成少量伤害",
            "static": ["对敌方单体造成少量的物理伤害", "狙杀模式下<em class='green'>20%</em>概率对与自身距离20米以上敌方造成双倍伤害"],
            "addition": [],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提升4%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提升8%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "当目标处于“流血”状态时,本技能造成的伤害额外提高7%"
                },
                {
                    "layer": 9,
                    "value": "当目标处于“流血”状态时,本技能造成的伤害额外提高14%"
                },
                {
                    "layer": 10,
                    "value": "当目标处于“流血”状态时,本技能造成的伤害额外提高20%"
                }],
                "require": {
                    "books": "中级疾风弹卷一*炎",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "狙杀模式下,造成双倍伤害的概率提高至28%"
                },
                {
                    "layer": 14,
                    "value": "狙杀模式下,造成双倍伤害的概率提高至36%"
                },
                {
                    "layer": 15,
                    "value": "狙杀模式下,造成双倍伤害的概率提高至45%"
                }],
                "require": {
                    "books": "高级疾风弹卷一*炎",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高6%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高12%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "当目标处于“弱疗”状态时,本技能造成的伤害额外提高5%"
                },
                {
                    "layer": 4,
                    "value": "当目标处于“弱疗”状态时,本技能造成的伤害额外提高10%"
                },
                {
                    "layer": 5,
                    "value": "当目标处于“弱疗”状态时,本技能造成的伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对目标造成暴击伤害后,立即恢复自身2点轻功值"
                },
                {
                    "layer": 9,
                    "value": "本技能对目标造成暴击伤害后,立即恢复自身4点轻功值"
                },
                {
                    "layer": 10,
                    "value": "本技能对目标造成暴击伤害后,立即恢复自身6点轻功值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对目标造成伤害后有20%概率立即扣除目标2点轻功值"
                },
                {
                    "layer": 14,
                    "value": "本技能对目标造成伤害后有20%概率立即扣除目标4点轻功值"
                },
                {
                    "layer": 15,
                    "value": "本技能对目标造成伤害后有20%概率立即扣除目标6点轻功值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "震荡弹",
        "skillProperty": ["物理攻击", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_0f6c166d-b8e3-4521-b9de-2a8bd8b09c01_1503",
        "skillDescribe": {
            "main": "对敌方单体造成伤害",
            "static": ["对敌方单体造成一定的物理伤害", "狙杀模式时，额外附带一个流血效果"],
            "addition": [{
                "initiative": "狙杀模式时对目标造成流血效果，持续6秒",
                "passivity": "流血：每2秒造成15.2%基础物理攻击的伤害"
            }],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "狙杀模式下,本技能造成的“流血”效果伤害提高15%"
                },
                {
                    "layer": 9,
                    "value": "狙杀模式下,本技能造成的“流血”效果伤害提高30%"
                },
                {
                    "layer": 10,
                    "value": "狙杀模式下,本技能造成的“流血”效果伤害提高45%"
                }],
                "require": {
                    "books": "中级震荡弹卷一*炎",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "狙杀模式下,本技能造成的“流血”效果最多可叠加2层"
                },
                {
                    "layer": 14,
                    "value": "狙杀模式下,本技能造成的“流血”效果最多可叠加3层"
                }],
                "require": {
                    "books": "高级震荡弹卷一*炎",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "狙杀模式下,本技能造成的“流血”效果持续时间提高2秒"
                },
                {
                    "layer": 14,
                    "value": "狙杀模式下,本技能造成的“流血”效果持续时间提高4秒"
                }],
                "require": {
                    "books": "高级震荡弹卷二*炎",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能有50%概率对处于“死亡标记”的目标造成“断筋”效果,移动速度降低50%,持续3秒"
                },
                {
                    "layer": 4,
                    "value": "本技能有75%概率对处于“死亡标记”的目标造成“断筋”效果,移动速度降低50%,持续4秒"
                },
                {
                    "layer": 5,
                    "value": "本技能有100%概率对处于“死亡标记”的目标造成“断筋”效果,移动速度降低50%,持续5秒"
                }],
                "require": {
                    "books": "初级震荡弹卷一*钢",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能有15%的概率立即打断目标吟唱或者引导"
                },
                {
                    "layer": 9,
                    "value": "本技能有30%的概率立即打断目标吟唱或者引导"
                },
                {
                    "layer": 10,
                    "value": "本技能有50%的概率立即打断目标吟唱或者引导"
                }],
                "require": {
                    "books": "中级震荡弹卷一*钢",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能有50%概率随机封印目标1个技能,持续3秒"
                },
                {
                    "layer": 14,
                    "value": "本技能有100%概率随机封印目标1个技能,持续3秒"
                },
                {
                    "layer": 15,
                    "value": "本技能有100%概率随机封印目标2个技能,持续3秒"
                }],
                "require": {
                    "books": "高级震荡弹卷一*钢",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "震地雷",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_08bb8224-7677-4c3a-b18d-f1f1bb69cd4c_1512",
        "skillDescribe": {
            "main": "朝目标位置丢掷手雷，将目标及周围的敌方击倒并造成伤害",
            "static": ["对目标及周围敌方造成基于物理攻击百分比的火系伤害"],
            "addition": [{
                "initiative": "将敌方<em class='green'>击倒</em>，持续<em class='green'>3</em>秒",
                "passivity": "击倒：无法移动、使用轻功和技能"
            }],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的法术伤害提升13%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的法术伤害提升26%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的法术伤害额外提高50%,但无法击倒敌人"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的法术伤害额外提高100%,但无法击倒敌人"
                }],
                "require": {
                    "books": "中级震地雷卷一*炎",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "震地雷忽视敌人12%的法术防御力"
                },
                {
                    "layer": 14,
                    "value": "震地雷忽视敌人25%的法术防御力"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的法术伤害额外提高20%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的法术伤害额外提高40%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能立即扣除敌人6点轻功值"
                },
                {
                    "layer": 4,
                    "value": "本技能立即扣除敌人12点轻功值"
                },
                {
                    "layer": 5,
                    "value": "本技能立即扣除敌人18点轻功值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能的最大射程提高3米"
                },
                {
                    "layer": 9,
                    "value": "本技能的最大射程提高5米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对敌人造成的“击倒”时间延长0.5秒（学习了中级震地雷卷一*炎则此效果失效）"
                },
                {
                    "layer": 14,
                    "value": "本技能对敌人造成的“击倒”时间延长1秒（学习了中级震地雷卷一*炎则此效果失效）"
                }],
                "require": {
                    "books": "高级震地雷卷一*钢",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能爆炸范围扩大2米"
                },
                {
                    "layer": 14,
                    "value": "本技能爆炸范围扩大4米"
                },
                {
                    "layer": 15,
                    "value": "本技能爆炸范围扩大6米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "黯灭弹",
        "skillProperty": ["物理技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9f72ecc6-6623-407c-82e4-273334415f4c_1504",
        "skillDescribe": {
            "main": "对敌方单体造成大量伤害",
            "static": ["造成大量物理伤害", "狙杀模式下该技能暴击力提高"],
            "addition": [],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的物理伤害可忽视敌人8%的物理防御力"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的物理伤害可忽视敌人16%的物理防御力"
                },
                {
                    "layer": 10,
                    "value": "本技能造成的物理伤害可忽视敌人25%的物理防御力"
                }],
                "require": {
                    "books": "中级黯灭弹卷一*炎",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对目标造成暴击伤害后,使自身获得“狂暴”效果,暴击加成力提高10%,持续5秒"
                },
                {
                    "layer": 14,
                    "value": "本技能对目标造成暴击伤害后,使自身获得“狂暴”效果,暴击加成力提高20%,持续5秒"
                },
                {
                    "layer": 15,
                    "value": "本技能对目标造成暴击伤害后,使自身获得“狂暴”效果,暴击加成力提高30%,持续5秒"
                }],
                "require": {
                    "books": "高级黯灭弹卷一*炎",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能有50%概率使目标造成“断筋”效果,移动速度降低50%,持续3秒"
                },
                {
                    "layer": 4,
                    "value": "本技能有50%概率使目标造成“断筋”效果,移动速度降低50%,持续4秒"
                },
                {
                    "layer": 5,
                    "value": "本技能有50%概率使目标造成“断筋”效果,移动速度降低50%,持续5秒"
                }],
                "require": {
                    "books": "初级黯灭弹卷一*钢",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能有50%的概率立即驱散目标1个正面状态"
                },
                {
                    "layer": 9,
                    "value": "本技能有100%的概率立即驱散目标1个正面状态"
                },
                {
                    "layer": 10,
                    "value": "本技能有100%的概率立即驱散目标1个正面状态,如果驱散成功则可以使自己获得“黯灭”状态，提升2%的物理攻击，最多可叠加5层。"
                }],
                "require": {
                    "books": "中级黯灭弹卷一*钢",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对目标造成造成“弱疗”效果,受到的治疗效果降低10%,持续5秒"
                },
                {
                    "layer": 14,
                    "value": "本技能对目标造成造成“弱疗”效果,受到的治疗效果降低20%,持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对目标造成暴击伤害后,使自身获得“风行”状态,移动速度提高30%,持续3秒"
                },
                {
                    "layer": 14,
                    "value": "本技能对目标造成暴击伤害后,使自身获得“风行”状态,移动速度提高50%,持续3秒"
                }],
                "require": {
                    "books": "高级黯灭弹卷二*钢",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "穿云弹",
        "skillProperty": ["物理技能", "引导技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_dad6fae4-f0b1-4cba-a501-59376c0906eb_1502",
        "skillDescribe": {
            "main": "<em class='green'>2.5</em>秒内持续对目标及周围敌方连续射击",
            "static": ["每2次射击造成一次物理伤害，最多可攻击目标及周围共<em class='green'>4</em>个目标", "狙杀模式下最多可攻击共<em class='green'>8</em>个目标"],
            "addition": [{
                "initiative": "是自己进入<em class='green'>物伤加深</em>状态，持续<em class='green'>5</em>秒",
                "passivity": "物伤加深：提升20%的物理伤害"
            }],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能在普通模式和狙杀模式下攻击到的目标各增加1个"
                },
                {
                    "layer": 9,
                    "value": "本技能在普通模式和狙杀模式下攻击到的目标各增加2个"
                },
                {
                    "layer": 10,
                    "value": "本技能在普通模式和狙杀模式下攻击到的目标各增加3个"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "狙杀模式下,本技能最后一击的暴击率提高30%"
                },
                {
                    "layer": 14,
                    "value": "狙杀模式下,本技能最后一击的暴击率提高60%"
                },
                {
                    "layer": 15,
                    "value": "狙杀模式下,本技能最后一击的暴击率提高90%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能持续期间内,获得“无惧”状态,自身的反控制等级提高25点"
                },
                {
                    "layer": 4,
                    "value": "本技能持续期间内,获得“无惧”状态,自身的反控制等级提高50点"
                },
                {
                    "layer": 5,
                    "value": "本技能持续期间内,获得“霸体”状态,免疫一切控制"
                }],
                "require": {
                    "books": "初级穿云弹卷一*钢",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "狙杀模式下,本技能每次攻击都都有20%的概率击退敌人2米"
                },
                {
                    "layer": 9,
                    "value": "狙杀模式下,本技能每次攻击都都有40%的概率击退敌人2米"
                },
                {
                    "layer": 10,
                    "value": "狙杀模式下,本技能每次攻击都都有60%的概率击退敌人2米"
                }],
                "require": {
                    "books": "中级穿云弹卷一*钢",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "狙杀模式下,本技能最后一击10%的概率击倒目标3秒"
                },
                {
                    "layer": 14,
                    "value": "狙杀模式下,本技能最后一击20%的概率击倒目标3秒"
                },
                {
                    "layer": 15,
                    "value": "狙杀模式下,本技能最后一击30%的概率击倒目标3秒"
                }],
                "require": {
                    "preNum": 3,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能最后一击对目标造成伤害后,立即减少螺旋刃1秒冷却时间"
                },
                {
                    "layer": 14,
                    "value": "本技能最后一击对目标造成伤害后,立即减少螺旋刃2秒冷却时间"
                },
                {
                    "layer": 15,
                    "value": "本技能最后一击对目标造成伤害后,立即减少螺旋刃3秒冷却时间"
                }],
                "require": {
                    "books": "高级穿云弹卷二*钢",
                    "preNum": 0,
                    "totolNum": 5,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "螺旋刃",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_05b7aaf4-ae35-4706-aa97-63bac74fd670_1513",
        "skillDescribe": {
            "main": "向前方丢掷螺旋刃，对触发区域内所有敌方造成持续伤害，持续<em class='green'>5</em>秒",
            "static": ["螺旋刃在接触到第一个敌方时展开，每秒对范围内敌方造成一定的物理伤害", "自身受到螺旋刃反作用力后退<em class='green'>10</em>米"],
            "addition": [{
                "initiative": "对区域内敌方持续造成<em class='green'>断筋</em>效果",
                "passivity": "断筋：降低移动速度50%"
            }],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能施放后,后退距离缩短至5米,同时造成的物理伤害提高15%"
                },
                {
                    "layer": 9,
                    "value": "本技能施放后,后退距离缩短至0米,同时造成的物理伤害提高30%"
                }],
                "require": {
                    "books": "中级螺旋刃卷一*炎",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "螺旋刃的每次攻击对都忽视敌人12%的物理防御力"
                },
                {
                    "layer": 14,
                    "value": "螺旋刃的每次攻击对都忽视敌人24%的物理防御力"
                },
                {
                    "layer": 15,
                    "value": "螺旋刃的每次攻击对都忽视敌人36%的物理防御力"
                }],
                "require": {
                    "books": "高级螺旋刃卷一*炎",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "可在眩晕或击倒状态下使用此技能，但无法解除控制"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "螺旋刃的每次攻击对敌人的伤害逐渐提高,每次提高5%"
                },
                {
                    "layer": 14,
                    "value": "螺旋刃的每次攻击对敌人的伤害逐渐提高,每次提高10%"
                },
                {
                    "layer": 15,
                    "value": "螺旋刃的每次攻击对敌人的伤害逐渐提高,每次提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低5%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "螺旋刃的每次攻击有15%的概率会对敌人造成“迟钝”状态,无法使用轻功,持续3秒"
                },
                {
                    "layer": 4,
                    "value": "螺旋刃的每次攻击有30%的概率会对敌人造成“迟钝”状态,无法使用轻功,持续3秒"
                },
                {
                    "layer": 5,
                    "value": "螺旋刃的每次攻击有50%的概率会对敌人造成“迟钝”状态,无法使用轻功,持续3秒"
                }],
                "require": {
                    "books": "初级螺旋刃卷一*钢",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "螺旋刃的每次攻击都会扣除敌人2点轻功值"
                },
                {
                    "layer": 9,
                    "value": "螺旋刃的每次攻击都会扣除敌人4点轻功值"
                },
                {
                    "layer": 10,
                    "value": "螺旋刃的每次攻击都会扣除敌人6点轻功值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能施放后,有50%的概率获得“吟唱迅捷”状态,下一次使用技能吟唱技能的时间降低1秒,持续2秒"
                },
                {
                    "layer": 14,
                    "value": "本技能施放后,有100%的概率获得“吟唱迅捷”状态,下一次使用技能吟唱技能的时间降低1秒,持续2秒"
                },
                {
                    "layer": 15,
                    "value": "本技能施放后,有100%的概率获得“吟唱迅捷”状态,下一次使用技能吟唱技能的时间降低1秒,持续3秒"
                }],
                "require": {
                    "books": "高级螺旋刃卷一*钢",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "狙杀模式",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9eca46aa-6473-4cc7-9954-41ed654f7066_1505",
        "skillDescribe": {
            "main": "开启/关闭狙杀模式，已牺牲自身机动能力来获取攻击能力的提升，并可以影响部分技能的效果",
            "static": ["开启/关闭狙杀模式，移动速度大幅下降，攻击能力提高", "狙杀模式下部分技能效果会被影响"],
            "addition": [{
                "initiative": "开启时进入<em class='green'>狙杀模式</em>",
                "passivity": "狙杀模式：提升自身12%基础物理攻击和少量固定物理攻击力，移动速度大幅下降，降低轻功回复速度50%"
            }],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "狙杀模式提升物理攻击力的效果提高5%"
                },
                {
                    "layer": 4,
                    "value": "狙杀模式提升物理攻击力的效果提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "狙杀模式下,炎杀系无双值增长速度提高5%（同类效果无法共存）"
                },
                {
                    "layer": 9,
                    "value": "狙杀模式下,炎杀系无双值增长速度提高10%（同类效果无法共存）"
                },
                {
                    "layer": 10,
                    "value": "狙杀模式下,炎杀系无双值增长速度提高15%（同类效果无法共存）"
                }],
                "require": {
                    "books": "中级狙杀模式卷一*炎",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "狙杀模式下,每次技能造成暴击都会使自身获得“专注”状态,物理攻击力提升0.5%,最多叠加20层；退出狙杀模式后,状态消失"
                },
                {
                    "layer": 14,
                    "value": "狙杀模式下,每次技能造成暴击都会使自身获得“专注”状态,物理攻击力提升1%,最多叠加20层；退出狙杀模式后,状态消失"
                },
                {
                    "layer": 15,
                    "value": "狙杀模式下,每次技能造成暴击都会使自身获得“专注”状态,物理攻击力提升1.5%,最多叠加20层；退出狙杀模式后,状态消失"
                }],
                "require": {
                    "books": "高级狙杀模式卷一*炎",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能冷却时间降低1秒"
                },
                {
                    "layer": 4,
                    "value": "技能冷却时间降低3秒"
                },
                {
                    "layer": 5,
                    "value": "技能冷却时间降低5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "狙杀模式下,自身的命中力提高10%"
                },
                {
                    "layer": 4,
                    "value": "狙杀模式下,自身的命中力提高20%"
                },
                {
                    "layer": 5,
                    "value": "狙杀模式下,自身的命中力提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "狙杀模式下,移动速度下降变为40%"
                },
                {
                    "layer": 9,
                    "value": "狙杀模式下,移动速度下降变为20%"
                },
                {
                    "layer": 10,
                    "value": "狙杀模式下,不再降低移动速度"
                }],
                "require": {
                    "books": "中级狙杀模式卷一*钢",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "狙杀模式下，所有指向性技能射程提高1米"
                },
                {
                    "layer": 14,
                    "value": "狙杀模式下，所有指向性技能射程提高2米"
                },
                {
                    "layer": 15,
                    "value": "狙杀模式下，所有指向性技能射程提高3米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "狙杀模式下，轻功回复速度仅降低30%"
                },
                {
                    "layer": 14,
                    "value": "狙杀模式下，轻功回复速度仅降低15%"
                },
                {
                    "layer": 15,
                    "value": "狙杀模式下，不再降低轻功回复速度"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "炎光傀儡",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_46191d43-44a3-45f5-b2ab-93153c44b4e5_1519",
        "skillDescribe": {
            "main": "召唤炎光傀儡，拥有主人的<em class='green'>10%</em>附加固定数值的生命，主人的<em class='green'>50%</em>攻击附加少量固定值物理攻击，持续<em class='green'>30</em>秒，不会被怪物攻击",
            "static": ["傀儡可以使用炎光波技能"],
            "addition": [{
                "initiative": "傀儡释放炎光波攻击敌人",
                "passivity": "炎光波：对前方1*30米区域内所有敌方造成基于物理攻击力的光系法术伤害，持续3秒，冷却5秒"
            }],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "进入战斗后,炎光傀儡会提高主人1%的物理攻击力,持续30秒"
                },
                {
                    "layer": 4,
                    "value": "进入战斗后,炎光傀儡会提高主人2%的物理攻击力,持续30秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "当炎光傀儡血量低于20%时会使用“自爆”技能,对周围5米范围的敌人造成主人160%基础物理攻击力的法术伤害"
                },
                {
                    "layer": 9,
                    "value": "当炎光傀儡血量低于20%时会使用“自爆”技能,对周围5米范围的敌人造成主人320%基础物理攻击力的法术伤害"
                },
                {
                    "layer": 10,
                    "value": "当炎光傀儡血量低于20%时会使用“自爆”技能,对周围5米范围的敌人造成主人480%基础物理攻击力的法术伤害"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "进入战斗后,炎光傀儡会提高主人5%的炎杀系无双增长速度,持续30秒（同类效果无法共存）"
                },
                {
                    "layer": 14,
                    "value": "进入战斗后,炎光傀儡会提高主人10%的炎杀系无双增长速度,持续30秒（同类效果无法共存）"
                },
                {
                    "layer": 15,
                    "value": "进入战斗后,炎光傀儡会提高主人15%的炎杀系无双增长速度,持续30秒（同类效果无法共存）"
                }],
                "require": {
                    "books": "高级炎光傀儡卷一*炎",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "炎光傀儡的攻击力提高5%"
                },
                {
                    "layer": 4,
                    "value": "炎光傀儡的攻击力提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "炎光傀儡的生命上限提高为主人的30%,持续时间增加15秒"
                },
                {
                    "layer": 9,
                    "value": "炎光傀儡的生命上限提高为主人的40%,持续时间增加30秒"
                }],
                "require": {
                    "books": "中级炎光傀儡卷一*钢",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“炎光波”造成的法术伤害可以忽视敌人20%的法术防御力"
                },
                {
                    "layer": 14,
                    "value": "“炎光波”造成的法术伤害可以忽视敌人40%的法术防御力"
                }],
                "require": {
                    "books": "高级炎光傀儡卷一*钢",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "使炎光傀儡额外获得“寒光波”技能,每秒对敌人造成主人55.8%基础物理攻击的法术伤害并造成“缚足”效果,移动速度降低50%,持续3秒,冷却时间3秒"
                },
                {
                    "layer": 14,
                    "value": "使炎光傀儡额外获得“寒光波”技能,每秒对敌人造成主人100%基础物理攻击的法术伤害并造成“缚足”效果,移动速度降低50%,持续3秒,冷却时间3秒"
                }],
                "require": {
                    "books": "高级炎光傀儡卷二*钢",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "暗诡雷",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_77cffc25-a5b1-4e4e-a821-b2c751bb619a_1511",
        "skillDescribe": {
            "main": "在原地安置炸药，对进入引爆区域的敌方造成相应效果，暗诡雷最多存在<em class='green'>60</em>秒",
            "static": ["<em class='green'>2</em>秒内再次使用使暗诡雷显形并朝目标移动", "可以对敌方造成基于物理攻击力的火系伤害，并且可通过烈性炸药或寒性炸药技能进行效果加强，任意炸药都可以解除敌人隐身效果"],
            "addition": [{
                "initiative": "烈性炸药强化后下一个安置的暗诡雷可以在造成伤害同时使敌方<em class='green'>击倒3</em>秒",
                "passivity": "击倒：无法移动和使用技能、轻功"
            },
            {
                "initiative": "寒性炸药强化后下一个安置的暗诡雷可以在爆炸范围内形成一片持续<em class='green'>10</em>秒的冰霜领域",
                "passivity": "冰霜领域：领域内所有敌方移动速度降低50%，受到的治疗效果降低50%"
            }],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的法术伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的法术伤害提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "普通炸药爆炸后原地留下一滩流火，每秒对上面的敌人造成15%基础物理攻击的法术伤害，持续3秒"
                },
                {
                    "layer": 9,
                    "value": "普通炸药爆炸后原地留下一滩流火，每秒对上面的敌人造成30%基础物理攻击的法术伤害，持续3秒"
                },
                {
                    "layer": 10,
                    "value": "普通炸药爆炸后原地留下一滩流火，每秒对上面的敌人造成45%基础物理攻击的法术伤害，持续3秒"
                }],
                "require": {
                    "books": "中级暗诡雷卷一*炎",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "流火的威力提升50%"
                },
                {
                    "layer": 14,
                    "value": "流火的威力提升100%"
                }],
                "require": {
                    "preNum": 3,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的法术伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "安装烈性炸药的暗诡雷爆炸后，敌人的物理防御力降低5%，持续10秒"
                },
                {
                    "layer": 4,
                    "value": "安装烈性炸药的暗诡雷爆炸后，敌人的物理防御力降低10%，持续10秒"
                },
                {
                    "layer": 5,
                    "value": "安装烈性炸药的暗诡雷爆炸后，敌人的物理防御力降低15%，持续10秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "安装烈性炸药的暗诡雷爆炸后,会随机封印敌人1个技能,持续5秒"
                },
                {
                    "layer": 9,
                    "value": "安装烈性炸药的暗诡雷爆炸后,会随机封印敌人2个技能,持续5秒"
                },
                {
                    "layer": 10,
                    "value": "安装烈性炸药的暗诡雷爆炸后,会随机封印敌人3个技能,持续5秒"
                }],
                "require": {
                    "books": "中级暗诡雷卷一*钢",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "烈性炸药的技能冷却时间降低3秒"
                },
                {
                    "layer": 14,
                    "value": "烈性炸药的技能冷却时间降低5秒"
                }],
                "require": {
                    "books": "高级暗诡雷卷一*钢",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "寒性炸药造成的“弱疗”效果提高为58%"
                },
                {
                    "layer": 4,
                    "value": "寒性炸药造成的“弱疗”效果提高为66%"
                },
                {
                    "layer": 5,
                    "value": "寒性炸药造成的“弱疗”效果提高为75%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "使敌人在冰霜领域内被冰冻3秒"
                }],
                "require": {
                    "books": "中级暗诡雷卷二*钢",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "寒性炸药的技能冷却时间降低4秒"
                },
                {
                    "layer": 14,
                    "value": "寒性炸药的技能冷却时间降低8秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "魔能甲",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_0ff0eada-4c36-47a0-8dce-a231fcbd5388_1514",
        "skillDescribe": {
            "main": "解除控制，魔能甲时间内免疫控制,最多持续<em class='green'>5</em>秒",
            "static": ["解除自身受到的控制效果"],
            "addition": [{
                "initiative": "自身进入<em class='green'>魔能甲</em>状态",
                "passivity": "魔能甲：增加自身物理防御力，免疫所有控制效果"
            }],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "“魔能甲”提升的物理防御力额外增加15%"
                },
                {
                    "layer": 4,
                    "value": "“魔能甲”提升的物理防御力额外增加30%"
                },
                {
                    "layer": 5,
                    "value": "“魔能甲”提升的物理防御力额外增加50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“魔能甲”持续期间,自身的轻功回复速度提高50%"
                },
                {
                    "layer": 9,
                    "value": "“魔能甲”持续期间,自身的轻功回复速度提高75%"
                },
                {
                    "layer": 10,
                    "value": "“魔能甲”持续期间,自身的轻功回复速度提高100%"
                }],
                "require": {
                    "books": "中级魔能甲卷一*炎",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“魔能甲”持续期间,最多可吸收自身生命上限4%的伤害"
                },
                {
                    "layer": 14,
                    "value": "“魔能甲”持续期间,最多可吸收自身生命上限8%的伤害"
                },
                {
                    "layer": 15,
                    "value": "“魔能甲”持续期间,最多可吸收自身生命上限12%的伤害"
                }],
                "require": {
                    "books": "高级魔能甲卷一*炎",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级魔能甲卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "“魔能甲”持续时间再次按键可以施放魔能甲二段,对自身周围所有敌人造成50%基础物理攻击力的物理伤害"
                },
                {
                    "layer": 4,
                    "value": "“魔能甲”持续时间再次按键可以施放魔能甲二段,对自身周围所有敌人造成100%基础物理攻击力的物理伤害"
                },
                {
                    "layer": 5,
                    "value": "“魔能甲”持续时间再次按键可以施放魔能甲二段,对自身周围所有敌人造成150%基础物理攻击力的物理伤害"
                }],
                "require": {
                    "books": "初级魔能甲卷一*钢",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“魔能甲”二段对敌人造成“物攻削弱”状态,物理攻击力降低10%,持续5秒"
                },
                {
                    "layer": 9,
                    "value": "“魔能甲”二段对敌人造成“物攻削弱”状态,物理攻击力降低20%,持续5秒"
                },
                {
                    "layer": 10,
                    "value": "“魔能甲”二段对敌人造成“物攻削弱”状态,物理攻击力降低30%,持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“魔能甲”二段对敌人造成“晕眩”状态,持续1秒"
                },
                {
                    "layer": 14,
                    "value": "“魔能甲”二段对敌人造成“晕眩”状态,持续2秒"
                },
                {
                    "layer": 15,
                    "value": "“魔能甲”二段对敌人造成“晕眩”状态,持续3秒"
                }],
                "require": {
                    "books": "高级魔能甲卷一*钢",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "死亡标记",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_fa89ef70-f605-4fb1-ba73-333a2aea7c20_1515",
        "skillDescribe": {
            "main": "使目标受到的伤害增加，持续<em class='green'>5</em>秒，可被对方防御效果减伤。",
            "static": ["被标记目标每次受到的伤害会额外增加"],
            "addition": [],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "处于“死亡标记”的目标每次受到的额外伤害加成提高5%"
                },
                {
                    "layer": 4,
                    "value": "处于“死亡标记”的目标每次受到的额外伤害加成提高10%"
                },
                {
                    "layer": 5,
                    "value": "处于“死亡标记”的目标每次受到的额外伤害加成提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "对处于“死亡标记”的目标每次攻击会立即回复30点生命上限"
                },
                {
                    "layer": 9,
                    "value": "对处于“死亡标记”的目标每次攻击会立即回复60点生命上限"
                },
                {
                    "layer": 10,
                    "value": "对处于“死亡标记”的目标每次攻击会立即回复100点生命上限"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“死亡标记”效果的持续时间增加1秒"
                },
                {
                    "layer": 14,
                    "value": "“死亡标记”效果的持续时间增加2秒"
                },
                {
                    "layer": 15,
                    "value": "“死亡标记”效果的持续时间增加3秒"
                }],
                "require": {
                    "books": "高级死亡标记卷一*炎",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "books": "中级死亡标记卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "处于“死亡标记”的目标吟唱时间延长20%"
                },
                {
                    "layer": 4,
                    "value": "处于“死亡标记”的目标吟唱时间延长40%"
                },
                {
                    "layer": 5,
                    "value": "处于“死亡标记”的目标吟唱时间延长60%"
                }],
                "require": {
                    "books": "初级死亡标记卷一*钢",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "处于“死亡标记”的目标自身的反控制等级降低7点"
                },
                {
                    "layer": 9,
                    "value": "处于“死亡标记”的目标自身的反控制等级降低14点"
                },
                {
                    "layer": 10,
                    "value": "处于“死亡标记”的目标自身的反控制等级降低20点"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "处于“死亡标记”的目标攻击力降低5%"
                },
                {
                    "layer": 14,
                    "value": "处于“死亡标记”的目标攻击力降低10%"
                },
                {
                    "layer": 15,
                    "value": "处于“死亡标记”的目标攻击力降低15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "聚能",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_54f2863c-a330-4d89-bd9d-c6f854ea1e09_1506",
        "skillDescribe": {
            "main": "<em class='green'>10</em>秒内强化自身，增加自己、傀儡、队友的暴击力和暴击加成",
            "static": ["使自己和周围队友获得<em class='green'>聚能</em>效果"],
            "addition": [{
                "initiative": "使用后，自身、傀儡及周围队友获得<em class='green'>聚能</em>效果",
                "passivity": "聚能：暴击力提升，暴击伤害加成提升15%"
            }],
            "trainingName": ["炎", "悟", "钢"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "“聚能”状态的暴击力提升10%"
                },
                {
                    "layer": 4,
                    "value": "“聚能”状态的暴击力提升20%"
                },
                {
                    "layer": 5,
                    "value": "“聚能”状态的暴击力提升30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“聚能”状态的暴击加成力额外提升10%"
                },
                {
                    "layer": 9,
                    "value": "“聚能”状态的暴击加成力额外提升20%"
                },
                {
                    "layer": 10,
                    "value": "“聚能”状态的暴击加成力额外提升30%"
                }],
                "require": {
                    "books": "中级聚能卷一*炎",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "自身在“聚能”持续期间对敌人造成暴击后,聚能的冷却时间降低1秒,该效果每秒最多触发一次"
                },
                {
                    "layer": 14,
                    "value": "自身在“聚能”持续期间对敌人造成暴击后,聚能的冷却时间降低2秒,该效果每秒最多触发一次"
                }],
                "require": {
                    "books": "高级聚能卷一*炎",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "小幅提高侦测到隐身敌人的概率"
                },
                {
                    "layer": 4,
                    "value": "大幅提高侦测到隐身敌人的概率"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级聚能卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对自己已召唤的傀儡附加“充能”状态,攻击力提升15%,持续10秒"
                },
                {
                    "layer": 4,
                    "value": "本技能对自己已召唤的傀儡附加“充能”状态,攻击力提升30%,持续10秒"
                },
                {
                    "layer": 5,
                    "value": "本技能对自己已召唤的傀儡附加“充能”状态,攻击力提升45%,持续10秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“充能”状态下，傀儡免疫受到的15%的PVP伤害"
                },
                {
                    "layer": 9,
                    "value": "“充能”状态下，傀儡免疫受到的30%的PVP伤害"
                },
                {
                    "layer": 10,
                    "value": "“充能”状态下，傀儡免疫受到的50%的PVP伤害"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“充能”状态下,傀儡的暴击力提高15%，暴击加成提高5%"
                },
                {
                    "layer": 14,
                    "value": "“充能”状态下,傀儡的暴击力提高30%，暴击加成提高10%"
                },
                {
                    "layer": 15,
                    "value": "“充能”状态下,傀儡的暴击力提高50%，暴击加成提高15%"
                }],
                "require": {
                    "books": "高级聚能卷一*钢",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    }],
    "liuguang": [{
        "skillName": "魂击",
        "skillProperty": ["法术技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_b618e745-434f-401a-a28b-0834148641c2_16022",
        "skillDescribe": {
            "main": "对敌方造成伤害或者回复友方生命值",
            "static": ["衍光形态下回复友方单体生命值，", "寂灭形态下对敌方单体造成魂系伤害"],
            "addition": [],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "衍光形态下,本技能造成的治疗效果提升5%"
                },
                {
                    "layer": 4,
                    "value": "衍光形态下,本技能造成的治疗效果提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "衍光形态下,当自身处于“沐光”状态时,本技能造成的治疗效果额外提高3%*“沐光”层数"
                },
                {
                    "layer": 9,
                    "value": "衍光形态下,当自身处于“沐光”状态时,本技能造成的治疗效果额外提高4%*“沐光”层数"
                },
                {
                    "layer": 10,
                    "value": "衍光形态下,当自身处于“沐光”状态时,本技能造成的治疗效果额外提高5%*“沐光”层数"
                }],
                "require": {
                    "books": "中级魂击卷一*光",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "衍光形态下,本技能对目标造成暴击治疗后,则立即清除魂珠技能0.5秒冷却时间"
                },
                {
                    "layer": 14,
                    "value": "衍光形态下,本技能对目标造成暴击治疗后,则立即清除魂珠技能1秒冷却时间"
                },
                {
                    "layer": 15,
                    "value": "衍光形态下,本技能对目标造成暴击治疗后,则立即清除魂珠技能1.5秒冷却时间"
                }],
                "require": {
                    "books": "高级魂击卷一*光",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的法术伤害提高4%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的法术伤害提高8%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "寂灭形态下,当自身处于“聚魂”状态时,本技能造成的法术伤害额外提高3%*“聚魂”层数"
                },
                {
                    "layer": 9,
                    "value": "寂灭形态下,当自身处于“聚魂”状态时,本技能造成的法术伤害额外提高4%*“聚魂”层数"
                },
                {
                    "layer": 10,
                    "value": "寂灭形态下,当自身处于“聚魂”状态时,本技能造成的法术伤害额外提高5%*“聚魂”层数"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "寂灭形态下,当目标处于“灭之魂”状态时,本技能有15%概率对目标造成“缚足”状态,减速50%,持续3秒"
                },
                {
                    "layer": 14,
                    "value": "寂灭形态下,当目标处于“灭之魂”状态时,本技能有30%概率对目标造成“缚足”状态,减速50%,持续3秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的法术伤害额外提高6%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的法术伤害额外提高12%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "魂爆",
        "skillProperty": ["法术技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_19d380ad-395a-45fb-bd0b-edac1c360e19_16032",
        "skillDescribe": {
            "main": "给目标单位加上一个魂印标记，<em class='green'>3</em>秒后爆炸，对目标周围的敌方造成伤害，或者对周围友方造成治疗",
            "static": ["寂灭：爆炸造成魂系伤害", "衍光：爆炸造成治疗效果"],
            "addition": [{
                "initiative": "衍光形态下，爆炸后会使目标周围敌方单位获得<em class='green'>光之魂</em>状态<em class='green'>3</em>秒",
                "passivity": "对每个光之魂状态下的敌方造成的每次有效伤害都能回复伤害来源者的生命值"
            },
            {
                "initiative": "寂灭形态下，爆炸后会使目标周围敌方单位获得<em class='green'>灭之魂</em>状态<em class='green'>3</em>秒",
                "passivity": "对灭之魂状态下的敌方造成的每次有效伤害都能造成额外伤害"
            }],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "衍光形态下，本技能爆炸时造成的治疗效果提高7%"
                },
                {
                    "layer": 4,
                    "value": "衍光形态下，本技能爆炸时造成的治疗效果提高14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“光之魂”状态的持续时间延长1秒"
                },
                {
                    "layer": 9,
                    "value": "“光之魂”状态的持续时间延长2秒"
                }],
                "require": {
                    "books": "中级魂爆卷一*光",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "衍光形态下,延时爆炸的时间缩短1秒"
                },
                {
                    "layer": 14,
                    "value": "衍光形态下,延时爆炸的时间缩短2秒"
                }],
                "require": {
                    "books": "高级魂爆卷一*光",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "攻击“光之魂”状态的单位回复的生命上限提高15%"
                },
                {
                    "layer": 9,
                    "value": "攻击“光之魂”状态的单位回复的生命上限提高30%"
                },
                {
                    "layer": 10,
                    "value": "攻击“光之魂”状态的单位回复的生命上限提高45%"
                }],
                "require": {
                    "books": "中级魂爆卷二*光",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "寂灭形态下,本技能爆炸时造成的法术伤害提高7%"
                },
                {
                    "layer": 4,
                    "value": "寂灭形态下,本技能爆炸时造成的法术伤害提高14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“灭之魂”状态的持续时间延长1秒"
                },
                {
                    "layer": 9,
                    "value": "“灭之魂”状态的持续时间延长2秒"
                }],
                "require": {
                    "books": "中级魂爆卷一*暗",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "寂灭形态下,延时爆炸的时间缩短1秒"
                },
                {
                    "layer": 14,
                    "value": "寂灭形态下,延时爆炸的时间缩短2秒"
                }],
                "require": {
                    "books": "高级魂爆卷一*暗",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "寂灭形态下,本技能爆炸时对怪物造成的法术伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "寂灭形态下,本技能爆炸时对怪物造成的法术伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "攻击“灭之魂”状态的单位造成的额外伤害提高15%"
                },
                {
                    "layer": 9,
                    "value": "攻击“灭之魂”状态的单位造成的额外伤害提高30%"
                }],
                "require": {
                    "books": "中级魂爆卷二*暗",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}]]
        }
    },
    {
        "skillName": "魂珠",
        "skillProperty": ["法术技能", "引导技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_5c51c105-f05b-4b84-87a7-fd5affbb7f8d_16152",
        "skillDescribe": {
            "main": "创造5个魂珠，<em class='green'>2</em>秒内连续引导发射，最多发射5个，手动打断或者目标死亡时魂珠消失",
            "static": ["衍光形态下，每个魂珠都会给目标回复生命值，最后一个魂珠击中目标时，为目标附加<em class='green'>光盾</em>状态", "寂灭形态下，每个魂珠对敌方造成魂系伤害，最后一个魂珠击中目标时，可吸收一定的生命值转移给施法者"],
            "addition": [{
                "initiative": "衍光形态下，使目标获得<em class='green'>光盾</em>，持续<em class='green'>5</em>秒",
                "passivity": "光盾：吸收所受到的伤害"
            }],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "衍光形态下,本技能造成的治疗效果提升5%"
                },
                {
                    "layer": 4,
                    "value": "衍光形态下,本技能造成的治疗效果提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "衍光形态下,本技能对目标产生结算，会使自身获得“沐光”状态,治疗能力提升1%,持续10秒,最多叠加5层"
                },
                {
                    "layer": 9,
                    "value": "衍光形态下,本技能对目标产生结算，会使自身获得“沐光”状态,治疗能力提升2%,持续10秒,最多叠加5层"
                },
                {
                    "layer": 10,
                    "value": "衍光形态下,本技能对目标产生结算，会使自身获得“沐光”状态,治疗能力提升3%,持续10秒,最多叠加5层"
                }],
                "require": {
                    "books": "中级魂珠卷一*光",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "当自身处于“沐光”状态时,本技能造成的“光盾”效果,吸收的伤害量提高30%"
                },
                {
                    "layer": 14,
                    "value": "当自身处于“沐光”状态时,本技能造成的“光盾”效果,吸收的伤害量提高60%"
                },
                {
                    "layer": 15,
                    "value": "当自身处于“沐光”状态时,本技能造成的“光盾”效果,吸收的伤害量提高100%"
                }],
                "require": {
                    "books": "高级魂珠卷一*光",
                    "preNum": 3,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的“光盾”效果,吸收的伤害量提高20%"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的“光盾”效果,吸收的伤害量提高40%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "衍光形态下,本技能的暴击治疗加成效果提高30%"
                },
                {
                    "layer": 14,
                    "value": "衍光形态下,本技能的暴击治疗加成效果提高60%"
                }],
                "require": {
                    "books": "高级魂珠卷二*光",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级魂珠卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的法术伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的法术伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "寂灭形态下,本技能对目标产生结算，会使自身获得“聚魂”状态,法术攻击力提升1%,持续10秒,最多叠加5层"
                },
                {
                    "layer": 9,
                    "value": "寂灭形态下,本技能对目标产生结算，会使自身获得“聚魂”状态,法术攻击力提升2%,持续10秒,最多叠加5层"
                },
                {
                    "layer": 10,
                    "value": "寂灭形态下,本技能对目标产生结算，会使自身获得“聚魂”状态,法术攻击力提升3%,持续10秒,最多叠加5层"
                }],
                "require": {
                    "books": "中级魂珠卷一*暗",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "当自身处于“聚魂”状态时,最后一个魂珠吸收的生命上限提高30%"
                },
                {
                    "layer": 14,
                    "value": "当自身处于“聚魂”状态时,最后一个魂珠吸收的生命上限提高60%"
                },
                {
                    "layer": 15,
                    "value": "当自身处于“聚魂”状态时,最后一个魂珠吸收的生命上限提高100%"
                }],
                "require": {
                    "books": "高级魂珠卷一*暗",
                    "preNum": 3,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的法术伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "使施法者在施放魂珠的过程中可以移动，但造成的伤害和治疗效果降低30%"
                },
                {
                    "layer": 9,
                    "value": "使施法者在施放魂珠的过程中可以移动，但造成的伤害和治疗效果降低15%"
                },
                {
                    "layer": 10,
                    "value": "使施法者在施放魂珠的过程中可以移动"
                }],
                "require": {
                    "books": "中级魂珠卷二*暗",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "寂灭形态下,本技能的暴击伤害加成提高30%"
                },
                {
                    "layer": 14,
                    "value": "寂灭形态下,本技能的暴击伤害加成提高60%"
                }],
                "require": {
                    "books": "高级魂珠卷二*暗",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "魂域",
        "skillProperty": ["法术技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_ee646d36-c7de-4fc3-a752-60c862c0a41d_16042",
        "skillDescribe": {
            "main": "<em class='green'>5</em>秒内持续回复范围内友方单位生命值或持续对敌方单位造成伤害",
            "static": ["衍光形态下，每秒回复范围内所有友方单位生命值", "寂灭形态下，每秒对范围内敌方单位造成魂系伤害"],
            "addition": [],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "衍光形态下,本技能每秒造成的治疗效果提升5%"
                },
                {
                    "layer": 4,
                    "value": "衍光形态下,本技能每秒造成的治疗效果提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "衍光形态下,魂域范围内的友方获得“强疗”效果,受到的治疗效果提高3%"
                },
                {
                    "layer": 9,
                    "value": "衍光形态下,魂域范围内的友方获得“强疗”效果,受到的治疗效果提高6%"
                },
                {
                    "layer": 10,
                    "value": "衍光形态下,魂域范围内的友方获得“强疗”效果,受到的治疗效果提高10%"
                }],
                "require": {
                    "books": "中级魂域卷一*光",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "衍光形态下,魂域的持续时间增加1秒"
                },
                {
                    "layer": 14,
                    "value": "衍光形态下,魂域的持续时间增加2秒"
                },
                {
                    "layer": 15,
                    "value": "衍光形态下,魂域的持续时间增加3秒"
                }],
                "require": {
                    "books": "高级魂域卷一*光",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "衍光形态下,魂域范围内的友方获得“轻功急速”效果,轻功回复速度提高15%,持续5秒"
                },
                {
                    "layer": 9,
                    "value": "衍光形态下,魂域范围内的友方获得“轻功急速”效果,轻功回复速度提高30%,持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "寂灭形态下,本技能每秒造成的法术伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "寂灭形态下,本技能每秒造成的法术伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "寂灭形态下,魂域范围内的敌方每秒扣除2点轻功值"
                },
                {
                    "layer": 9,
                    "value": "寂灭形态下,魂域范围内的敌方每秒扣除4点轻功值"
                },
                {
                    "layer": 10,
                    "value": "寂灭形态下,魂域范围内的敌方每秒扣除6点轻功值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "寂灭形态下,魂域的持续时间增加1秒"
                },
                {
                    "layer": 14,
                    "value": "寂灭形态下,魂域的持续时间增加2秒"
                },
                {
                    "layer": 15,
                    "value": "寂灭形态下,魂域的持续时间增加3秒"
                }],
                "require": {
                    "books": "高级魂域卷一*暗",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "寂灭形态下,本技能每秒对怪物造成的法术伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "寂灭形态下,本技能每秒对怪物造成的法术伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "追魂之魄",
        "skillProperty": ["法术技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a543dde8-3274-4067-9d08-f8f3ed2ec611_16062",
        "skillDescribe": {
            "main": "向前释放一颗包含灵气的光球，造成伤害或回复",
            "static": ["衍光形态下，向前方释放一颗光魄球，光魄球前进途中碰到的友方目标可以获得生命回复效果。<em class='green'>5</em>秒内再次按键可以直接引爆光魄球，立即对半径5米范围内所有友方造成治疗效果。", "寂灭形态下，向前方释放一颗暗魄球，光魄球前进途中每次碰到敌方都会对其造成魂系伤害。<em class='green'>5</em>秒内再次按键可以直接引爆暗魄球，立即对半径5米范围内所有敌方造成魂系伤害。"],
            "addition": [{
                "initiative": "光魄球可使被触碰到的友方获得<em class='green'>生命回复</em>状态，持续<em class='green'>10</em>秒",
                "passivity": "生命回复：状态持续时间内每2秒回复60.5%施法者基础治疗能力的生命值"
            }],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "衍光形态下,造成的治疗效果提升10%"
                },
                {
                    "layer": 4,
                    "value": "衍光形态下,造成的治疗效果提升20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "衍光形态下,光魄球的移动速度降低30%，存在时间增加1秒"
                },
                {
                    "layer": 9,
                    "value": "衍光形态下,光魄球的移动速度降低50%，存在时间增加2秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "衍光形态下,对生命上限低于20%的目标,光魄球爆炸造成的治疗效果额外提升20%"
                },
                {
                    "layer": 14,
                    "value": "衍光形态下,对生命上限低于20%的目标,光魄球爆炸造成的治疗效果额外提升40%"
                },
                {
                    "layer": 15,
                    "value": "衍光形态下,对生命上限低于20%的目标,光魄球爆炸造成的治疗效果额外提升60%"
                }],
                "require": {
                    "books": "高级追魂之魄卷一*光",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "衍光形态下,光魄球爆炸造成的治疗效果提升15%"
                },
                {
                    "layer": 14,
                    "value": "衍光形态下,光魄球爆炸造成的治疗效果提升30%"
                },
                {
                    "layer": 15,
                    "value": "衍光形态下,光魄球爆炸造成的治疗效果提升50%"
                }],
                "require": {
                    "books": "高级追魂之魄卷二*光",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "寂灭形态下,光魄球移动过程中造成的法术伤害提升10%"
                },
                {
                    "layer": 4,
                    "value": "寂灭形态下,光魄球移动过程中造成的法术伤害提升20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "寂灭形态下,光魄球的移动速度降低30%，存在时间增加1秒"
                },
                {
                    "layer": 9,
                    "value": "寂灭形态下,光魄球的移动速度降低50%，存在时间增加2秒"
                }],
                "require": {
                    "books": "中级追魂之魄卷一*暗",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "寂灭形态下,光魄球爆炸造成的法术伤害提升15%"
                },
                {
                    "layer": 14,
                    "value": "寂灭形态下,光魄球爆炸造成的法术伤害提升30%"
                },
                {
                    "layer": 15,
                    "value": "寂灭形态下,光魄球爆炸造成的法术伤害提升50%"
                }],
                "require": {
                    "books": "高级追魂之魄卷一*暗",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能的吟唱时间缩短0.5秒"
                }],
                "require": {
                    "books": "高级追魂之魄卷二*暗",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "魂镜",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_8bc318fa-5652-4138-9ede-1b3aae2dc349_16112",
        "skillDescribe": {
            "main": "在目标位置召唤魂镜，持续<em class='green'>300</em>秒，最多同时存在一个",
            "static": ["衍光形态下召唤的魂镜可以给周围队友增加物理和法术防御力", "寂灭形态下召唤的魂镜可以给周围队友增加物理和法术伤害"],
            "addition": [],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "“光之魂镜”增加的物理和法术防御力提高10%"
                },
                {
                    "layer": 4,
                    "value": "“光之魂镜”增加的物理和法术防御力提高15%"
                },
                {
                    "layer": 5,
                    "value": "“光之魂镜”增加的物理和法术防御力提高20%"
                }],
                "require": {
                    "books": "初级魂镜卷一*光",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“光之魂镜”周围10米内的队友获得“强疗”效果,受到的治疗效果提高10%"
                },
                {
                    "layer": 9,
                    "value": "在“光之魂镜”周围10米内的队友获得“强疗”效果,受到的治疗效果提高15%"
                },
                {
                    "layer": 10,
                    "value": "在“光之魂镜”周围10米内的队友获得“强疗”效果,受到的治疗效果提高20%"
                }],
                "require": {
                    "books": "中级魂镜卷一*光",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“光之魂镜”周围10米内的队友获得“轻功急速”效果,轻功回复速度提高30%"
                },
                {
                    "layer": 14,
                    "value": "在“光之魂镜”周围10米内的队友获得“轻功急速”效果,轻功回复速度提高40%"
                },
                {
                    "layer": 15,
                    "value": "在“光之魂镜”周围10米内的队友获得“轻功急速”效果,轻功回复速度提高50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "使魂镜可以清除周围5米内敌人的隐身效果"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "“灭之魂镜”增加的物理和法术攻击力提高10%"
                },
                {
                    "layer": 4,
                    "value": "“灭之魂镜”增加的物理和法术攻击力提高15%"
                },
                {
                    "layer": 5,
                    "value": "“灭之魂镜”增加的物理和法术攻击力提高20%"
                }],
                "require": {
                    "books": "初级魂镜卷一*暗",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“灭之魂镜”周围10米内的敌人获得“弱疗”效果,受到的治疗效果降低10%"
                },
                {
                    "layer": 9,
                    "value": "在“灭之魂镜”周围10米内的敌人获得“弱疗”效果,受到的治疗效果降低20%"
                },
                {
                    "layer": 10,
                    "value": "在“灭之魂镜”周围10米内的敌人获得“弱疗”效果,受到的治疗效果降低30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“灭之魂镜”周围10米内的敌人获得“轻功迟缓”效果,轻功回复速度降低30%"
                },
                {
                    "layer": 14,
                    "value": "在“灭之魂镜”周围10米内的敌人获得“轻功迟缓”效果,轻功回复速度降低40%"
                },
                {
                    "layer": 15,
                    "value": "在“灭之魂镜”周围10米内的敌人获得“轻功迟缓”效果,轻功回复速度降低50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "转魂",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_b461b003-1c23-4e2a-9496-37909b2e7434_16012",
        "skillDescribe": {
            "main": "使自己切换为衍光或者寂灭形态，对换2系无双值",
            "static": ["在衍光形态下所有技能增长衍光系无双值，并且增加自身基于敏捷数值百分比的治疗能力", "在寂灭形态下所有技能增长寂灭系无双值，并且增加自身基于敏捷数值百分比的法术攻击力，寂灭形态下对怪物会造成更多的伤害"],
            "addition": [],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "衍光形态增加的治疗能力提高10%"
                },
                {
                    "layer": 4,
                    "value": "衍光形态增加的治疗能力提高20%"
                }],
                "require": {
                    "books": "初级转魂卷一*光",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "衍光形态下,自身的暴击加成提高5%"
                },
                {
                    "layer": 9,
                    "value": "衍光形态下,自身的暴击加成提高10%"
                },
                {
                    "layer": 10,
                    "value": "衍光形态下,自身的暴击加成提高15%"
                }],
                "require": {
                    "books": "中级转魂卷一*光",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "衍光形态下,当自身的生命上限低于20%时,会触发“光之体”,3秒内受到的伤害降低50%,每120秒触发一次）"
                },
                {
                    "layer": 14,
                    "value": "衍光形态下,当自身的生命上限低于20%时,会触发“光之体”,3秒内受到的伤害降低50%,每90秒触发一次）"
                },
                {
                    "layer": 15,
                    "value": "衍光形态下,当自身的生命上限低于20%时,会触发“光之体”,3秒内受到的伤害降低50%,每60秒触发一次）"
                }],
                "require": {
                    "books": "高级转魂卷一*光",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "寂灭形态下,自身的生命上限降低10%,但法术攻击力提高5%"
                },
                {
                    "layer": 4,
                    "value": "寂灭形态下,自身的生命上限降低10%,但法术攻击力提高10%"
                }],
                "require": {
                    "books": "初级转魂卷一*暗",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "寂灭形态下,自身的暴击加成提高5%"
                },
                {
                    "layer": 9,
                    "value": "寂灭形态下,自身的暴击加成提高10%"
                },
                {
                    "layer": 10,
                    "value": "寂灭形态下,自身的暴击加成提高15%"
                }],
                "require": {
                    "books": "中级转魂卷一*暗",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "寂灭形态下,当自身的生命上限低于20%时,会触发“灭之体”,3秒内的暴击力和暴击伤害提高20%,每60秒触发一次）"
                },
                {
                    "layer": 14,
                    "value": "寂灭形态下,当自身的生命上限低于20%时,会触发“灭之体”,3秒内的暴击力和暴击伤害提高20%,每45秒触发一次）"
                },
                {
                    "layer": 15,
                    "value": "寂灭形态下,当自身的生命上限低于20%时,会触发“灭之体”,3秒内的暴击力和暴击伤害提高20%,每30秒触发一次）"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "寂灭形态下,对怪物伤害加成的效果提升5%"
                },
                {
                    "layer": 14,
                    "value": "寂灭形态下,对怪物伤害加成的效果提升10%"
                },
                {
                    "layer": 15,
                    "value": "寂灭形态下,对怪物伤害加成的效果提升15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "破碎虚空",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_4e03de08-125a-44cc-a65c-da6763ab17e7_16142",
        "skillDescribe": {
            "main": "引爆召唤的魂镜",
            "static": ["引爆衍光魂镜时可恢复范围内友方生命值，并驱散其所有负面状态", "引爆寂灭魂镜时可对范围内敌方造成魂系伤害，并驱散其所有正面状态"],
            "addition": [],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "“光之魂镜”爆炸后造成的治疗效果提升7.5%"
                },
                {
                    "layer": 4,
                    "value": "“光之魂镜”爆炸后造成的治疗效果提升15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“光之魂镜”爆炸后对每个驱散的队友额外回复50%基础治疗能力*驱散负面状态个数的生命和法力值"
                },
                {
                    "layer": 9,
                    "value": "“光之魂镜”爆炸后对每个驱散的队友额外回复75%基础治疗能力*驱散负面状态个数的生命和法力值"
                },
                {
                    "layer": 10,
                    "value": "“光之魂镜”爆炸后对每个驱散的队友额外回复100%基础治疗能力*驱散负面状态个数的生命和法力值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“光之魂镜”爆炸后提高自身3%*驱散负面状态总个数的暴击力，持续5秒"
                },
                {
                    "layer": 14,
                    "value": "“光之魂镜”爆炸后提高自身4%*驱散负面状态总个数的暴击力，持续5秒"
                },
                {
                    "layer": 15,
                    "value": "“光之魂镜”爆炸后提高自身5%*驱散负面状态总个数的暴击力，持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "衍光形态下，使用破碎虚空后图腾不再消失"
                }],
                "require": {
                    "books": "高级破碎虚空卷二*光",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "“灭之魂镜”爆炸后造成的法术伤害提升10%"
                },
                {
                    "layer": 4,
                    "value": "“灭之魂镜”爆炸后造成的法术伤害提升20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“灭之魂镜”爆炸后对每个驱散的敌人额外造成20%基础法术攻击力*驱散正面状态个数的法术伤害"
                },
                {
                    "layer": 9,
                    "value": "“灭之魂镜”爆炸后对每个驱散的敌人额外造成35%基础法术攻击力*驱散正面状态个数的法术伤害"
                },
                {
                    "layer": 10,
                    "value": "“灭之魂镜”爆炸后对每个驱散的敌人额外造成50%基础法术攻击力*驱散正面状态个数的法术伤害"
                }],
                "require": {
                    "books": "中级破碎虚空卷一*暗",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“灭之魂镜”爆炸后提高自身3%*驱散正面状态总个数的暴击力，持续5秒"
                },
                {
                    "layer": 14,
                    "value": "“灭之魂镜”爆炸后提高自身4%*驱散正面状态总个数的暴击力，持续5秒"
                },
                {
                    "layer": 15,
                    "value": "“灭之魂镜”爆炸后提高自身5%*驱散正面状态总个数的暴击力，持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "“灭之魂镜”爆炸后会清除周围20米以内敌人的隐身状态，并使其5秒内无法再次使用隐身技能"
                },
                {
                    "layer": 4,
                    "value": "“灭之魂镜”爆炸后会清除周围20米以内敌人的隐身状态，并使其10秒内无法再次使用隐身技能"
                },
                {
                    "layer": 5,
                    "value": "“灭之魂镜”爆炸后会清除周围20米以内敌人的隐身状态，并使其15秒内无法再次使用隐身技能"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            },
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "寂灭形态下，使用破碎虚空后图腾不再消失"
                }],
                "require": {
                    "books": "高级破碎虚空卷二*暗",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "轮回之门",
        "skillProperty": ["法术技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_5d17f89f-aa32-4f55-915c-4f52d51b8864_16162",
        "skillDescribe": {
            "main": "在自身位置召唤轮回之门，轮回之门存在<em class='green'>5</em>秒，对经过的队友或敌方造成影响",
            "static": ["衍光形态下，召唤<em class='green'>神佑</em>之门，从门里穿过的友方可以获得神佑之门的祝福，获得<em class='green'>神佑</em>效果", "寂灭形态下，召唤<em class='green'>噬魂</em>之门，从门里穿过的敌方会被噬魂之门诅咒，获得<em class='green'>噬魂</em>效果"],
            "addition": [{
                "initiative": "<em class='green'>神佑</em>之门可对经过的队友增加<em class='green'>神佑</em>效果，持续<em class='green'>4</em>秒，不可被同一门重复祝福。",
                "passivity": "神佑：免疫所有控制效果，移动速度提高50%，同时回复生命值"
            },
            {
                "initiative": "<em class='green'>噬魂</em>之门可对经过的敌方增加<em class='green'>噬魂</em>效果，持续<em class='green'>4</em>秒，不会被同一门重复诅咒。",
                "passivity": "噬魂：减速50%，同时每2秒造成魂系伤害，并且使敌人无法使用轻功"
            }],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "衍光形态下,“神佑”效果造成的治疗效果提升7.5%"
                },
                {
                    "layer": 4,
                    "value": "衍光形态下,“神佑”效果造成的治疗效果提升15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "衍光形态下,“神佑之墙”的存在时间增加1秒"
                },
                {
                    "layer": 9,
                    "value": "衍光形态下,“神佑之墙”的存在时间增加2秒"
                },
                {
                    "layer": 10,
                    "value": "衍光形态下,“神佑之墙”的存在时间增加3秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "当生命上限低于20%时，穿过神佑之门立即回复200%基础治疗量的生命上限"
                },
                {
                    "layer": 14,
                    "value": "当生命上限低于40%时，穿过神佑之门立即回复200%基础治疗量的生命上限"
                },
                {
                    "layer": 15,
                    "value": "当生命上限低于60%时，穿过神佑之门立即回复200%基础治疗量的生命上限"
                }],
                "require": {
                    "books": "高级轮回之门卷一*光",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "衍光形态下,“神佑之墙”的生成位置向前增加10米"
                },
                {
                    "layer": 4,
                    "value": "衍光形态下,“神佑之墙”的生成位置向前增加20米"
                },
                {
                    "layer": 5,
                    "value": "衍光形态下,“神佑之墙”的生成位置向前增加30米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级轮回之门卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "寂灭形态下,“噬魂”效果造成的法术伤害提高10%"
                },
                {
                    "layer": 4,
                    "value": "寂灭形态下,“噬魂”效果造成的法术伤害提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "寂灭形态下,“噬魂之墙”的存在时间增加1秒"
                },
                {
                    "layer": 9,
                    "value": "寂灭形态下,“噬魂之墙”的存在时间增加2秒"
                },
                {
                    "layer": 10,
                    "value": "寂灭形态下,“噬魂之墙”的存在时间增加3秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "寂灭形态下,“噬魂”效果的持续时间增加1秒"
                },
                {
                    "layer": 14,
                    "value": "寂灭形态下,“噬魂”效果的持续时间增加2秒"
                },
                {
                    "layer": 15,
                    "value": "寂灭形态下,“噬魂”效果的持续时间增加3秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "寂灭形态下,“噬魂之墙”的生成位置向前增加10米"
                },
                {
                    "layer": 4,
                    "value": "寂灭形态下,“噬魂之墙”的生成位置向前增加20米"
                },
                {
                    "layer": 5,
                    "value": "寂灭形态下,“噬魂之墙”的生成位置向前增加30米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "寂灭形态下,“噬魂”效果使敌人反控等级降低5点"
                },
                {
                    "layer": 9,
                    "value": "寂灭形态下,“噬魂”效果使敌人反控等级降低10点"
                },
                {
                    "layer": 10,
                    "value": "寂灭形态下,“噬魂”效果使敌人反控等级降低15点"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}]]
        }
    },
    {
        "skillName": "离魂归位",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_5ce69221-6008-43da-b50f-b45e678b7bdb_16052",
        "skillDescribe": {
            "main": "解除控制，获得护盾,并归位到图腾附近位置",
            "static": ["衍光状态时使用获得护盾<em class='green'>光辉之珠</em>，吸收一定量的伤害，最多持续<em class='green'>5</em>秒，手动解除<em class='green'>光辉之珠</em>可以解除周围<em class='green'>5</em>米范围内友方的受控状态", "寂灭状态时使用获得护盾<em class='green'>暗夜之珠</em>，吸收一定量的伤害，最多持续<em class='green'>5</em>秒，手动解除<em class='green'>暗夜之珠</em>可以<em class='green'>禁锢</em>周围<em class='green'>5</em>米范围内的敌方"],
            "addition": [{
                "initiative": "手动解除<em class='green'>暗夜之珠</em>可以禁锢周围敌方<em class='green'>3</em>秒",
                "passivity": "禁锢：无法移动、使用轻功和技能"
            }],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "在“光辉之珠”状态下,吸收的伤害增加10%"
                },
                {
                    "layer": 4,
                    "value": "在“光辉之珠”状态下,吸收的伤害增加20%"
                },
                {
                    "layer": 5,
                    "value": "在“光辉之珠”状态下,吸收的伤害增加30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“光辉之珠”状态下,自身的暴击力和暴击加成提高10%"
                },
                {
                    "layer": 9,
                    "value": "在“光辉之珠”状态下,自身的暴击力和暴击加成提高15%"
                },
                {
                    "layer": 10,
                    "value": "在“光辉之珠”状态下,自身的暴击力和暴击加成提高20%"
                }],
                "require": {
                    "books": "中级离魂归位卷一*光",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“光辉之珠”状态下,自身施法的吟唱时间缩短30%"
                },
                {
                    "layer": 14,
                    "value": "在“光辉之珠”状态下,自身施法的吟唱时间缩短50%"
                },
                {
                    "layer": 15,
                    "value": "在“光辉之珠”状态下,自身施法的吟唱时间缩短80%"
                }],
                "require": {
                    "books": "高级离魂归位卷一*光",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“光辉之珠”状态下,自身的反控等级提高25点"
                },
                {
                    "layer": 14,
                    "value": "在“光辉之珠”状态下,自身的反控等级提高50点"
                }],
                "require": {
                    "books": "高级离魂归位卷二*光",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级离魂归位卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "在“暗夜之珠”状态下,吸收的伤害增加10%"
                },
                {
                    "layer": 4,
                    "value": "在“暗夜之珠”状态下,吸收的伤害增加20%"
                },
                {
                    "layer": 5,
                    "value": "在“暗夜之珠”状态下,吸收的伤害增加30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“暗夜之珠”状态下,自身的暴击力和暴击加成提高10%"
                },
                {
                    "layer": 9,
                    "value": "在“暗夜之珠”状态下,自身的暴击力和暴击加成提高15%"
                },
                {
                    "layer": 10,
                    "value": "在“暗夜之珠”状态下,自身的暴击力和暴击加成提高20%"
                }],
                "require": {
                    "books": "中级离魂归位卷一*暗",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“暗夜之珠”状态下,自身施法的吟唱时间缩短30%"
                },
                {
                    "layer": 14,
                    "value": "在“暗夜之珠”状态下,自身施法的吟唱时间缩短50%"
                },
                {
                    "layer": 15,
                    "value": "在“暗夜之珠”状态下,自身施法的吟唱时间缩短80%"
                }],
                "require": {
                    "books": "高级离魂归位卷一*暗",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“暗夜之珠”状态下,自身的反控等级提高25点"
                },
                {
                    "layer": 14,
                    "value": "在“暗夜之珠”状态下,自身的反控等级提高50点"
                }],
                "require": {
                    "books": "高级离魂归位卷二*暗",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "灵魂之禁",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_d20442dc-59c8-4aae-be30-113a8649e2bc_16132",
        "skillDescribe": {
            "main": "对锁定目标使用，造成禁区效果，禁区消失或被击毁后可以产生爆炸，造成效果，禁区持续时间内可以再次使用技能手动引爆",
            "static": ["光之禁区爆炸后可以恢复禁区周围友方单位生命值", "灭之禁区爆炸后可以对附近敌方单位造成暗系伤害"],
            "addition": [{
                "initiative": "衍光状态下只能对团队目标使用，召唤<em class='green'>光之禁区</em>，持续<em class='green'>6</em>秒",
                "passivity": "光之禁区：禁锢目标并吸收大量伤害"
            },
            {
                "initiative": "寂灭形态下只能对敌方目标使用，召唤<em class='green'>灭之禁区</em>，持续<em class='green'>6</em>秒",
                "passivity": "灭之禁区：禁锢目标并吸收大量伤害"
            }],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "衍光形态下,“光之禁区”吸收的伤害提高10%"
                },
                {
                    "layer": 4,
                    "value": "衍光形态下,“光之禁区”吸收的伤害提高20%"
                },
                {
                    "layer": 5,
                    "value": "衍光形态下,“光之禁区”吸收的伤害提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "衍光形态下,“光之禁区”爆炸造成的治疗效果提升10%"
                },
                {
                    "layer": 9,
                    "value": "衍光形态下,“光之禁区”爆炸造成的治疗效果提升20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "衍光形态下,“光之禁区”内的目标每2秒回复2%生命上限和法力值"
                },
                {
                    "layer": 14,
                    "value": "衍光形态下,“光之禁区”内的目标每2秒回复3%生命上限和法力值"
                },
                {
                    "layer": 15,
                    "value": "衍光形态下,“光之禁区”内的目标每2秒回复4%生命上限和法力值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "衍光形态下,进入“光之禁区”内的敌方目标0.5秒有50%的概率会被“禁锢”,无法移动且无法施法"
                },
                {
                    "layer": 14,
                    "value": "衍光形态下,进入“光之禁区”内的敌方目标0.5秒有100%的概率会被“禁锢”,无法移动且无法施法"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级灵魂之禁卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "寂灭形态下,“灭之禁区”爆炸造成的法术伤害提升10%"
                },
                {
                    "layer": 4,
                    "value": "寂灭形态下,“灭之禁区”爆炸造成的法术伤害提升20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "寂灭形态下,“灭之禁区”爆炸对周围5米的敌人造成“缚足”效果,移动速度降低50%、禁止轻功,持续3秒"
                },
                {
                    "layer": 9,
                    "value": "寂灭形态下,“灭之禁区”爆炸对周围5米的敌人造成“缚足”效果,移动速度降低50%、禁止轻功,持续4秒"
                },
                {
                    "layer": 10,
                    "value": "寂灭形态下,“灭之禁区”爆炸对周围5米的敌人造成“缚足”效果,移动速度降低50%、禁止轻功,持续5秒"
                }],
                "require": {
                    "books": "中级灵魂之禁卷一*暗",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "寂灭形态下,“灭之禁区”内的目标每2秒扣除1%的法力值"
                },
                {
                    "layer": 14,
                    "value": "寂灭形态下,“灭之禁区”内的目标每2秒扣除2%的法力值"
                },
                {
                    "layer": 15,
                    "value": "寂灭形态下,“灭之禁区”内的目标每2秒扣除3%的法力值"
                }],
                "require": {
                    "books": "高级灵魂之禁卷一*暗",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "虚空流转",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_0878480e-2d3c-4f45-8e37-f197bd79a260_16122",
        "skillDescribe": {
            "main": "解除自身控制状态，并使自己和选定目标互换位置",
            "static": ["衍光形态：使自己和锁定队友、团友互换位置，解除其受到的控制效果，并减少自己<em class='green'>5%</em>的生命值，使目标恢复生命值", "寂灭形态：使自己和锁定敌方互换位置，对目标造成暗系伤害，并给自身回复伤害<em class='green'>50%</em>的生命值"],
            "addition": [],
            "trainingName": ["光", "悟", "灭"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“风行”状态,移动速度提高50%,持续1秒"
                },
                {
                    "layer": 4,
                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“风行”状态,移动速度提高50%,持续3秒"
                },
                {
                    "layer": 5,
                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“风行”状态,移动速度提高50%,持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“伤害减免”状态,受到的伤害降低10%,持续3秒"
                },
                {
                    "layer": 9,
                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“伤害减免”状态,受到的伤害降低20%,持续3秒"
                },
                {
                    "layer": 10,
                    "value": "衍光形态下,虚空流转换位后,自身和友方都获得“伤害减免”状态,受到的伤害降低30%,持续3秒"
                }],
                "require": {
                    "books": "中级虚空流转卷一*光",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "衍光形态下,虚空流转换位后,对自身周围所有敌人造成“昏迷”效果,持续1秒"
                },
                {
                    "layer": 14,
                    "value": "衍光形态下,虚空流转换位后,对自身周围所有敌人造成“昏迷”效果,持续2秒"
                },
                {
                    "layer": 15,
                    "value": "衍光形态下,虚空流转换位后,对自身周围所有敌人造成“昏迷”效果,持续3秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "books": "初级虚空流转卷一*悟",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级虚空流转卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "寂灭形态下,虚空流转换位后,对目标造成“晕眩”效果,持续1秒"
                },
                {
                    "layer": 4,
                    "value": "寂灭形态下,虚空流转换位后,对目标造成“晕眩”效果,持续2秒"
                },
                {
                    "layer": 5,
                    "value": "寂灭形态下,虚空流转换位后,对目标造成“晕眩”效果,持续3秒"
                }],
                "require": {
                    "books": "初级虚空流转卷一*暗",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "寂灭形态下,虚空流转换位后,对目标造成“法伤加深”效果,受到的法术伤害提高20%,持续3秒"
                },
                {
                    "layer": 9,
                    "value": "寂灭形态下,虚空流转换位后,对目标造成“法伤加深”效果,受到的法术伤害提高10%,持续3秒"
                },
                {
                    "layer": 10,
                    "value": "寂灭形态下,虚空流转换位后,对目标造成“法伤加深”效果,受到的法术伤害提高30%,持续3秒"
                }],
                "require": {
                    "books": "中级虚空流转卷一*暗",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "寂灭形态下,虚空流转换位后,自身获得“霸体”状态,免疫所有控制效果,持续1秒"
                },
                {
                    "layer": 14,
                    "value": "寂灭形态下,虚空流转换位后,自身获得“霸体”状态,免疫所有控制效果,持续2秒"
                },
                {
                    "layer": 15,
                    "value": "寂灭形态下,虚空流转换位后,自身获得“霸体”状态,免疫所有控制效果,持续3秒"
                }],
                "require": {
                    "books": "高级虚空流转卷一*暗",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能最大射程增加5米"
                },
                {
                    "layer": 9,
                    "value": "本技能最大射程增加10米"
                }],
                "require": {
                    "books": "中级虚空流转卷二*暗",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}]]
        }
    }],
    "yuxu": [{
        "skillName": "穿云",
        "skillProperty": ["法术技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_533edd99-62a6-46a2-919d-45125d595314_1201",
        "skillDescribe": {
            "main": "对敌方单体造成少量伤害，元灵种类会影响技能效果",
            "static": ["造成伤害，火灵状态下为火系伤害、雷灵状态下为雷系伤害、冰灵状态下造成冰系伤害", "雷灵状态下<em class='green'>20%</em>概率对目标周围<em class='green'>3</em>米内敌方造成法术伤害"],
            "addition": [{
                "initiative": "火灵状态下<em class='green'>20%</em>概率使敌方单体获得<em class='green'>破魔</em>状态<em class='green'>5</em>秒",
                "passivity": "降低10%的法术防御力"
            },
            {
                "initiative": "冰灵状态下<em class='green'>10%</em>概率使敌方单体获得<em class='green'>缚足</em>状态<em class='green'>2</em>秒",
                "passivity": "降低50%移动速度"
            }],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "火灵状态下,本技能造成的法术伤害提升7.5%"
                },
                {
                    "layer": 4,
                    "value": "火灵状态下,本技能造成的法术伤害提升15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "火灵状态下，本技能造成的“破魔”降低的法术防御力提高至15%"
                },
                {
                    "layer": 9,
                    "value": "火灵状态下，本技能造成的“破魔”降低的法术防御力提高至20%"
                }],
                "require": {
                    "books": "中级穿云卷一*诛",
                    "preNum": 2,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "火灵状态下，本技能对“灼烧”的敌人造成的“破魔”概率提高至50%"
                },
                {
                    "layer": 14,
                    "value": "火灵状态下，本技能对“灼烧”的敌人造成的“破魔”概率提高至75%"
                },
                {
                    "layer": 15,
                    "value": "火灵状态下，本技能对“灼烧”的敌人造成的“破魔”概率提高至100%"
                }],
                "require": {
                    "preNum": 2,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "雷灵状态下，本技能造成的法术伤害提升7.5%"
                },
                {
                    "layer": 4,
                    "value": "雷灵状态下，本技能造成的法术伤害提升15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "雷灵状态下，本技能对周围目标造成的伤害比例提高至30%"
                },
                {
                    "layer": 9,
                    "value": "雷灵状态下，本技能对周围目标造成的伤害比例提高至50%"
                }],
                "require": {
                    "preNum": 2,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "雷灵状态下，本技能对“触电”的敌人施放时，对周围目标造成的伤害比例提高至100%"
                }],
                "require": {
                    "preNum": 2,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能增长无双值转化为星罗系"
                },
                {
                    "layer": 9,
                    "value": "本技能增长无双值转化为星罗系,并额外增加1点万象系无双（无法享受初级穿云卷一・悟的效果）"
                },
                {
                    "layer": 10,
                    "value": "本技能增长无双值转化为星罗系,并额外增加2点万象系无双（无法享受初级穿云卷一・悟的效果）"
                }],
                "require": {
                    "books": "中级穿云卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "冰灵状态下,本技能造成的“缚足”概率提高至15%"
                },
                {
                    "layer": 4,
                    "value": "冰灵状态下,本技能造成的“缚足”概率提高至20%"
                },
                {
                    "layer": 5,
                    "value": "冰灵状态下,本技能造成的“缚足”概率提高至25%"
                }],
                "require": {
                    "books": "初级穿云卷一*禁",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "冰灵状态下,本技能造成的“缚足”效果延长1秒"
                },
                {
                    "layer": 9,
                    "value": "冰灵状态下,本技能造成的“缚足”效果延长2秒"
                },
                {
                    "layer": 10,
                    "value": "冰灵状态下,本技能造成的“缚足”效果延长3秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "冰灵状态下,本技能对“冰冻”的敌人造成的“缚足”的概率提高至50%"
                },
                {
                    "layer": 14,
                    "value": "冰灵状态下,本技能对“冰冻”的敌人造成的“缚足”的概率提高至100%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "冰灵状态下,本技能对“冰冻”的敌人有25%的概率再次造成“深度冰冻”，持续2秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "流火",
        "skillProperty": ["法术技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_ef03366b-d75e-48df-813b-4993e6ce9bfe_1203",
        "skillDescribe": {
            "main": "对敌方单体造成大量伤害，并增加一个元灵",
            "static": ["造成火系伤害", "火灵状态下<em class='green'>2</em>秒内可以释放流火二斩，可以引爆<em class='green'>灼烧</em>效果，造成全额伤害，若目标身上没有<em class='green'>灼烧</em>效果，则伤害为全额的一半且消耗一个元灵"],
            "addition": [{
                "initiative": "使目标敌方获得<em class='green'>灼烧</em>状态<em class='green'>5</em>秒",
                "passivity": "共计造成189%基础法术攻击力的火系伤害"
            }],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "流火一斩造成的法术伤害提高10%"
                },
                {
                    "layer": 4,
                    "value": "流火一斩造成的法术伤害提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "流火一斩造成的法术伤害可忽视敌人5%法术防御力"
                },
                {
                    "layer": 9,
                    "value": "流火一斩造成的法术伤害可忽视敌人10%法术防御力"
                },
                {
                    "layer": 10,
                    "value": "流火一斩造成的法术伤害可忽视敌人15%法术防御力"
                }],
                "require": {
                    "books": "中级流火卷一*诛",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "流火二斩后有50%概率不消耗1个元灵"
                },
                {
                    "layer": 14,
                    "value": "流火二斩后有100%概率不消耗1个元灵"
                }],
                "require": {
                    "books": "高级流火卷一*诛",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "流火一斩对怪物造成的法术伤害额外提高15%"
                },
                {
                    "layer": 4,
                    "value": "流火一斩对怪物造成的法术伤害额外提高30%"
                },
                {
                    "layer": 4,
                    "value": "流火一斩对怪物造成的法术伤害额外提高45%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "流火二斩后有50%概率保持原“灼烧”效果"
                },
                {
                    "layer": 9,
                    "value": "流火二斩后有100%概率保持原“灼烧”效果"
                }],
                "require": {
                    "books": "中级流火卷二*诛",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能的射程增加1米"
                },
                {
                    "layer": 4,
                    "value": "本技能的射程增加3米"
                },
                {
                    "layer": 5,
                    "value": "本技能的射程增加5米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对于处在“冰冻”状态的敌人造成的法术伤害额外提高10%"
                },
                {
                    "layer": 9,
                    "value": "本技能对于处在“冰冻”状态的敌人造成的法术伤害额外提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 1,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对于处在“冰冻”状态的敌人有10%概率造成的3秒“晕眩”"
                },
                {
                    "layer": 14,
                    "value": "本技能对于处在“冰冻”状态的敌人有20%概率造成的3秒“晕眩”"
                },
                {
                    "layer": 15,
                    "value": "本技能对于处在“冰冻”状态的敌人有30%概率造成的3秒“晕眩”"
                }],
                "require": {
                    "preNum": 2,
                    "totolNum": 3,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对于处在“触电”状态的敌人有20%概率造成的3秒“吟唱迟缓”,吟唱时间增加100%"
                },
                {
                    "layer": 9,
                    "value": "本技能对于处在“触电”状态的敌人有40%概率造成的3秒“吟唱迟缓”,吟唱时间增加100%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 1,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对于处在“触电”状态的敌人有20%概率造成的3秒“盲目”,技能射程降低50%"
                },
                {
                    "layer": 14,
                    "value": "本技能对于处在“触电”状态的敌人有40%概率造成的3秒“盲目”,技能射程降低50%"
                }],
                "require": {
                    "preNum": 2,
                    "totolNum": 3,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "冰封",
        "skillProperty": ["法术技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_e6aac35d-fa4a-49da-bc43-ea60809ec859_1206",
        "skillDescribe": {
            "main": "冰冻目标和其周围敌方，并造成伤害，同时增加一个元灵",
            "static": ["造成冰系伤害", "冰灵状态下<em class='green'>2</em>秒内可以消耗一个元灵使用冰封二斩，击碎冰块，对每一个周围敌方单位造成冰系伤害"],
            "addition": [{
                "initiative": "将敌方冰冻2秒",
                "passivity": "不能移动"
            },
            {
                "initiative": "冰封二斩可以对敌方单位造成缚足效果，持续3秒",
                "passivity": "移动速度降低50%"
            }],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的法术伤害提高10%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的法术伤害提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "冰封二斩造成的法术伤害额外提高50%,但无法使敌人“缚足”"
                },
                {
                    "layer": 9,
                    "value": "冰封二斩造成的法术伤害额外提高100%,但无法使敌人“缚足”"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "冰封二斩后有50%概率不消耗1个元灵"
                },
                {
                    "layer": 14,
                    "value": "冰封二斩后有100%概率不消耗1个元灵"
                }],
                "require": {
                    "books": "高级冰封卷一*诛",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的法术伤害额外提高15%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的法术伤害额外提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能的射程增加1米"
                },
                {
                    "layer": 4,
                    "value": "本技能的射程增加3米"
                },
                {
                    "layer": 5,
                    "value": "本技能的射程增加5米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的“冰冻”效果增加0.2秒"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的“冰冻”效果增加0.5秒"
                }],
                "require": {
                    "books": "中级冰封卷一*禁",
                    "preNum": 0,
                    "totolNum": 1,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "冰封二斩击碎冰块后,有50%概率对周围敌人造成“冰冻”效果,持续2秒"
                }],
                "require": {
                    "books": "高级冰封卷一*禁",
                    "preNum": 0,
                    "totolNum": 3,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "经过冰块的所有敌人造成“缚足”效果,降低移动速度30%,持续3秒"
                },
                {
                    "layer": 9,
                    "value": "经过冰块的所有敌人造成“缚足”效果,降低移动速度50%,持续3秒"
                }],
                "require": {
                    "books": "中级冰封卷二*禁",
                    "preNum": 0,
                    "totolNum": 1,
                    "line": "59"
                }
            },
            {}]]
        }
    },
    {
        "skillName": "聚灵",
        "skillProperty": ["法术技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_7a922185-0c0d-41b5-aae4-4443f25534fc_1225",
        "skillDescribe": {
            "main": "开启元灵，每次使用会以火、冰、雷的顺序进行切换，只能存在一种元灵",
            "static": ["每<em class='green'>5</em>秒自动增加一个元灵，也可以通过使用部分技能获得，最多存在<em class='green'>5</em>个", "元灵可以通过灵袭和剑罚释放，并可以影响部分技能的效果"],
            "addition": [{
                "initiative": "聚灵姿态下，自身获得<em class='green'>法术攻击强化</em>效果",
                "passivity": "提升法术攻击力"
            }],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "聚灵姿态增加的法术攻击力提高7%"
                },
                {
                    "layer": 4,
                    "value": "聚灵姿态增加的法术攻击力提高14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "火元灵状态下,自身的法术破防提升7%"
                },
                {
                    "layer": 9,
                    "value": "火元灵状态下,自身的法术破防提升14%"
                }],
                "require": {
                    "books": "中级聚灵卷一*诛",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "火元灵状态下,自每次自身技能造成暴击时,都有10%的概率获得1个元灵,该效果每5秒最多触发一次"
                },
                {
                    "layer": 14,
                    "value": "火元灵状态下,自每次自身技能造成暴击时,都有20%的概率获得1个元灵,该效果每5秒最多触发一次"
                },
                {
                    "layer": 15,
                    "value": "火元灵状态下,自每次自身技能造成暴击时,都有30%的概率获得1个元灵,该效果每5秒最多触发一次"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "对怪物造成的伤害额外提升5%"
                },
                {
                    "layer": 4,
                    "value": "对怪物造成的伤害额外提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "雷灵姿态下,提升的法术攻击力额外提升20%"
                },
                {
                    "layer": 9,
                    "value": "雷灵姿态下,提升的法术攻击力额外提升40%"
                }],
                "require": {
                    "books": "中级聚灵卷二*诛",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "雷元灵姿态下,自每次自身技能造成暴击时,都有10%的概率获得1个元灵,该效果每5秒最多触发一次"
                },
                {
                    "layer": 14,
                    "value": "雷元灵姿态下,自每次自身技能造成暴击时,都有20%的概率获得1个元灵,该效果每5秒最多触发一次"
                },
                {
                    "layer": 15,
                    "value": "雷元灵姿态下,自每次自身技能造成暴击时,都有30%的概率获得1个元灵,该效果每5秒最多触发一次"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "冰灵姿态下,自身的物理和法术防御力额外提升3%"
                },
                {
                    "layer": 4,
                    "value": "冰灵姿态下,自身的物理和法术防御力额外提升6%"
                },
                {
                    "layer": 5,
                    "value": "冰灵姿态下,自身的物理和法术防御力额外提升9%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "冰灵姿态下,自身每使用一个技能,都会降低所有技能1%的冷却时间，该效果5秒内最多只能触发一次"
                },
                {
                    "layer": 9,
                    "value": "冰灵姿态下,自身每使用一个技能,都会降低所有技能2%的冷却时间，该效果5秒内最多只能触发一次"
                },
                {
                    "layer": 10,
                    "value": "冰灵姿态下,自身每使用一个技能,都会降低所有技能3%的冷却时间，该效果5秒内最多只能触发一次"
                }],
                "require": {
                    "books": "中级聚灵卷一*禁",
                    "preNum": 0,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在冰灵姿态下，每次受到暴击，则会在接下来的5秒内，受到的伤害降低10%，触发间隔30秒"
                },
                {
                    "layer": 14,
                    "value": "在冰灵姿态下，每次受到暴击，则会在接下来的5秒内，受到的伤害降低20%，触发间隔30秒"
                },
                {
                    "layer": 15,
                    "value": "在冰灵姿态下，每次受到暴击，则会在接下来的5秒内，受到的伤害降低30%，触发间隔30秒"
                }],
                "require": {
                    "books": "高级聚灵卷一*禁",
                    "preNum": 0,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "灵袭",
        "skillProperty": ["法术技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_21dc94a8-9209-41c8-8783-5c5ef4f7e5d3_1204",
        "skillDescribe": {
            "main": "释放5颗元灵，向前方直线区域发动一次攻击，对范围内所有敌方造成伤害，三系灵袭不共冷却时间",
            "static": ["火灵状态下造成火系伤害", "冰灵状态下造成冰系伤害", "雷灵状态下召唤雷域对前方所有敌方进行攻击，每0.5秒造成雷系伤害，雷域存在5秒"],
            "addition": [{
                "initiative": "火灵状态下对敌方造成灼伤效果，持续6秒",
                "passivity": "6秒内造成火系伤害"
            },
            {
                "initiative": "冰灵状态下对敌方造成冰冻效果，持续5秒",
                "passivity": "无法移动和使用技能，被攻击后解除"
            },
            {
                "initiative": "雷灵状态下对敌方造成触电效果，持续5秒",
                "passivity": "无法使用轻功，降低20%的物理攻击力"
            }],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "火灵状态下,本技能造成的法术伤害可忽视敌人10%法术防御力"
                },
                {
                    "layer": 4,
                    "value": "火灵状态下,本技能造成的法术伤害可忽视敌人20%法术防御力"
                },
                {
                    "layer": 5,
                    "value": "火灵状态下,本技能造成的法术伤害可忽视敌人30%法术防御力"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "火灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外11%伤害"
                },
                {
                    "layer": 9,
                    "value": "火灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外22%伤害"
                },
                {
                    "layer": 10,
                    "value": "火灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外33%伤害"
                }],
                "require": {
                    "books": "中级灵袭卷一*诛",
                    "preNum": 2,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "火灵状态下,施放技能所需和消耗的元灵个数降低1个"
                },
                {
                    "layer": 14,
                    "value": "火灵状态下,施放技能所需和消耗的元灵个数降低2个"
                }],
                "require": {
                    "books": "高级灵袭卷一*诛",
                    "preNum": 2,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "雷灵状态下,本技能造成的法术伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "雷灵状态下,本技能造成的法术伤害提升10%"
                },
                {
                    "layer": 5,
                    "value": "雷灵状态下,本技能造成的法术伤害提升15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "雷灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外11%伤害,并对怪物造成的伤害额外提升7%"
                },
                {
                    "layer": 9,
                    "value": "雷灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外22%伤害,并对怪物造成的伤害额外提升14%"
                },
                {
                    "layer": 10,
                    "value": "雷灵状态下,本技能对处于“星剑杀阵”内的敌人造成额外33%伤害,并对怪物造成的伤害额外提升21%"
                }],
                "require": {
                    "books": "中级灵袭卷二*诛",
                    "preNum": 2,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "雷灵状态下,施放技能所需和消耗的元灵个数降低1个"
                },
                {
                    "layer": 14,
                    "value": "雷灵状态下,施放技能所需和消耗的元灵个数降低2个"
                }],
                "require": {
                    "books": "高级灵袭卷二*诛",
                    "preNum": 2,
                    "totolNum": 4,
                    "line": "59"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级灵袭卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "冰灵状态下,本技能造成的“冰冻”效果,同时附带5秒“缚足”效果,降低移动速度50%"
                },
                {
                    "layer": 4,
                    "value": "冰灵状态下,本技能造成的“冰冻”效果,同时附带5秒“缚足”效果,降低移动速度80%"
                }],
                "require": {
                    "books": "初级灵袭卷一*禁",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "冰灵状态下，本技能的“缚足”效果额外附带降低30%轻功回复速度的效果"
                },
                {
                    "layer": 9,
                    "value": "冰灵状态下，本技能的“缚足”效果额外附带降低60%轻功回复速度的效果"
                },
                {
                    "layer": 10,
                    "value": "冰灵状态下，本技能的“缚足”效果额外附带降低90%轻功回复速度的效果"
                }],
                "require": {
                    "books": "中级灵袭卷一*禁",
                    "preNum": 2,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "冰灵状态下,施放技能所需和消耗的元灵个数降低1个"
                },
                {
                    "layer": 14,
                    "value": "冰灵状态下,施放技能所需和消耗的元灵个数降低2个"
                }],
                "require": {
                    "books": "高级灵袭卷一*禁",
                    "preNum": 2,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "冰灵状态下,本技能的控制等级提高5点（相当于1级技能的数值）"
                },
                {
                    "layer": 9,
                    "value": "冰灵状态下,本技能的控制等级提高10点（相当于2级技能的数值）"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "冰灵状态下,本技能可随机封印敌人1个技能,使其无法使用,持续3秒"
                },
                {
                    "layer": 14,
                    "value": "冰灵状态下,本技能可随机封印敌人3个技能,使其无法使用,持续3秒"
                },
                {
                    "layer": 15,
                    "value": "冰灵状态下,本技能可随机封印敌人5个技能,使其无法使用,持续3秒"
                }],
                "require": {
                    "books": "高级灵袭卷二*禁",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "骤雷",
        "skillProperty": ["法术技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_94871f22-68a3-455d-b927-baf378bc63e9_1202",
        "skillDescribe": {
            "main": "释放一个向目标移动的闪电球，碰到一个的敌方后直接爆炸，对周围敌方造成伤害",
            "static": ["爆炸后对周围所有敌方造成雷系伤害", "使用技能增加一个元灵", "雷灵状态下，在闪电球爆炸前再次施放（爆炸后施放无效果），消耗一个元灵转换为一个新的电球向当前目标转移，新的电球在爆炸后可在原地再产生一个持续伤害的雷域"],
            "addition": [],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "一段造成的法术伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "一段造成的法术伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能施放的闪电球存在时间增加0.5秒"
                },
                {
                    "layer": 9,
                    "value": "本技能施放的闪电球存在时间增加1秒"
                },
                {
                    "layer": 10,
                    "value": "本技能施放的闪电球存在时间增加2秒"
                }],
                "require": {
                    "books": "中级骤雷卷一*诛",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "骤雷二斩后有50%概率不消耗1个元灵"
                },
                {
                    "layer": 14,
                    "value": "骤雷二斩后有100%概率不消耗1个元灵"
                }],
                "require": {
                    "books": "高级骤雷卷一*诛",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的法术伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "25%概率对闪电球范围内的敌人造成“破魔”效果,法术防御力降低10%,持续2秒"
                },
                {
                    "layer": 9,
                    "value": "50%概率对闪电球范围内的敌人造成“破魔”效果,法术防御力降低10%,持续2秒"
                }],
                "require": {
                    "books": "中级骤雷卷二*诛",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "books": "中级骤雷卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "闪电球的移动速度提高50%"
                },
                {
                    "layer": 4,
                    "value": "闪电球的移动速度提高100%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "被骤雷一段击中的目标有50%造成2秒“触电”,无法使用轻功,物理攻击力降低20%"
                },
                {
                    "layer": 9,
                    "value": "被骤雷一段击中的目标有75%造成2秒“触电”,无法使用轻功,物理攻击力降低20%"
                },
                {
                    "layer": 10,
                    "value": "被骤雷一段击中的目标有100%造成2秒“触电”,无法使用轻功,物理攻击力降低20%"
                }],
                "require": {
                    "books": "中级骤雷卷一*禁",
                    "preNum": 1,
                    "totolNum": 1,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "二段造成的法术伤害提升5%"
                }],
                "require": {
                    "books": "初级骤雷卷二*禁",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "闪电球每次伤害都有3%概率使敌人定身1秒"
                },
                {
                    "layer": 14,
                    "value": "闪电球每次伤害都有6%概率使敌人定身1秒"
                },
                {
                    "layer": 15,
                    "value": "闪电球每次伤害都有9%概率使敌人定身1秒"
                }],
                "require": {
                    "books": "高级骤雷卷二*禁",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "伐·星落",
        "skillProperty": ["法术技能", "瞬发技能"],
        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1213.png",
        "skillDescribe": {
            "main": "向后一跃，并对前方区域的所有敌方造成伤害",
            "static": ["3秒内每秒对敌方造成念系伤害"],
            "addition": [],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的法术伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的法术伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对“冰冻”目标的伤害提高10%"
                },
                {
                    "layer": 9,
                    "value": "本技能对“冰冻”目标的伤害提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能施放后,3秒内下一次使用技能的吟唱时间降低0.5秒"
                },
                {
                    "layer": 14,
                    "value": "本技能施放后,3秒内下一次使用技能的吟唱时间降低1秒"
                },
                {
                    "layer": 15,
                    "value": "本技能施放后,3秒内下一次使用技能的吟唱时间降低1秒,自身获得1秒霸体状态"
                }],
                "require": {
                    "books": "高级星落卷一*诛",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的法术伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级星落卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能每次攻击对敌人额外造成“缚足”效果,减速50%,持续1秒"
                },
                {
                    "layer": 4,
                    "value": "本技能每次攻击对敌人额外造成“缚足”效果,减速50%,持续2秒"
                },
                {
                    "layer": 5,
                    "value": "本技能每次攻击对敌人额外造成“缚足”效果,减速50%,持续3秒"
                }],
                "require": {
                    "books": "初级星落卷一*禁",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能每次攻击对敌人都会扣除其5点轻功值"
                },
                {
                    "layer": 9,
                    "value": "本技能每次攻击对敌人都会扣除其10点轻功值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能施放后,自身获得“风行”效果,移动速度提高50%,持续1秒"
                },
                {
                    "layer": 14,
                    "value": "本技能施放后,自身获得“风行”效果,移动速度提高50%,持续2秒"
                },
                {
                    "layer": 15,
                    "value": "本技能施放后,自身获得“风行”效果,移动速度提高50%,持续3秒"
                }],
                "require": {
                    "books": "高级星落卷一*禁",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能每次攻击对敌人额外造成“涣散”效果,控制等级降低10,持续3秒"
                },
                {
                    "layer": 14,
                    "value": "本技能每次攻击对敌人额外造成“涣散”效果,控制等级降低20,持续3秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "定·星阵",
        "skillProperty": ["法术技能", "瞬发技能"],
        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1212.png",
        "skillDescribe": {
            "main": "冰冻自身周围的所有敌方，并造成伤害",
            "static": ["对周围敌方造成冰系伤害"],
            "addition": [{
                "initiative": "将敌方冰冻3秒",
                "passivity": "无法移动和使用技能，受到攻击后解除"
            }],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的法术伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的法术伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的法术伤害额外提高25%,但无法使敌人“冰冻”（包括深度冰冻）"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的法术伤害额外提高50%,但无法使敌人“冰冻”（包括深度冰冻）"
                }],
                "require": {
                    "books": "中级星阵卷一*诛",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "2秒内再次按键可以继续施放1次定*星阵,最多可施放1次"
                },
                {
                    "layer": 14,
                    "value": "2秒内再次按键可以继续施放1次定*星阵,最多可施放2次"
                },
                {
                    "layer": 15,
                    "value": "2秒内再次按键可以继续施放1次定*星阵,最多可施放3次"
                }],
                "require": {
                    "books": "高级星阵卷一*诛",
                    "preNum": 1,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的法术伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的“冰冻”效果时间延长0.5秒(如果激活中级星阵卷一*诛,该效果将无法生效）"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的“冰冻”效果时间延长1秒(如果激活中级星阵卷一*诛,该效果将无法生效）"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的“冰冻”效果,同时附带5秒“缚足”效果,降低移动速度50%"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的“冰冻”效果,同时附带5秒“缚足”效果,降低移动速度80%"
                }],
                "require": {
                    "books": "中级星阵卷一*禁",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能施放后,有50%概率会重置伐*星落的技能冷却时间"
                },
                {
                    "layer": 14,
                    "value": "本技能施放后,有100%概率会重置伐*星落的技能冷却时间"
                }],
                "require": {
                    "books": "高级星阵卷一*禁",
                    "preNum": 2,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能有50%概率造成“深度冰冻”效果,被攻击后不会解除"
                },
                {
                    "layer": 14,
                    "value": "本技能有75%概率造成“深度冰冻”效果,被攻击后不会解除"
                },
                {
                    "layer": 15,
                    "value": "本技能有100%概率造成“深度冰冻”效果,被攻击后不会解除"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "佑·星体",
        "skillProperty": ["辅助技能", "吟唱技能"],
        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1216.png",
        "skillDescribe": {
            "main": "提升自身和周围队友的法术攻击力与法力值上限，并回复一定法力值",
            "static": ["立即恢复自身和队友的法力值，并增加自身和队友的法力值上限和法术攻击力"],
            "addition": [{
                "initiative": "自身获得星体状态，持续1800秒",
                "passivity": "提升自己的法术攻击力和法力值上限"
            },
            {
                "initiative": "队友获得星体之佑状态，持续1800秒",
                "passivity": "提升周围队友法术攻击力和法力值上限，效果与星体叠加"
            }],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能恢复的法力值提高15%"
                },
                {
                    "layer": 4,
                    "value": "本技能恢复的法力值提高30%"
                },
                {
                    "layer": 5,
                    "value": "本技能恢复的法力值提高45%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能产生的“星体”状态的法力值上限提高7%,法术攻击力加成提高7%"
                },
                {
                    "layer": 9,
                    "value": "本技能产生的“星体”状态的法力值上限提高7%,法术攻击力加成提高14%"
                },
                {
                    "layer": 10,
                    "value": "本技能产生的“星体”状态的法力值上限提高7%,法术攻击力加成提高20%"
                }],
                "require": {
                    "books": "中级星体卷一*诛",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“星体”状态下,自身的攻击对怪物造成的伤害额外提高3%"
                },
                {
                    "layer": 14,
                    "value": "“星体”状态下,自身的攻击对怪物造成的伤害额外提高6%"
                },
                {
                    "layer": 14,
                    "value": "“星体”状态下,自身的攻击对怪物造成的伤害额外提高9%"
                }],
                "require": {
                    "books": "高级星体卷一*诛",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能冷却时间降低5%"
                },
                {
                    "layer": 4,
                    "value": "技能冷却时间降低10%"
                },
                {
                    "layer": 5,
                    "value": "技能冷却时间降低15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能产生的“星体”状态额外使自身的法术防御力提高2%"
                },
                {
                    "layer": 4,
                    "value": "本技能产生的“星体”状态额外使自身的法术防御力提高4%"
                },
                {
                    "layer": 5,
                    "value": "本技能产生的“星体”状态额外使自身的法术防御力提高6%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能产生的“星体”状态额外使自身的物理防御力提高4%"
                },
                {
                    "layer": 9,
                    "value": "本技能产生的“星体”状态额外使自身的物理防御力提高8%"
                },
                {
                    "layer": 10,
                    "value": "本技能产生的“星体”状态额外使自身的物理防御力提高12%"
                }],
                "require": {
                    "books": "中级星体卷一*禁",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“星体”状态下,使自身提高4*体质的生命上限"
                },
                {
                    "layer": 14,
                    "value": "“星体”状态下,使自身提高8*体质的生命上限"
                },
                {
                    "layer": 15,
                    "value": "“星体”状态下,使自身提高12*体质的生命上限"
                }],
                "require": {
                    "books": "高级星体卷一*禁",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "遁·流星",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1211.png",
        "skillDescribe": {
            "main": "解除控制效果，并向前方瞬移",
            "static": ["解除自身控制状态", "向前方瞬移20米"],
            "addition": [],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能使用后3秒内,自身的法术攻击力提高4%"
                },
                {
                    "layer": 4,
                    "value": "技能使用后3秒内,自身的法术攻击力提高8%"
                },
                {
                    "layer": 5,
                    "value": "技能使用后3秒内,自身的法术攻击力提高12%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "使用后3秒内自身的法术破防率提高4%"
                },
                {
                    "layer": 9,
                    "value": "使用后3秒内自身的法术破防率提高9%"
                },
                {
                    "layer": 10,
                    "value": "使用后3秒内自身的法术破防率提高14%"
                }],
                "require": {
                    "books": "中级流星卷一*诛",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "技能使用后,立刻增加5点星罗系无双值"
                },
                {
                    "layer": 14,
                    "value": "技能使用后,立刻增加10点星罗系无双值"
                },
                {
                    "layer": 15,
                    "value": "技能使用后,立刻增加15点星罗系无双值"
                }],
                "require": {
                    "books": "高级流星卷一*诛",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级流星卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能使用后，3秒内自身受到的物理伤害降低8%"
                },
                {
                    "layer": 4,
                    "value": "技能使用后，3秒内自身受到的物理伤害降低15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能使用后3秒内,自身获得“流星护体”，可吸收3%生命上限上限的伤害"
                },
                {
                    "layer": 9,
                    "value": "技能使用后3秒内,自身获得“流星护体”，可吸收6%生命上限上限的伤害"
                },
                {
                    "layer": 10,
                    "value": "技能使用后3秒内,自身获得“流星护体”，可吸收9%生命上限上限的伤害"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "技能使用后,自身获得“霸体”效果,免疫任何控制技能,持续1秒"
                },
                {
                    "layer": 14,
                    "value": "技能使用后,自身获得“霸体”效果,免疫任何控制技能,持续2秒"
                },
                {
                    "layer": 15,
                    "value": "技能使用后,自身获得“霸体”效果,免疫任何控制技能,持续3秒"
                }],
                "require": {
                    "books": "高级流星卷一*禁",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能移动距离提高5米(影响移动距离的效果只能生效一种)"
                },
                {
                    "layer": 9,
                    "value": "本技能移动距离提高10米(影响移动距离的效果只能生效一种)"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "59"
                }
            },
            {}]]
        }
    },
    {
        "skillName": "裁·星剑",
        "skillProperty": ["法术技能", "吟唱技能"],
        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1214.png",
        "skillDescribe": {
            "main": "对指定区域内所有敌方造成大量伤害，并使星剑范围内敌方受到伤害加深，星剑最多存在10秒",
            "static": ["对范围内所有敌方造成念系伤害"],
            "addition": [{
                "initiative": "使范围内所有敌方晕眩3秒",
                "passivity": "不能移动和使用轻功、技能，被攻击不会解除"
            },
            {
                "initiative": "对周围敌方造成伤害加深效果",
                "passivity": "伤害加深10%，星剑消失时该效果消失"
            }],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的法术伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的法术伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的法术伤害额外提高30%,但无法使敌人“晕眩”"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的法术伤害额外提高50%,但无法使敌人“晕眩”"
                },
                {
                    "layer": 10,
                    "value": "本技能造成的法术伤害额外提高80%,但无法使敌人“晕眩”"
                }],
                "require": {
                    "books": "中级星剑卷一*诛",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "5秒内再次按键则引爆星剑,对周围敌人造成星剑一斩30%的伤害"
                },
                {
                    "layer": 14,
                    "value": "5秒内再次按键则引爆星剑,对周围敌人造成星剑一斩50%的伤害"
                },
                {
                    "layer": 15,
                    "value": "5秒内再次按键则引爆星剑,对周围敌人造成星剑一斩70%的伤害"
                }],
                "require": {
                    "books": "高级星剑卷一*诛",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的法术伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级星剑卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "星剑周围的敌人额外造成“缚足”效果,减速50%"
                },
                {
                    "layer": 4,
                    "value": "星剑周围的敌人额外造成“缚足”效果,减速80%"
                }],
                "require": {
                    "books": "初级星剑卷一*禁",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "星剑周围的敌人额外造成“虚弱”效果,无双增长速度降低15%（同类效果无法共存）"
                },
                {
                    "layer": 9,
                    "value": "星剑周围的敌人额外造成“虚弱”效果,无双增长速度降低30%（同类效果无法共存）"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "星剑周围的友方额外获得“激昂”效果,无双增长速度提高15%（同类效果无法共存）"
                },
                {
                    "layer": 14,
                    "value": "星剑周围的友方额外获得“激昂”效果,无双增长速度提高30%（同类效果无法共存）"
                }],
                "require": {
                    "books": "高级星剑卷一*禁",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "星剑造成的“晕眩”效果增加0.5秒(如果激活中级星剑卷一*诛,该效果将无法生效）"
                },
                {
                    "layer": 14,
                    "value": "星剑造成的“晕眩”效果增加1秒(如果激活中级星剑卷一*诛,该效果将无法生效）"
                },
                {
                    "layer": 15,
                    "value": "星剑造成的“晕眩”效果增加1.5秒(如果激活中级星剑卷一*诛,该效果将无法生效）"
                }],
                "require": {
                    "books": "高级星剑卷二*禁",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "临·星盾",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://img5.cache.netease.com/game/img14/tianyu/20150528/skill/icon64/1215.png",
        "skillDescribe": {
            "main": "解除自身控制状态，并且免疫一切威胁",
            "static": ["自身无法移动和使用技能，同时免疫一切攻击伤害和不良状态，移除大量怪物对自身的仇恨值，持续5秒"],
            "addition": [],
            "trainingName": ["诛", "悟", "禁"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "5秒内再次按键则解除星盾,并立即使自己获得3个元灵"
                },
                {
                    "layer": 4,
                    "value": "5秒内再次按键则解除星盾,并立即使自己获得4个元灵"
                },
                {
                    "layer": 4,
                    "value": "5秒内再次按键则解除星盾,并立即使自己获得5个元灵"
                }],
                "require": {
                    "books": "初级星盾卷一*诛",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "解除星盾后,立即使自己获得3点星罗系无双值"
                },
                {
                    "layer": 9,
                    "value": "解除星盾后,立即使自己获得6点星罗系无双值"
                },
                {
                    "layer": 10,
                    "value": "解除星盾后,立即使自己获得10点星罗系无双值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能施放后,立即清空“灵袭”和“万象*剑罚”的技能冷却时间"
                }],
                "require": {
                    "books": "高级星盾卷一*诛",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级星盾卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "星盾周围5米范围内的敌人会造成“缚足”效果,移动速度降低50%,持续3秒"
                },
                {
                    "layer": 4,
                    "value": "星盾周围5米范围内的敌人会造成“缚足”效果,移动速度降低50%,持续4秒"
                },
                {
                    "layer": 5,
                    "value": "星盾周围5米范围内的敌人会造成“缚足”效果,移动速度降低50%,持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在星盾状态下,自身每2秒回复1%的生命上限和法力值"
                },
                {
                    "layer": 9,
                    "value": "在星盾状态下,自身每2秒回复2%的生命上限和法力值"
                },
                {
                    "layer": 10,
                    "value": "在星盾状态下,自身每2秒回复3%的生命上限和法力值"
                }],
                "require": {
                    "books": "中级星盾卷一*禁",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "星盾周围5米范围内的敌人有50%的概率会造成“冰冻”效果,持续3秒"
                },
                {
                    "layer": 14,
                    "value": "星盾周围5米范围内的敌人有75%的概率会造成“冰冻”效果,持续3秒"
                },
                {
                    "layer": 15,
                    "value": "星盾周围5米范围内的敌人有100%的概率会造成“冰冻”效果,持续3秒"
                }],
                "require": {
                    "books": "高级星盾卷一*禁",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    }],
    "shengtang": [{
        "skillName": "猛击",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_d7fb5bb4-75a1-42a1-b5a4-bc5601ef74e9_1101",
        "skillDescribe": {
            "main": "对前方扇形区域的所有敌方造成少量伤害",
            "static": ["造成物理伤害"],
            "addition": [],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能伤害提升4%"
                },
                {
                    "layer": 4,
                    "value": "技能伤害提升8%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对“流血”的目标造成的伤害额外提升2%*“流血”层数"
                },
                {
                    "layer": 9,
                    "value": "本技能对“流血”的目标造成的伤害额外提升4%*“流血”层数"
                },
                {
                    "layer": 10,
                    "value": "本技能对“流血”的目标造成的伤害额外提升6%*“流血”层数"
                }],
                "require": {
                    "books": "中级猛击卷一*罚",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“雷罡体”状态下,本技能有10%的概率对敌人造成“流血”效果"
                },
                {
                    "layer": 14,
                    "value": "在“雷罡体”状态下,本技能有20%的概率对敌人造成“流血”效果"
                },
                {
                    "layer": 15,
                    "value": "在“雷罡体”状态下,本技能有30%的概率对敌人造成“流血”效果"
                }],
                "require": {
                    "books": "高级猛击卷一*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“雷罡体”状态下,本技能有30%的概率对“流血”的目标造成“断筋”效果,移动速度降低50%,持续2秒"
                },
                {
                    "layer": 14,
                    "value": "在“雷罡体”状态下,本技能有50%的概率对“流血”的目标造成“断筋”效果,移动速度降低50%,持续2秒"
                }],
                "require": {
                    "books": "高级猛击卷二*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能有20%的概率对敌人造成“破甲”效果,降低2.5%物理防御力,持续5秒"
                },
                {
                    "layer": 4,
                    "value": "本技能有40%的概率对敌人造成“破甲”效果,降低2.5%物理防御力,持续5秒"
                }],
                "require": {
                    "books": "初级猛击卷一*佑",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对敌人造成“破甲”效果的时间延长1秒"
                },
                {
                    "layer": 9,
                    "value": "本技能对敌人造成“破甲”效果的时间延长3秒"
                },
                {
                    "layer": 10,
                    "value": "本技能对敌人造成“破甲”效果的时间延长5秒"
                }],
                "require": {
                    "books": "中级猛击卷一*佑",
                    "preNum": 2,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对敌人造成“破甲”效果最多可叠加2层"
                },
                {
                    "layer": 14,
                    "value": "本技能对敌人造成“破甲”效果最多可叠加3层"
                },
                {
                    "layer": 15,
                    "value": "本技能对敌人造成“破甲”效果最多可叠加4层"
                }],
                "require": {
                    "books": "高级猛击卷一*佑",
                    "preNum": 3,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对“流血”的敌人造成“破甲”效果的概率提高至60%"
                },
                {
                    "layer": 14,
                    "value": "本技能对“流血”的敌人造成“破甲”效果的概率提高至80%"
                },
                {
                    "layer": 15,
                    "value": "本技能对“流血”的敌人造成“破甲”效果的概率提高至100%"
                }],
                "require": {
                    "books": "高级猛击卷二*佑",
                    "preNum": 0,
                    "totolNum": 5,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "扫荡",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_7f1eaebe-b54b-4c0f-ad28-e5c82531fc67_1104",
        "skillDescribe": {
            "main": "对自身周围的所有敌方造成伤害，并附加流血效果",
            "static": ["对周围所有敌方造成物理伤害"],
            "addition": [{
                "initiative": "使周围所有敌方进入<em class='green'>流血</em>状态<em class='green'>6</em>秒",
                "passivity": "6秒内每2秒受到物理伤害，同时会对受到来自自己赋予流血状态的敌人，之后造成的攻击会提高每层1%的伤害"
            }],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能造成的“流血”效果持续时间提高2秒（包括自身其他技能产生的“流血”效果）"
                },
                {
                    "layer": 4,
                    "value": "技能造成的“流血”效果持续时间提高4秒（包括自身其他技能产生的“流血”效果）"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能造成的“流血”效果最多可叠加3层（包括自身其他技能产生的“流血”效果）"
                },
                {
                    "layer": 9,
                    "value": "技能造成的“流血”效果最多可叠加4层（包括自身其他技能产生的“流血”效果）"
                },
                {
                    "layer": 10,
                    "value": "技能造成的“流血”效果最多可叠加5层（包括自身其他技能产生的“流血”效果）"
                }],
                "require": {
                    "books": "中级扫荡卷一*罚",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "技能造成的“流血”效果伤害提高4%（包括自身其他技能产生的“流血”效果）"
                },
                {
                    "layer": 14,
                    "value": "技能造成的“流血”效果伤害提高8%（包括自身其他技能产生的“流血”效果）"
                },
                {
                    "layer": 15,
                    "value": "技能造成的“流血”效果伤害提高12%（包括自身其他技能产生的“流血”效果）"
                }],
                "require": {
                    "books": "高级扫荡卷一*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的直接伤害提高7%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的直接伤害提高14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的直接伤害对怪物额外提高10%"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的直接伤害对怪物额外提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "在罡体状态下,使用本技能会使自身获得“铁甲”效果,物理防御力提高2%,持续6秒"
                },
                {
                    "layer": 4,
                    "value": "在罡体状态下,使用本技能会使自身获得“铁甲”效果,物理防御力提高2%,持续8秒"
                },
                {
                    "layer": 5,
                    "value": "在罡体状态下,使用本技能会使自身获得“铁甲”效果,物理防御力提高2%,持续10秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“铁甲”效果最多可叠加2层"
                },
                {
                    "layer": 9,
                    "value": "“铁甲”效果最多可叠加3层"
                },
                {
                    "layer": 10,
                    "value": "“铁甲”效果最多可叠加4层"
                }],
                "require": {
                    "books": "中级扫荡卷一*佑",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "当自身处于“铁甲”状态且受到暴击伤害时,自动触发“铁甲护体”效果,受到的伤害额外降低12%,持续5秒,触发间隔1分钟"
                },
                {
                    "layer": 14,
                    "value": "当自身处于“铁甲”状态且受到暴击伤害时,自动触发“铁甲护体”效果,受到的伤害额外降低25%,持续5秒,触发间隔1分钟"
                }],
                "require": {
                    "books": "高级扫荡卷一*佑",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "破阵",
        "skillProperty": ["物理技能", "蓄力技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_be47d4da-0767-4b30-8f2b-859d30359ba6_1105",
        "skillDescribe": {
            "main": "对前方区域所有敌方造成伤害",
            "static": ["造成物理伤害", "蓄力<em class='green'>0.5</em>秒后可将打击对象击退5米"],
            "addition": [{
                "initiative": "蓄力0.5秒后可使打击对象获得攻击削弱效果，持续3秒",
                "passivity": "降低10%的攻击力"
            }],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "破阵对当前生命值高于50%的敌人造成的物理伤害提高11%"
                },
                {
                    "layer": 9,
                    "value": "破阵对当前生命值高于50%的敌人造成的物理伤害提高22%"
                },
                {
                    "layer": 10,
                    "value": "破阵对当前生命值高于50%的敌人造成的物理伤害提高33%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "破阵对当前生命值低于20%的敌人造成的物理伤害提高20%"
                },
                {
                    "layer": 14,
                    "value": "破阵对当前生命值低于20%的敌人造成的物理伤害提高40%"
                },
                {
                    "layer": 15,
                    "value": "破阵对当前生命值低于20%的敌人造成的物理伤害提高60%"
                }],
                "require": {
                    "books": "高级破阵卷一*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能有20%的概率对“流血”的目标造成“断筋”效果,移动速度降低50%,持续2秒"
                },
                {
                    "layer": 4,
                    "value": "本技能有40%的概率对“流血”的目标造成“断筋”效果,移动速度降低50%,持续2秒"
                },
                {
                    "layer": 5,
                    "value": "本技能有60%的概率对“流血”的目标造成“断筋”效果,移动速度降低50%,持续2秒"
                }],
                "require": {
                    "books": "初级破阵卷一*佑",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "蓄力时间增加0.5秒,技能造成的物理伤害提高25%,对敌人降低的攻击力提高为15%。"
                },
                {
                    "layer": 9,
                    "value": "蓄力时间增加1秒,技能造成的物理伤害提高50%,对敌人降低的攻击力提高为20%。"
                }],
                "require": {
                    "books": "中级破阵卷一*佑",
                    "preNum": 0,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“罡体”状态下,蓄力结束后,本技能有30%的概率对怪物“击倒”2秒"
                },
                {
                    "layer": 14,
                    "value": "在“罡体”状态下,蓄力结束后,本技能有60%的概率对怪物“击倒”2秒"
                },
                {
                    "layer": 15,
                    "value": "在“罡体”状态下,蓄力结束后,本技能有100%的概率对怪物“击倒”2秒"
                }],
                "require": {
                    "books": "高级破阵卷一*佑",
                    "preNum": 0,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "去除蓄力后的击退效果，蓄力完造成的伤害额外提高10%"
                },
                {
                    "layer": 4,
                    "value": "去除蓄力后的击退效果，蓄力完造成的伤害额外提高20%"
                },
                {
                    "layer": 5,
                    "value": "去除蓄力后的击退效果，蓄力完造成的伤害额外提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 1,
                    "line": "59"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "旋斩",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_cd674063-0bb3-4c15-ae62-b6fb987bb79f_1103",
        "skillDescribe": {
            "main": "击倒前方区域的所有敌方并造成伤害",
            "static": ["造成物理伤害", "2秒内可以再次按键，使用旋斩二斩，3秒内对敌方造成物理伤害"],
            "addition": [{
                "initiative": "使敌方被<em class='green'>击倒</em>，持续3秒",
                "passivity": "自身倒地，无法移动和释放技能"
            }],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "旋斩二段造成的物理伤害提高10%"
                },
                {
                    "layer": 4,
                    "value": "旋斩二段造成的物理伤害提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "旋斩二斩对当前生命值高于50%的敌人造成的物理伤害提高17%"
                },
                {
                    "layer": 9,
                    "value": "旋斩二斩对当前生命值高于50%的敌人造成的物理伤害提高34%"
                },
                {
                    "layer": 10,
                    "value": "旋斩二斩对当前生命值高于50%的敌人造成的物理伤害提高51%"
                }],
                "require": {
                    "books": "中级旋斩卷一*罚",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "旋斩二斩对当前生命值低于20%的敌人造成的物理伤害提高30%"
                },
                {
                    "layer": 14,
                    "value": "旋斩二斩对当前生命值低于20%的敌人造成的物理伤害提高60%"
                },
                {
                    "layer": 15,
                    "value": "旋斩二斩对当前生命值低于20%的敌人造成的物理伤害提高90%"
                }],
                "require": {
                    "books": "高级旋斩卷一*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "旋斩二段对怪物伤害额外提升7.5%"
                },
                {
                    "layer": 4,
                    "value": "旋斩二段对怪物伤害额外提升15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "旋斩二斩施放期间，自身可以移动"
                }],
                "require": {
                    "books": "高级旋斩卷二*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "59"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 3,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 4,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "49"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "旋斩二斩持续期间内，自身受到的伤害降低3%"
                },
                {
                    "layer": 4,
                    "value": "旋斩二斩持续期间内，自身受到的伤害降低6%"
                },
                {
                    "layer": 5,
                    "value": "旋斩二斩持续期间内，自身受到的伤害降低9%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "旋斩二斩的持续时间增加1秒"
                },
                {
                    "layer": 9,
                    "value": "旋斩二斩的持续时间增加2秒"
                },
                {
                    "layer": 10,
                    "value": "旋斩二斩的持续时间增加3秒"
                }],
                "require": {
                    "books": "中级旋斩卷一*佑",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "旋斩二斩持续期间内,自身的反控制等级提高25点"
                },
                {
                    "layer": 14,
                    "value": "旋斩二斩持续期间内,自身的反控制等级提高50点"
                }],
                "require": {
                    "books": "高级旋斩卷一*佑",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "定军",
        "skillProperty": ["物理技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_c6f4a9d3-0ecb-4d16-adb2-d4f9957aa27e_1112",
        "skillDescribe": {
            "main": "对前方直线上所有敌方造成伤害并附加断筋效果",
            "static": ["对区域内所有敌方造成物理伤害", "造成一个地裂区域，5秒内每秒造成雷系伤害"],
            "addition": [{
                "initiative": "使范围内敌方断筋，持续3秒",
                "passivity": "移动速度降低50%"
            }],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提高10%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能伤害提高50%，但不再生成地裂区域的持续伤害和断筋效果"
                },
                {
                    "layer": 9,
                    "value": "技能伤害提高75%，但不再生成地裂区域的持续伤害和断筋效果"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对于倒地状态的敌人，造出的伤害额外提高19%"
                },
                {
                    "layer": 14,
                    "value": "本技能对于倒地状态的敌人，造出的伤害额外提高38%"
                }],
                "require": {
                    "books": "高级定军卷一*罚",
                    "preNum": 2,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的“断筋”效果额外降低目标4%的物理防御力"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的“断筋”效果额外降低目标8%的物理防御力"
                }],
                "require": {
                    "books": "中级定军卷二*罚",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“雷罡体”状态下，本技能对敌人造成定身1秒"
                },
                {
                    "layer": 14,
                    "value": "在“雷罡体”状态下，本技能对敌人造成定身1.5秒"
                },
                {
                    "layer": 15,
                    "value": "在“雷罡体”状态下，本技能对敌人造成定身2秒"
                }],
                "require": {
                    "books": "高级定军卷二*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "59"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "减少定军0.5秒的吟唱时间"
                }],
                "require": {
                    "books": "高级定军卷一*悟",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "地裂区域的法术伤害提高15%"
                },
                {
                    "layer": 4,
                    "value": "地裂区域的法术伤害提高30%"
                },
                {
                    "layer": 5,
                    "value": "地裂区域的法术伤害提高50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "地裂区域持续时间提高1秒"
                },
                {
                    "layer": 9,
                    "value": "地裂区域持续时间提高2秒"
                },
                {
                    "layer": 10,
                    "value": "地裂区域持续时间提高3秒"
                }],
                "require": {
                    "books": "中级定军卷一*佑",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "处于地裂区域内的敌人,受到的治疗效果降低30%"
                },
                {
                    "layer": 14,
                    "value": "处于地裂区域内的敌人,受到的治疗效果降低40%"
                },
                {
                    "layer": 15,
                    "value": "处于地裂区域内的敌人,受到的治疗效果降低50%"
                }],
                "require": {
                    "books": "高级定军卷一*佑",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "地裂区域对怪物造成的法术伤害额外提高25%"
                },
                {
                    "layer": 9,
                    "value": "地裂区域对怪物造成的法术伤害额外提高50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "地裂区域内的敌人受到的伤害提高4%"
                },
                {
                    "layer": 14,
                    "value": "地裂区域内的敌人受到的伤害提高8%"
                },
                {
                    "layer": 15,
                    "value": "地裂区域内的敌人受到的伤害提高12%"
                }],
                "require": {
                    "books": "高级定军卷二*佑",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "降世",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_905516bd-e671-4f05-9caf-c3d4bf374a2c_1102",
        "skillDescribe": {
            "main": "纵身一跃，快速跳向目标敌方，击倒范围内所有敌方并造成伤害",
            "static": ["造成物理伤害"],
            "addition": [{
                "initiative": "将范围内敌方击倒，持续3秒",
                "passivity": "自身倒地，无法移动和释放技能"
            }],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的物理伤害提高25%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的物理伤害提高50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能的最远射程提高1米"
                },
                {
                    "layer": 9,
                    "value": "本技能的最远射程提高3米"
                },
                {
                    "layer": 10,
                    "value": "本技能的最远射程提高5米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“雷罡体”状态下,本技能对敌人额外造成“破甲”效果,降低7%物理防御力,持续3秒"
                },
                {
                    "layer": 14,
                    "value": "在“雷罡体”状态下,本技能对敌人额外造成“破甲”效果,降低14%物理防御力,持续3秒"
                },
                {
                    "layer": 15,
                    "value": "在“雷罡体”状态下,本技能对敌人额外造成“破甲”效果,降低21%物理防御力,持续3秒"
                }],
                "require": {
                    "books": "高级降世卷一*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级降世卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "当敌人处于“霸体”状态时,本技能造成的物理伤害额外提高50%,并产生大量仇恨"
                },
                {
                    "layer": 4,
                    "value": "当敌人处于“霸体”状态时,本技能造成的物理伤害额外提高100%,并产生大量仇恨"
                },
                {
                    "layer": 5,
                    "value": "当敌人处于“霸体”状态时,本技能造成的物理伤害额外提高150%,并产生大量仇恨"
                }],
                "require": {
                    "books": "初级降世卷一*佑",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能的最远射程提高1米"
                },
                {
                    "layer": 9,
                    "value": "本技能的最远射程提高3米"
                },
                {
                    "layer": 10,
                    "value": "本技能的最远射程提高5米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“罡体”状态下,本技能施放后,自身获得霸体效果,持续1秒"
                },
                {
                    "layer": 14,
                    "value": "在“罡体”状态下,本技能施放后,自身获得霸体效果,持续2秒"
                }],
                "require": {
                    "books": "高级降世卷一*佑",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "罡体",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_bb58f86c-8768-487e-93e0-50aaa661e6f1_1115",
        "skillDescribe": {
            "main": "使用开启或者关闭罡体状态，罡体与雷罡体共享冷却时间",
            "static": [],
            "addition": [{
                "initiative": "开启时获得罡体效果",
                "passivity": "物理防御力提升，法术防御力提升，伤害减免率提升3%，同时降低自身50%的移动速度，造成的仇恨值增加50%"
            }],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "雷罡体状态下，自身攻击力提升1%"
                },
                {
                    "layer": 4,
                    "value": "雷罡体状态下，自身攻击力提升2%"
                },
                {
                    "layer": 5,
                    "value": "雷罡体状态下，自身攻击力提升3%"
                }],
                "require": {
                    "books": "初级罡体卷一*罚",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“雷罡体”状态,自身的暴击力提升5%"
                },
                {
                    "layer": 9,
                    "value": "“雷罡体”状态,自身的暴击力提升10%"
                },
                {
                    "layer": 10,
                    "value": "“雷罡体”状态,自身的暴击力提升15%"
                }],
                "require": {
                    "books": "中级罡体卷一*罚",
                    "preNum": 3,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“雷罡体”状态,天罚系无双增长速度提升5%（同类效果无法共存）"
                },
                {
                    "layer": 14,
                    "value": "“雷罡体”状态,天罚系无双增长速度提升10%（同类效果无法共存）"
                },
                {
                    "layer": 15,
                    "value": "“雷罡体”状态,天罚系无双增长速度提升15%（同类效果无法共存）"
                }],
                "require": {
                    "books": "高级罡体卷一*罚",
                    "preNum": 3,
                    "totolNum": 6,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "“罡体”状态,移动速度下降变为30%"
                },
                {
                    "layer": 4,
                    "value": "“罡体”状态,移动速度下降变为15%"
                },
                {
                    "layer": 5,
                    "value": "“罡体”状态,不减移动速度"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能的“罡体”状态提升的物理及法术防御力额外增加15%"
                },
                {
                    "layer": 9,
                    "value": "本技能的“罡体”状态提升的物理及法术防御力额外增加30%"
                },
                {
                    "layer": 10,
                    "value": "本技能的“罡体”状态提升的物理及法术防御力额外增加45%"
                }],
                "require": {
                    "books": "中级罡体卷一*佑",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“罡体”状态,神佑系无双增长速度提升5%（同类效果无法共存）"
                },
                {
                    "layer": 14,
                    "value": "“罡体”状态,神佑系无双增长速度提升10%（同类效果无法共存）"
                },
                {
                    "layer": 15,
                    "value": "“罡体”状态,神佑系无双增长速度提升15%（同类效果无法共存）"
                }],
                "require": {
                    "books": "高级罡体卷一*佑",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "“罡体”状态,提升1%额外破防抵抗率"
                },
                {
                    "layer": 14,
                    "value": "“罡体”状态,提升1%额外破防抵抗率"
                },
                {
                    "layer": 15,
                    "value": "“罡体”状态,提升1%额外破防抵抗率"
                }],
                "require": {
                    "books": "高级罡体卷二*佑",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "龙握",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_69f176a5-2841-4a7b-b1b3-d311f75968e6_1111",
        "skillDescribe": {
            "main": "强行将目标敌方拉向自己，并造成伤害",
            "static": ["打断目标技能的吟唱或引导过程，强行将目标拉到自己身边", "造成物理伤害"],
            "addition": [],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "使本技能造成的物理伤害提高25%"
                },
                {
                    "layer": 4,
                    "value": "使本技能造成的物理伤害提高50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能有50%的概率对“流血”的目标造成“迟钝”效果,无法使用轻功,持续2秒"
                },
                {
                    "layer": 9,
                    "value": "本技能有100%的概率对“流血”的目标造成“迟钝”效果,无法使用轻功,持续2秒"
                }],
                "require": {
                    "books": "中级龙握卷一*罚",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在雷罡体状态下,本技能会随机封印目标1个技能,持续5秒"
                },
                {
                    "layer": 14,
                    "value": "在雷罡体状态下,本技能会随机封印目标2个技能,持续5秒"
                },
                {
                    "layer": 15,
                    "value": "在雷罡体状态下,本技能会随机封印目标3个技能,持续5秒"
                }],
                "require": {
                    "books": "高级龙握卷一*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能的最远射程提高1米"
                },
                {
                    "layer": 14,
                    "value": "本技能的最远射程提高3米"
                },
                {
                    "layer": 15,
                    "value": "本技能的最远射程提高5米"
                }],
                "require": {
                    "books": "高级龙握卷二*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "59"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级龙握卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能有50%的概率迫使怪物5秒内强制攻击自己"
                },
                {
                    "layer": 4,
                    "value": "本技能有100%的概率迫使怪物5秒内强制攻击自己"
                }],
                "require": {
                    "books": "初级龙握卷一*佑",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在罡体状态下,本技能使目标的物理攻击力降低6%,持续3秒"
                },
                {
                    "layer": 9,
                    "value": "在罡体状态下,本技能使目标的物理攻击力降低12%,持续3秒"
                },
                {
                    "layer": 10,
                    "value": "在罡体状态下,本技能使目标的物理攻击力降低20%,持续3秒"
                }],
                "require": {
                    "books": "中级龙握卷一*佑",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在罡体状态下,本技能会随机封印目标1个技能,持续5秒"
                },
                {
                    "layer": 14,
                    "value": "在罡体状态下,本技能会随机封印目标2个技能,持续5秒"
                },
                {
                    "layer": 15,
                    "value": "在罡体状态下,本技能会随机封印目标3个技能,持续5秒"
                }],
                "require": {
                    "books": "高级龙握卷一*佑",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能施放后,将自身牵引至敌人身前,并造成敌人“定身”1秒"
                },
                {
                    "layer": 14,
                    "value": "本技能施放后,将自身牵引至敌人身前,并造成敌人“定身”2秒"
                }],
                "require": {
                    "books": "高级龙握卷二*佑",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "铁血",
        "skillProperty": ["辅助技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_3784085c-2582-418b-9019-a0ad3c245e08_1113",
        "skillDescribe": {
            "main": "增加自身和周围队友的生命上限",
            "static": [],
            "addition": [{
                "initiative": "自身获得铁血效果，持续600秒",
                "passivity": "增加自身生命值上限，受到的治疗效果提升20%"
            },
            {
                "initiative": "队友获得铁血效果，持续600秒",
                "passivity": "增加周围队友生命上限"
            }],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "“铁血”状态对自身提升的生命上限效果提高10%"
                },
                {
                    "layer": 4,
                    "value": "“铁血”状态对自身提升的生命上限效果提高20%"
                },
                {
                    "layer": 5,
                    "value": "“铁血”状态对自身提升的生命上限效果提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能施放后,使自身及30米范围内的队友物理攻击力提高5%,持续5秒"
                },
                {
                    "layer": 9,
                    "value": "本技能施放后,使自身及30米范围内的队友物理攻击力提高10%,持续5秒"
                },
                {
                    "layer": 10,
                    "value": "本技能施放后,使自身及30米范围内的队友物理攻击力提高15%,持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在雷罡体状态下,本技能施放后,使自身及30米范围内的队友获得4%的“吸血”效果,持续5秒"
                },
                {
                    "layer": 14,
                    "value": "在雷罡体状态下,本技能施放后,使自身及30米范围内的队友获得8%的“吸血”效果,持续5秒"
                },
                {
                    "layer": 15,
                    "value": "在雷罡体状态下,本技能施放后,使自身及30米范围内的队友获得12%的“吸血”效果,持续5秒"
                }],
                "require": {
                    "books": "高级铁血卷一*罚",
                    "preNum": 3,
                    "totolNum": 6,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "“铁血”状态对自身提升的生命上限效果提高10%"
                },
                {
                    "layer": 4,
                    "value": "“铁血”状态对自身提升的生命上限效果提高20%"
                },
                {
                    "layer": 5,
                    "value": "“铁血”状态对自身提升的生命上限效果提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能施放后,使自身及30米范围内的队友每秒回复0.2%生命上限,持续10秒"
                },
                {
                    "layer": 9,
                    "value": "本技能施放后,使自身及30米范围内的队友每秒回复0.4%生命上限,持续10秒"
                },
                {
                    "layer": 10,
                    "value": "本技能施放后,使自身及30米范围内的队友每秒回复0.6%生命上限,持续10秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "自身处于“铁血”状态且血量低于20%时,自动触发生命恢复效果,每2秒回复1%生命上限,持续10秒,触发间隔2分钟"
                },
                {
                    "layer": 14,
                    "value": "自身处于“铁血”状态且血量低于20%时,自动触发生命恢复效果,每2秒回复2%生命上限,持续10秒,触发间隔2分钟"
                },
                {
                    "layer": 15,
                    "value": "自身处于“铁血”状态且血量低于20%时,自动触发生命恢复效果,每2秒回复3%生命上限,持续10秒,触发间隔2分钟"
                }],
                "require": {
                    "books": "高级铁血卷一*佑",
                    "preNum": 3,
                    "totolNum": 6,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "“铁血”状态对自身受到的治疗效果提升至25%"
                },
                {
                    "layer": 9,
                    "value": "“铁血”状态对自身受到的治疗效果提升至30%"
                }],
                "require": {
                    "books": "中级铁血卷二*佑",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "59"
                }
            },
            {}]]
        }
    },
    {
        "skillName": "啸天",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9a43e99a-fd4d-4204-99be-195301b7f77c_1116",
        "skillDescribe": {
            "main": "解除控制并进入霸体状态，持续3秒",
            "static": ["解除自身控制状态"],
            "addition": [{
                "initiative": "进入霸体状态",
                "passivity": "免除所有控制效果"
            }],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能使自身的获得的“霸体”状态额外获得移动速度提高15%"
                },
                {
                    "layer": 4,
                    "value": "本技能使自身的获得的“霸体”状态额外获得移动速度提高30%"
                },
                {
                    "layer": 4,
                    "value": "本技能使自身的获得的“霸体”状态额外获得移动速度提高50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能使自身的获得的“霸体”状态时间延长0.5秒"
                },
                {
                    "layer": 9,
                    "value": "本技能使自身的获得的“霸体”状态时间延长1秒"
                },
                {
                    "layer": 10,
                    "value": "本技能使自身的获得的“霸体”状态时间延长2秒"
                }],
                "require": {
                    "books": "中级啸天卷一*罚",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,啸天的冷却时间降低1秒,该效果每3秒最多触发一次"
                },
                {
                    "layer": 14,
                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,啸天的冷却时间降低3秒,该效果每3秒最多触发一次"
                },
                {
                    "layer": 15,
                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,啸天的冷却时间降低5秒,该效果每3秒最多触发一次"
                }],
                "require": {
                    "books": "高级啸天卷一*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级啸天卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能使自身的获得的“霸体”状态额外增加自身5%的物理和法术防御力"
                },
                {
                    "layer": 4,
                    "value": "本技能使自身的获得的“霸体”状态额外增加自身10%的物理和法术防御力"
                },
                {
                    "layer": 5,
                    "value": "本技能使自身的获得的“霸体”状态额外增加自身15%的物理和法术防御力"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在“霸体”状态下,躲闪率增加自身5%"
                },
                {
                    "layer": 9,
                    "value": "在“霸体”状态下,躲闪率增加自身10%"
                },
                {
                    "layer": 10,
                    "value": "在“霸体”状态下,躲闪率增加自身15%"
                }],
                "require": {
                    "books": "中级啸天卷一*佑",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,立即回复3%生命上限,该效果每5秒最多触发一次"
                },
                {
                    "layer": 14,
                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,立即回复6%生命上限,该效果每5秒最多触发一次"
                },
                {
                    "layer": 15,
                    "value": "在“霸体”状态下,自身被敌人造成暴击伤害时,立即回复10%生命上限,该效果每5秒最多触发一次"
                }],
                "require": {
                    "books": "高级啸天卷一*佑",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "光盾",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_35079a1f-9fba-4ead-9b24-38d84905ac3d_1106",
        "skillDescribe": {
            "main": "只有开启罡体或者雷罡体时使用，可以开启光盾",
            "static": ["光盾可以吸收自身受到的伤害，开启光盾时无法使用猛击以外的其他技能", "再次使用或持续时间结束会触发光盾反击，造成物理伤害"],
            "addition": [{
                "initiative": "获得光盾效果3秒",
                "passivity": "最多吸收自身受到的伤害"
            }],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "在雷罡体状态下，光盾反击的伤害提高15%"
                },
                {
                    "layer": 4,
                    "value": "在雷罡体状态下，光盾反击的伤害提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在雷罡体状态下,光盾反击造成的伤害额外附加自身力量*5的伤害"
                },
                {
                    "layer": 9,
                    "value": "在雷罡体状态下,光盾反击造成的伤害额外附加自身力量*10的伤害"
                },
                {
                    "layer": 10,
                    "value": "在雷罡体状态下,光盾反击造成的伤害额外附加自身力量*15的伤害"
                }],
                "require": {
                    "books": "中级光盾卷一*罚",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在雷罡体状态下,光盾反击有15%的概率对敌人“击倒”2秒"
                },
                {
                    "layer": 14,
                    "value": "在雷罡体状态下,光盾反击有30%的概率对敌人“击倒”2秒"
                },
                {
                    "layer": 15,
                    "value": "在雷罡体状态下,光盾反击有50%的概率对敌人“击倒”2秒"
                }],
                "require": {
                    "books": "高级光盾卷一*罚",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "在罡体状态下,光盾吸收的伤害提高15%"
                },
                {
                    "layer": 4,
                    "value": "在罡体状态下,光盾吸收的伤害提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在罡体状态下,光盾受到来自怪物的攻击会减低13%的折损量"
                },
                {
                    "layer": 9,
                    "value": "在罡体状态下,光盾受到来自怪物的攻击会减低23%的折损量"
                },
                {
                    "layer": 10,
                    "value": "在罡体状态下,光盾受到来自怪物的攻击会减低30%的折损量"
                }],
                "require": {
                    "books": "中级光盾卷一*佑",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在罡体状态下,使用本技能后3秒内可将30米范围内队友所受的伤害的10%吸收为自身伤害"
                },
                {
                    "layer": 14,
                    "value": "在罡体状态下,使用本技能后3秒内可将30米范围内队友所受的伤害的20%吸收为自身伤害"
                },
                {
                    "layer": 15,
                    "value": "在罡体状态下,使用本技能后3秒内可将30米范围内队友所受的伤害的30%吸收为自身伤害"
                }],
                "require": {
                    "books": "高级光盾卷一*佑",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "使光盾只能吸收法术伤害，吸收量提高50%"
                },
                {
                    "layer": 9,
                    "value": "使光盾只能吸收法术伤害，吸收量提高100%"
                },
                {
                    "layer": 10,
                    "value": "使光盾只能吸收法术伤害，吸收量提高150%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}]]
        }
    },
    {
        "skillName": "无畏",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_37d87ecd-9496-4285-ae37-2a5267a29b5d_1114",
        "skillDescribe": {
            "main": "提升自身防御力和攻击力，持续5秒",
            "static": [],
            "addition": [{
                "initiative": "自身获得进入无畏状态",
                "passivity": "提升自身20%攻击力和防御力"
            },
            {
                "initiative": "罡体状态下使用进入无畏-护状态",
                "passivity": "降低自身50%攻击力，提升30%伤害减免率，与绝对守护的减伤效果无法叠加，同时存在则取两者中最强的减伤效果"
            },
            {
                "initiative": "雷罡体状态下使用进入无畏-破状态",
                "passivity": "受到的伤害额外增加30%，提升50%攻击力"
            }],
            "trainingName": ["罚", "悟", "佑"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "在雷罡体状态下,“无畏*破”持续期间的暴击力提升10%"
                },
                {
                    "layer": 4,
                    "value": "在雷罡体状态下,“无畏*破”持续期间的暴击力提升20%"
                },
                {
                    "layer": 5,
                    "value": "在雷罡体状态下,“无畏*破”持续期间的暴击力提升30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在雷罡体状态下,“无畏・破”持续期间对怪物的伤害提高20%"
                },
                {
                    "layer": 9,
                    "value": "在雷罡体状态下,“无畏・破”持续期间对怪物的伤害提高40%"
                },
                {
                    "layer": 10,
                    "value": "在雷罡体状态下,“无畏・破”持续期间对怪物的伤害提高60%"
                }],
                "require": {
                    "books": "中级无畏卷一*罚",
                    "preNum": 3,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在雷罡体状态下,自身在“无畏*破”持续期间对敌人造成暴击后,无畏的冷却时间降低1秒,该效果每5秒最多触发一次"
                },
                {
                    "layer": 14,
                    "value": "在雷罡体状态下,自身在“无畏*破”持续期间对敌人造成暴击后,无畏的冷却时间降低2秒,该效果每5秒最多触发一次"
                },
                {
                    "layer": 15,
                    "value": "在雷罡体状态下,自身在“无畏*破”持续期间对敌人造成暴击后,无畏的冷却时间降低3秒,该效果每5秒最多触发一次"
                }],
                "require": {
                    "books": "高级无畏卷一*罚",
                    "preNum": 3,
                    "totolNum": 6,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "在雷罡体状态下,损耗自身3%的最大生命上限的血量，立即获得10点天罚系无双值"
                },
                {
                    "layer": 9,
                    "value": "在雷罡体状态下,损耗自身3%的最大生命上限的血量，立即获得15点天罚系无双值"
                },
                {
                    "layer": 10,
                    "value": "在雷罡体状态下,损耗自身3%的最大生命上限的血量，立即获得20点天罚系无双值"
                }],
                "require": {
                    "books": "中级无畏卷二*罚",
                    "preNum": 0,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "在罡体状态下,“无畏*护”持续期间被暴击的概率下降15%"
                },
                {
                    "layer": 4,
                    "value": "在罡体状态下,“无畏*护”持续期间被暴击的概率下降25%"
                },
                {
                    "layer": 5,
                    "value": "在罡体状态下,“无畏*护”持续期间被暴击的概率下降40%"
                }],
                "require": {
                    "books": "初级无畏卷一*佑",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "在罡体状态下,“无畏*护”持续期间的自身受到的治疗效果提升15%"
                },
                {
                    "layer": 9,
                    "value": "在罡体状态下,“无畏*护”持续期间的自身受到的治疗效果提升30%"
                },
                {
                    "layer": 10,
                    "value": "在罡体状态下,“无畏*护”持续期间的自身受到的治疗效果提升45%"
                }],
                "require": {
                    "books": "中级无畏卷一*佑",
                    "preNum": 3,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在罡体状态下,自身在“无畏*护”持续期间被敌人造成暴击伤害时,无畏的冷却时间降低1秒,该效果每3秒最多触发一次"
                },
                {
                    "layer": 14,
                    "value": "在罡体状态下,自身在“无畏*护”持续期间被敌人造成暴击伤害时,无畏的冷却时间降低3秒,该效果每3秒最多触发一次"
                },
                {
                    "layer": 15,
                    "value": "在罡体状态下,自身在“无畏*护”持续期间被敌人造成暴击伤害时,无畏的冷却时间降低5秒,该效果每3秒最多触发一次"
                }],
                "require": {
                    "books": "高级无畏卷一*佑",
                    "preNum": 3,
                    "totolNum": 6,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "在罡体状态下,损耗自身3%的最大生命上限的血量，立即获得10点神佑系无双值"
                },
                {
                    "layer": 9,
                    "value": "在罡体状态下,损耗自身3%的最大生命上限的血量，立即获得15点神佑系无双值"
                },
                {
                    "layer": 10,
                    "value": "在罡体状态下,损耗自身3%的最大生命上限的血量，立即获得20点神佑系无双值"
                }],
                "require": {
                    "books": "中级无畏卷二*佑",
                    "preNum": 0,
                    "totolNum": 3,
                    "line": "59"
                }
            },
            {}]]
        }
    }],
    "linglong": [{
        "skillName": "灵击",
        "skillProperty": ["法术技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_01d54635-2a5c-4c9a-9366-a2867466a782_1401",
        "skillDescribe": {
            "main": "对敌方单体造成少量伤害",
            "static": ["对敌方造成念系伤害"],
            "addition": [],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成法术伤害提高4%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成法术伤害提高8%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "对“飞萤之痛”状态下敌人额外伤害提升7%"
                },
                {
                    "layer": 9,
                    "value": "对“飞萤之痛”状态下敌人额外伤害提升14%"
                }],
                "require": {
                    "books": "中级灵击卷一*魂",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "当目标身上有“飞萤之痛”状态时,则有10%概率将该状态传染给附近的1个敌人"
                },
                {
                    "layer": 14,
                    "value": "当目标身上有“飞萤之痛”状态时,则有20%概率将该状态传染给附近的1个敌人"
                },
                {
                    "layer": 15,
                    "value": "当目标身上有“飞萤之痛”状态时,则有30%概率将该状态传染给附近的1个敌人"
                }],
                "require": {
                    "books": "高级灵击卷一*魂",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的法术伤害额外提高6%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的法术伤害额外提高12%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能有10%的概率额外增长1个魂气"
                },
                {
                    "layer": 9,
                    "value": "本技能有20%的概率额外增长1个魂气"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对处于“缚足”、“冰冻”和“晕眩”的敌人造成的伤害提高6%"
                },
                {
                    "layer": 4,
                    "value": "本技能对处于“缚足”、“冰冻”和“晕眩”的敌人造成的伤害提高12%"
                },
                {
                    "layer": 5,
                    "value": "本技能对处于“缚足”、“冰冻”和“晕眩”的敌人造成的伤害提高18%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对敌人造成伤害后,立即回复自身1%基础治疗能力的法力值"
                },
                {
                    "layer": 9,
                    "value": "本技能对敌人造成伤害后,立即回复自身2%基础治疗能力的法力值"
                },
                {
                    "layer": 10,
                    "value": "本技能对敌人造成伤害后,立即回复自身3%基础治疗能力的法力值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对敌人造成暴击伤害后,额外获得1点巧语系无双值"
                },
                {
                    "layer": 14,
                    "value": "本技能对敌人造成暴击伤害后,额外获得2点巧语系无双值"
                },
                {
                    "layer": 15,
                    "value": "本技能对敌人造成暴击伤害后,额外获得3点巧语系无双值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "飞萤",
        "skillProperty": ["法术技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_0c95f8ab-e93e-4004-9f1d-0d2dd4bef693_1406",
        "skillDescribe": {
            "main": "对敌方单体施加<em class='green'>飞莹之痛</em>状态，不可被驱除",
            "static": ["每<em class='green'>2</em>秒造成一次魂系伤害，持续<em class='green'>6</em>秒，不可被驱除"],
            "addition": [{
                "initiative": "敌方获得<em class='green'>飞莹之痛</em>状态",
                "passivity": "飞莹之痛：持续受到飞莹折磨，损失生命值"
            },
            {
                "initiative": "敌方获得<em class='green'>飞莹之伤</em>状态",
                "passivity": "飞莹之痛：使敌人受到的伤害提高2%"
            }],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的“飞萤之痛”和“飞萤之伤”效果持续时间提高2秒"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的“飞萤之痛”和“飞萤之伤”效果持续时间提高4秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的“飞萤之痛”和“飞萤之伤”效果最多可叠加2层"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的“飞萤之痛”和“飞萤之伤”效果最多可叠加3层"
                },
                {
                    "layer": 10,
                    "value": "本技能造成的“飞萤之痛”和“飞萤之伤”效果最多可叠加4层"
                }],
                "require": {
                    "preNum": 2,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能造成的“飞萤之痛”效果伤害提高10%"
                },
                {
                    "layer": 14,
                    "value": "本技能造成的“飞萤之痛”效果伤害提高20%"
                },
                {
                    "layer": 15,
                    "value": "本技能造成的“飞萤之痛”效果伤害提高30%"
                }],
                "require": {
                    "books": "高级飞莹卷一*魂",
                    "preNum": 3,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "消耗2点魂气，使飞萤可以瞬间造成60%基础法术攻击力的法术伤害"
                },
                {
                    "layer": 14,
                    "value": "消耗2点魂气，使飞萤可以瞬间造成120%基础法术攻击力的法术伤害"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级飞莹卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的法术防御力降低1%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的法术防御力降低2%"
                },
                {
                    "layer": 5,
                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的法术防御力降低3%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的轻功回复速度降低5%"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的轻功回复速度降低10%"
                }],
                "require": {
                    "books": "中级飞莹卷一*灵",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的暴击力降低3%"
                },
                {
                    "layer": 14,
                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的暴击力降低4%"
                },
                {
                    "layer": 15,
                    "value": "本技能造成的“飞萤之痛”状态每一层都使目标的暴击力降低5%"
                }],
                "require": {
                    "books": "高级飞莹卷一*灵",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "青鸟",
        "skillProperty": ["法术技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_1d521290-0a1e-478d-aa9c-60b11f3353fc_1402",
        "skillDescribe": {
            "main": "对敌方及其周围单位造成伤害",
            "static": ["对敌方造成魂系伤害"],
            "addition": [],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的法术伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的法术伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对“飞萤之痛”的目标造成的伤害额外提升3%*“飞萤之痛”层数"
                },
                {
                    "layer": 9,
                    "value": "本技能对“飞萤之痛”的目标造成的伤害额外提升5%*“飞萤之痛”层数"
                }],
                "require": {
                    "books": "中级青鸟卷一*魂",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "提高0.5秒吟唱时间,使本技能造成的法术伤害提高25%"
                },
                {
                    "layer": 14,
                    "value": "提高1秒吟唱时间,使本技能造成的法术伤害提高50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 8,
                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
                },
                {
                    "layer": 9,
                    "value": "本技能对怪物造成的法术伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "消耗2点魂气，提高20%的技能伤害"
                },
                {
                    "layer": 14,
                    "value": "消耗2点魂气，提高40%的技能伤害"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "当目标身上有“飞萤之痛”状态时,则有10%概率将该状态传染给周围的敌人"
                },
                {
                    "layer": 4,
                    "value": "当目标身上有“飞萤之痛”状态时,则有20%概率将该状态传染给周围的敌人"
                },
                {
                    "layer": 5,
                    "value": "当目标身上有“飞萤之痛”状态时,则有30%概率将该状态传染给周围的敌人"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对处于“鱼跃”伤害范围中的敌人有25%的概率造成“迟钝”效果,无法使用轻功,持续2秒"
                },
                {
                    "layer": 9,
                    "value": "本技能对处于“鱼跃”伤害范围中的敌人有50%的概率造成“迟钝”效果,无法使用轻功,持续2秒"
                },
                {
                    "layer": 10,
                    "value": "本技能对处于“鱼跃”伤害范围中的敌人有75%的概率造成“迟钝”效果,无法使用轻功,持续2秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能施放后可立即再次施放青鸟技能,造成该技能30%的伤害,且不需要吟唱"
                },
                {
                    "layer": 14,
                    "value": "本技能施放后可立即再次施放青鸟技能,造成该技能60%的伤害,且不需要吟唱"
                },
                {
                    "layer": 15,
                    "value": "本技能施放后可立即再次施放青鸟技能,造成该技能100%的伤害,且不需要吟唱"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能对处于“鱼跃”伤害范围中的敌人有12%的概率造成“晕眩”效果,持续2秒"
                },
                {
                    "layer": 14,
                    "value": "本技能对处于“鱼跃”伤害范围中的敌人有25%的概率造成“晕眩”效果,持续2秒"
                }],
                "require": {
                    "books": "高级青鸟卷二*灵",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "春风",
        "skillProperty": ["回复技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a8d41be1-6c5c-4e9e-85e5-fb67022e7889_1411",
        "skillDescribe": {
            "main": "治疗自身或友方单体，恢复少量生命值",
            "static": ["回复自身或友方的生命值"],
            "addition": [{
                "initiative": "使目标获得<em class='green'>如沐春风</em>状态，持续<em class='green'>10</em>秒，最多叠加<em class='green'>3</em>层",
                "passivity": "如沐春风：状态时间内每2秒回复一次生命值"
            }],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的直接治疗效果提升10%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的直接治疗效果提升20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "每一层“如沐春风”状态的生命上限回复效果增加10%"
                },
                {
                    "layer": 9,
                    "value": "每一层“如沐春风”状态的生命上限回复效果增加20%"
                },
                {
                    "layer": 10,
                    "value": "每一层“如沐春风”状态的生命上限回复效果增加30%"
                }],
                "require": {
                    "books": "中级春风卷一*魂",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“如沐春风”状态的最多叠加层数增加1层"
                },
                {
                    "layer": 14,
                    "value": "“如沐春风”状态的最多叠加层数增加2层"
                }],
                "require": {
                    "books": "高级春风卷一*魂",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能有25%的概率额外增长1个灵气"
                },
                {
                    "layer": 9,
                    "value": "本技能有50%的概率额外增长1个灵气"
                }],
                "require": {
                    "books": "中级春风卷二*魂",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "每一层“如沐春风”状态都会使目标的物理及法术防御力提升1%"
                },
                {
                    "layer": 4,
                    "value": "每一层“如沐春风”状态都会使目标的物理及法术防御力提升2%"
                },
                {
                    "layer": 5,
                    "value": "每一层“如沐春风”状态都会使目标的物理及法术防御力提升3%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能施放时有25%概率降低青蔓的冷却时间1秒"
                },
                {
                    "layer": 9,
                    "value": "本技能施放时有50%概率降低青蔓的冷却时间1秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "当自身处于“如沐春风”状态且受到暴击伤害时,自动触发“春风护体”效果,受到的物理伤害会降低20%,持续5秒,触发间隔90秒"
                },
                {
                    "layer": 14,
                    "value": "当自身处于“如沐春风”状态且受到暴击伤害时,自动触发“春风护体”效果,受到的物理伤害会降低20%,持续5秒,触发间隔60秒"
                },
                {
                    "layer": 15,
                    "value": "当自身处于“如沐春风”状态且受到暴击伤害时,自动触发“春风护体”效果,受到的物理伤害会降低20%,持续5秒,触发间隔30秒"
                }],
                "require": {
                    "books": "高级春风卷一*灵",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能的射程增加3米"
                },
                {
                    "layer": 4,
                    "value": "本技能的射程增加5米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "鱼跃",
        "skillProperty": ["法术技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_2cff711a-1e29-4c84-a9bb-c48533a72b5a_1405",
        "skillDescribe": {
            "main": "<em class='green'>5</em>秒内持续对指定区域内所有敌方造成缚足和伤害",
            "static": ["每秒对区域内敌方造成魂系伤害"],
            "addition": [{
                "initiative": "区域内所有敌方获得<em class='green'>缚足</em>状态",
                "passivity": "缚足：移动速度降低50%"
            }],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的法术伤害提高5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的法术伤害提高10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能有50%概率立即结算敌人身上所有“飞萤之痛”的剩余伤害"
                },
                {
                    "layer": 9,
                    "value": "本技能有100%概率立即结算敌人身上所有“飞萤之痛”的剩余伤害"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "提高0.5秒吟唱时间,使本技能造成的法术伤害提高25%"
                },
                {
                    "layer": 14,
                    "value": "提高1秒吟唱时间,使本技能造成的法术伤害提高50%"
                }],
                "require": {
                    "books": "高级鱼跃卷一*魂",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的法术伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的法术伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "消耗2点魂气，使鱼跃首次可以额外造成100%基础法术攻击力的法术伤害"
                },
                {
                    "layer": 14,
                    "value": "消耗2点魂气，使鱼跃首次可以额外造成200%基础法术攻击力的法术伤害"
                }],
                "require": {
                    "books": "高级鱼跃卷二*魂",
                    "preNum": 0,
                    "totolNum": 5,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级鱼跃卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "5秒内再次使用技能可以引爆鱼灵,范围内敌方同时获得冰冻和迟钝效果，3秒内无法移动、无法施法、无法使用轻功（解控技能也只能解除冰冻效果，无法解除迟钝效果）"
                }],
                "require": {
                    "books": "初级鱼跃卷一*灵",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "引爆鱼灵造成的“冰冻”、“迟钝”效果时间延长1秒"
                },
                {
                    "layer": 9,
                    "value": "引爆鱼灵造成的“冰冻”、“迟钝”效果时间延长2秒"
                }],
                "require": {
                    "books": "中级鱼跃卷一*灵",
                    "preNum": 1,
                    "totolNum": 1,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "引爆鱼灵有8%概率造成的“深度冰冻”效果,不会被攻击后解除"
                },
                {
                    "layer": 14,
                    "value": "引爆鱼灵有16%概率造成的“深度冰冻”效果,不会被攻击后解除"
                },
                {
                    "layer": 15,
                    "value": "引爆鱼灵有25%概率造成的“深度冰冻”效果,不会被攻击后解除"
                }],
                "require": {
                    "preNum": 2,
                    "totolNum": 3,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "在鱼跃范围内的敌人造成“偏斜”效果,命中率下降15%"
                },
                {
                    "layer": 9,
                    "value": "在鱼跃范围内的敌人造成“偏斜”效果,命中率下降30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 1,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在鱼跃范围内的敌人造成“盲目”效果,技能射程降低30%"
                },
                {
                    "layer": 14,
                    "value": "在鱼跃范围内的敌人造成“盲目”效果,技能射程降低50%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 3,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "落樱",
        "skillProperty": ["回复技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a11a6a7c-22ef-43c4-8cc3-51ca817d5968_1413",
        "skillDescribe": {
            "main": "治疗自身或友方单体，回复生命值",
            "static": ["回复自身或友方单位大量生命值"],
            "addition": [],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的治疗效果提升5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的治疗效果提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对处于“如沐春风”状态的目标造成的治疗效果提升3%*“如沐春风”层数"
                },
                {
                    "layer": 9,
                    "value": "本技能对处于“如沐春风”状态的目标造成的治疗效果提升5%*“如沐春风”层数"
                }],
                "require": {
                    "books": "中级落樱卷一*魂",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高20%"
                },
                {
                    "layer": 14,
                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高40%"
                }],
                "require": {
                    "books": "高级落樱卷一*魂",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能有25%的概率额外增长1个灵气"
                },
                {
                    "layer": 9,
                    "value": "本技能有50%的概率额外增长1个灵气"
                }],
                "require": {
                    "books": "中级落樱卷二*魂",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "消耗2点灵气，提高20%的回复量"
                },
                {
                    "layer": 14,
                    "value": "消耗2点灵气，提高40%的回复量"
                }],
                "require": {
                    "books": "高级落樱卷二*魂",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对目标附加“润体”状态,受到的物理伤害降低10%,持续3秒"
                },
                {
                    "layer": 4,
                    "value": "本技能对目标附加“润体”状态,受到的物理伤害降低10%,持续4秒"
                },
                {
                    "layer": 5,
                    "value": "本技能对目标附加“润体”状态,受到的物理伤害降低10%,持续5秒"
                }],
                "require": {
                    "books": "初级落樱卷一*灵",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升10%"
                },
                {
                    "layer": 9,
                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升20%"
                },
                {
                    "layer": 10,
                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升30%"
                }],
                "require": {
                    "books": "中级落樱卷一*灵",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能的吟唱时间降低0.5秒"
                },
                {
                    "layer": 14,
                    "value": "本技能的吟唱时间降低1秒"
                }],
                "require": {
                    "books": "高级落樱卷一*灵",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能的射程增加3米"
                },
                {
                    "layer": 4,
                    "value": "本技能的射程增加5米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "青蔓",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a17430c3-edba-4ddb-a205-f342f2a1ab97_1412",
        "skillDescribe": {
            "main": "治疗自身和周围队友，恢复生命值",
            "static": ["同时恢复自身和队友的生命值", "可以扩散自身最多<em class='green'>1</em>层<em class='green'>如沐春风</em>状态给周围队友"],
            "addition": [],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的治疗效果提升5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的治疗效果提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能扩散的“如沐春风”状态同时最多可扩散2层"
                },
                {
                    "layer": 9,
                    "value": "本技能扩散的“如沐春风”状态同时最多可扩散3层"
                },
                {
                    "layer": 10,
                    "value": "本技能扩散的“如沐春风”状态同时最多可扩散4层"
                }],
                "require": {
                    "books": "中级青蔓卷一*魂",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高10%"
                },
                {
                    "layer": 14,
                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高20%"
                }],
                "require": {
                    "books": "高级青蔓卷一*魂",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高10%"
                },
                {
                    "layer": 9,
                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高20%"
                },
                {
                    "layer": 10,
                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高10%"
                },
                {
                    "layer": 14,
                    "value": "若目标的生命上限低于30%时,本技能对其造成的治疗效果额外提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能使用后自身的移动速度提高30%,持续3秒"
                },
                {
                    "layer": 4,
                    "value": "本技能使用后自身的移动速度提高40%,持续3秒"
                },
                {
                    "layer": 5,
                    "value": "本技能使用后自身的移动速度提高50%,持续3秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能使用后立即恢复自身和周围队友10点轻功值"
                },
                {
                    "layer": 9,
                    "value": "本技能使用后立即恢复自身和周围队友15点轻功值"
                },
                {
                    "layer": 10,
                    "value": "本技能使用后立即恢复自身和周围队友20点轻功值"
                }],
                "require": {
                    "books": "中级青蔓卷一*灵",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "消耗2点灵气，提高20%的回复量"
                },
                {
                    "layer": 14,
                    "value": "消耗2点灵气，提高40%的回复量"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能使用后有50%概率立即驱散自身和周围队友1个负面状态"
                },
                {
                    "layer": 4,
                    "value": "本技能使用后有100%概率立即驱散自身和周围队友1个负面状态"
                }],
                "require": {
                    "books": "初级青蔓卷二*灵",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "羽化",
        "skillProperty": ["回复技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_02d9de50-e4ac-48b3-8b88-b5e5df38b028_1414",
        "skillDescribe": {
            "main": "复活友方单位并回复该单位部分生命值和法力值",
            "static": ["复活一个友方死亡目标，回复10%生命值和5%法力值"],
            "addition": [],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "降低10%羽化施法的法力值消耗"
                },
                {
                    "layer": 4,
                    "value": "降低20%羽化施法的法力值消耗"
                },
                {
                    "layer": 5,
                    "value": "降低30%羽化施法的法力值消耗"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "复活后的友方拥有的法力值额外增加5%"
                },
                {
                    "layer": 9,
                    "value": "复活后的友方拥有的法力值额外增加10%"
                },
                {
                    "layer": 10,
                    "value": "复活后的友方拥有的法力值额外增加15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "复活后的友方拥有的生命上限额外增加5%"
                },
                {
                    "layer": 14,
                    "value": "复活后的友方拥有的生命上限额外增加10%"
                },
                {
                    "layer": 15,
                    "value": "复活后的友方拥有的生命上限额外增加15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "降低30%羽化*灵施法的法力值消耗"
                },
                {
                    "layer": 4,
                    "value": "降低50%羽化*灵施法的法力值消耗"
                },
                {
                    "layer": 5,
                    "value": "降低70%羽化*灵施法的法力值消耗"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "羽化的冷却时间缩短10秒"
                },
                {
                    "layer": 9,
                    "value": "羽化的冷却时间缩短20秒"
                },
                {
                    "layer": 10,
                    "value": "羽化的冷却时间缩短30秒"
                }],
                "require": {
                    "books": "中级羽化卷一*灵",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "羽化的吟唱时间缩短0.5秒"
                },
                {
                    "layer": 14,
                    "value": "羽化的吟唱时间缩短1秒"
                },
                {
                    "layer": 15,
                    "value": "羽化的吟唱时间缩短1.5秒"
                }],
                "require": {
                    "books": "高级羽化卷一*灵",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "羽化的射程增加5米"
                },
                {
                    "layer": 4,
                    "value": "羽化的射程增加10米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "白露",
        "skillProperty": ["回复技能", "引导技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_21f97f59-dd7c-476f-97bd-ea1d229bbc0d_1416",
        "skillDescribe": {
            "main": "<em class='green'>3</em>秒内持续恢复目标友方的生命值",
            "static": ["每秒内恢复1次目标友方的生命值"],
            "addition": [],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的治疗效果提升5%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的治疗效果提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能可对除目标外周围10米内1个队友造成50%的回复效果"
                },
                {
                    "layer": 9,
                    "value": "本技能可对除目标外周围10米内2个队友造成50%的回复效果"
                },
                {
                    "layer": 10,
                    "value": "本技能可对除目标外周围10米内3个队友造成50%的回复效果"
                }],
                "require": {
                    "books": "中级白露卷一*魂",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能每次治疗都会给自身附加“露泽”状态,使自身的治疗能力提高2%,持续5秒,可叠加"
                },
                {
                    "layer": 14,
                    "value": "本技能每次治疗都会给自身附加“露泽”状态,使自身的治疗能力提高4%,持续5秒,可叠加"
                },
                {
                    "layer": 15,
                    "value": "本技能每次治疗都会给自身附加“露泽”状态,使自身的治疗能力提高6%,持续5秒,可叠加"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "每次引导消耗1点灵气，造成的治疗效果额外提高20%"
                },
                {
                    "layer": 14,
                    "value": "每次引导消耗1点灵气，造成的治疗效果额外提高40%"
                }],
                "require": {
                    "books": "高级白露卷二*魂",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能施放期间,自身受到的伤害降低3%"
                },
                {
                    "layer": 4,
                    "value": "本技能施放期间,自身受到的伤害降低6%"
                },
                {
                    "layer": 5,
                    "value": "本技能施放期间,自身受到的伤害降低9%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升10%"
                },
                {
                    "layer": 9,
                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升20%"
                },
                {
                    "layer": 10,
                    "value": "本技能对于处在“断筋”“昏迷”“击倒”状态中的目标治疗效果额外提升30%"
                }],
                "require": {
                    "books": "中级白露卷一*灵",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "对其他友方使用此技能时，会同时对自己造成70%基础治疗能力的治疗效果"
                },
                {
                    "layer": 14,
                    "value": "对其他友方使用此技能时，会同时对自己造成140%基础治疗能力的治疗效果"
                }],
                "require": {
                    "books": "高级白露卷一*灵",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能的射程增加3米"
                },
                {
                    "layer": 4,
                    "value": "本技能的射程增加5米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "灵化",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_d929d1cf-edb3-42fb-b02f-23dfd7b736a2_1404",
        "skillDescribe": {
            "main": "解除控制并进入灵化状态，持续<em class='green'>8</em>秒",
            "static": ["灵化状态下可使用技能：<em class='green'>魅惑</em>：使周围<em class='green'>5</em>米范围内敌方进入<em class='green'>晕眩</em>状态，持续<em class='green'>3</em>秒；<em class='green'>灵冲</em>：吟唱<em class='green'>3</em>秒，对目标造成大量法术伤害", "灵化加速效果结束后，立即回复两系无双值各<em class='green'>10</em>点"],
            "addition": [{
                "initiative": "进入<em class='green'>灵化</em>状态",
                "passivity": "灵化：免疫所有控制技能效果，受到伤害降低50%，移动速度提升50%"
            }],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "灵化效果解除后,自身施放的下一个技能伤害或者治疗效果提高10%（灵解状态下无效）"
                },
                {
                    "layer": 4,
                    "value": "灵化效果解除后,自身施放的下一个技能伤害或者治疗效果提高30%（灵解状态下无效）"
                },
                {
                    "layer": 5,
                    "value": "灵化效果解除后,自身施放的下一个技能伤害或者治疗效果提高50%（灵解状态下无效）"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "灵化状态下，每2秒回复自身1.5%的生命值"
                },
                {
                    "layer": 9,
                    "value": "灵化状态下，每2秒回复自身3%的生命值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "灵化效果解除后,立即获得的两系无双值增加3点"
                },
                {
                    "layer": 14,
                    "value": "灵化效果解除后,立即获得的两系无双值增加6点"
                },
                {
                    "layer": 15,
                    "value": "灵化效果解除后,立即获得的两系无双值增加10点"
                }],
                "require": {
                    "books": "高级灵化卷一*魂",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "灵化状态下,自身受到的伤害额外降低10%"
                },
                {
                    "layer": 14,
                    "value": "灵化状态下,自身受到的伤害额外降低20%"
                }],
                "require": {
                    "books": "高级灵化卷二*魂",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "灵化的持续时间增加2秒"
                },
                {
                    "layer": 4,
                    "value": "灵化的持续时间增加4秒"
                },
                {
                    "layer": 5,
                    "value": "灵化的持续时间增加7秒"
                }],
                "require": {
                    "books": "初级灵化卷一*悟",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级灵化卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "“灵冲”技能造成的法术伤害提高10%"
                },
                {
                    "layer": 4,
                    "value": "“灵冲”技能造成的法术伤害提高20%"
                },
                {
                    "layer": 5,
                    "value": "“灵冲”技能造成的法术伤害提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "每次施放“灵冲”技能使自身获得1点巧语系无双值"
                },
                {
                    "layer": 9,
                    "value": "每次施放“灵冲”技能使自身获得3点巧语系无双值"
                },
                {
                    "layer": 10,
                    "value": "每次施放“灵冲”技能使自身获得5点巧语系无双值"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "“灵冲”技能可无视目标10%的法术防御"
                },
                {
                    "layer": 14,
                    "value": "“灵冲”技能可无视目标15%的法术防御"
                },
                {
                    "layer": 15,
                    "value": "“灵冲”技能可无视目标20%的法术防御"
                }],
                "require": {
                    "books": "高级灵化卷一*灵",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "灵甲",
        "skillProperty": ["辅助技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_43854627-9c01-43a1-ad88-be878538269a_1403",
        "skillDescribe": {
            "main": "给自身或友方单位附加一个可以吸收伤害的灵甲，驱散目标身上所有负面状态的效果",
            "static": ["自身或者友方单位获得一个灵甲护盾，驱散目标身上所有负面状态的效果"],
            "addition": [{
                "initiative": "自身进入<em class='green'>灵甲</em>状态，最多持续<em class='green'>60</em>秒",
                "passivity": "灵甲：吸收自身受到的伤害"
            },
            {
                "initiative": "附加于自身的灵甲被击破后会使周围敌方<em class='green'>变形</em>，持续持续<em class='green'>3</em>秒",
                "passivity": "变形：变成随机一类小动物，移动速度降低50%，无法使用轻功和技能"
            }],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "“灵甲”状态吸收的伤害提高10%"
                },
                {
                    "layer": 4,
                    "value": "“灵甲”状态吸收的伤害提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "“灵甲”状态额外提高目标10%物理防御力"
                },
                {
                    "layer": 9,
                    "value": "“灵甲”状态额外提高目标20%物理防御力"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "处于“灵甲”状态的目标,受到的治疗效果提高10%"
                },
                {
                    "layer": 14,
                    "value": "处于“灵甲”状态的目标,受到的治疗效果提高20%"
                },
                {
                    "layer": 15,
                    "value": "处于“灵甲”状态的目标,受到的治疗效果提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能的最大射程提高3米"
                },
                {
                    "layer": 4,
                    "value": "本技能的最大射程提高6米"
                },
                {
                    "layer": 5,
                    "value": "本技能的最大射程提高10米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级灵甲卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "5秒内再次使用可以主动解除自身的“灵甲”状态,并施放“变形”效果"
                }],
                "require": {
                    "books": "初级灵甲卷一*灵",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的“变形”效果使目标的法术防御力降低10%"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的“变形”效果使目标的法术防御力降低20%"
                },
                {
                    "layer": 10,
                    "value": "本技能造成的“变形”效果使目标的法术防御力降低30%"
                }],
                "require": {
                    "preNum": 1,
                    "totolNum": 1,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能造成的“变形”效果的持续时间增加0.5秒"
                },
                {
                    "layer": 14,
                    "value": "本技能造成的“变形”效果的持续时间增加1秒"
                }],
                "require": {
                    "books": "高级灵甲卷一*灵",
                    "preNum": 3,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "当自身的生命上限低于10%时,可在晕眩或者击倒状态下使用此技能，并使灵甲的目标霸体2秒"
                },
                {
                    "layer": 9,
                    "value": "当自身的生命上限低于20%时,可在晕眩或者击倒状态下使用此技能，并使灵甲的目标霸体2秒"
                },
                {
                    "layer": 10,
                    "value": "当自身的生命上限低于30%时,可在晕眩或者击倒状态下使用此技能，并使灵甲的目标霸体2秒"
                }],
                "require": {
                    "books": "中级灵甲卷二*灵",
                    "preNum": 0,
                    "totolNum": 1,
                    "line": "59"
                }
            },
            {}]]
        }
    },
    {
        "skillName": "芊心",
        "skillProperty": ["回复技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9a51aa88-1a2c-45f3-bce8-d8bc6dd99b44_1415",
        "skillDescribe": {
            "main": "使自身和周围所有队友受到的治疗效果提升并免疫所有控制效果",
            "static": ["提升自身和周围队友受到的治疗效果并免疫控制"],
            "addition": [{
                "initiative": "自身和队友获得<em class='green'>芊心</em>状态，持续<em class='green'>3</em>秒",
                "passivity": "芊心：受到的治疗效果提升50%并免疫控制效果"
            },
            {
                "initiative": "自身和队友获得<em class='green'>灵珑之心</em>状态，持续<em class='green'>1800</em>秒",
                "passivity": "灵珑之心：每5秒回复一定的生命值和法力值"
            }],
            "trainingName": ["魂", "悟", "灵"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的“灵珑之心”效果每秒回复的生命上限和法力值提高10%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的“灵珑之心”效果每秒回复的生命上限和法力值提高20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能造成的“芊心”效果提升的治疗效果提高10%"
                },
                {
                    "layer": 9,
                    "value": "本技能造成的“芊心”效果提升的治疗效果提高20%"
                }],
                "require": {
                    "books": "中级芊心卷一*魂",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能造成的“芊心”效果持续时间增加1秒"
                },
                {
                    "layer": 14,
                    "value": "本技能造成的“芊心”效果持续时间增加2秒"
                }],
                "require": {
                    "books": "高级芊心卷一*魂",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "芊心状态下，自身的法术攻击力和治疗能力提升5%"
                },
                {
                    "layer": 9,
                    "value": "芊心状态下，自身的法术攻击力和治疗能力提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级芊心卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能造成的“芊心”效果使目标的轻功回复速度提高30%"
                },
                {
                    "layer": 4,
                    "value": "本技能造成的“芊心”效果使目标的轻功回复速度提高50%"
                }],
                "require": {
                    "books": "初级虚空流转卷一*暗",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能有50%概率为自己和周围队友立即恢复一次等同与其身上所有“如沐春风”的剩余治疗量的生命上限"
                },
                {
                    "layer": 9,
                    "value": "本技能有100%概率为自己和周围队友立即恢复一次等同与其身上所有“如沐春风”的剩余治疗量的生命上限"
                }],
                "require": {
                    "books": "中级芊心卷一*灵",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "本技能造成的“芊心”效果使目标的免爆率提高15%"
                },
                {
                    "layer": 14,
                    "value": "本技能造成的“芊心”效果使目标的免爆率提高30%"
                }],
                "require": {
                    "books": "高级芊心卷一*灵",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    }],
    "yecha": [{
        "skillName": "刃刺",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_15da6653-2ee4-4616-9f0f-8ab3c221a853_1701",
        "skillDescribe": {
            "main": "对前方区域敌人造成少量伤害",
            "static": ["自身处于毒刃状态下,则使目标一定中毒"],
            "addition": [{
                "initiative": "有<em class='green'>30%</em>概率使敌人受到<em class='green'>中毒</em>效果，持续<em class='green'>5</em>秒，最多可叠加<em class='green'>3</em>层",
                "passivity": "5秒内每2秒受到10%物理伤害"
            }],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能伤害提升4%"
                },
                {
                    "layer": 4,
                    "value": "技能伤害提升8%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "每次命中敌人有10%概率使自己获得“极限”效果，持续3秒，最多可叠加2层"
                },
                {
                    "layer": 9,
                    "value": "每次命中敌人有20%概率使自己获得“极限”效果，持续3秒，最多可叠加2层"
                },
                {
                    "layer": 10,
                    "value": "每次命中敌人有30%概率使自己获得“极限”效果，有5%概率打出最高伤害，持续3秒，最多可叠加2层"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "极限效果的持续时间增加1秒，层数增加1层"
                },
                {
                    "layer": 14,
                    "value": "极限效果的持续时间增加2秒，层数增加2层"
                },
                {
                    "layer": 15,
                    "value": "极限效果的持续时间增加3秒，层数增加3层"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "毒刃状态下对敌人造成的伤害提升7.5%"
                },
                {
                    "layer": 4,
                    "value": "毒刃状态下对敌人造成的伤害提升15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "使用此技能有1%概率使体内瞬间凝聚一枚血毒"
                },
                {
                    "layer": 9,
                    "value": "使用此技能有2%概率使体内瞬间凝聚一枚血毒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "对有中毒的敌人会使其有10%的概率受到断筋效果，移动速度降低50%，持续2秒"
                },
                {
                    "layer": 14,
                    "value": "对有中毒的敌人会使其有10%的概率受到断筋效果，移动速度降低50%，持续2秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "链击",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_3d326ec0-bc68-44d6-afa9-e6e352ecd357_1711",
        "skillDescribe": {
            "main": "对前方大范围内的敌人造成少量伤害，最多可攻击4次",
            "static": ["自身处于<em class='green'>毒刃</em>状态下，则使目标一定中毒"],
            "addition": [{
                "initiative": "有<em class='green'>30%</em>概率使敌人受到<em class='green'>中毒</em>效果，持续<em class='green'>5</em>秒，最多可叠加<em class='green'>3</em>层",
                "passivity": "5秒内每2秒受到10%物理伤害"
            }],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "技能伤害提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "链击4击内，每下一击的伤害提升5%"
                },
                {
                    "layer": 9,
                    "value": "链击4击内，每下一击的伤害提升10%"
                }],
                "require": {
                    "preNum": 2,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "左系无双值增长0.7"
                },
                {
                    "layer": 14,
                    "value": "左系无双值增长1.4"
                },
                {
                    "layer": 15,
                    "value": "左系无双值增长2.1"
                }],
                "require": {
                    "books": "高级链击卷一*刹",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的伤害额外提升7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的伤害额外提升15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "使用此技能有2%概率使体内瞬间凝聚一枚血毒"
                },
                {
                    "layer": 4,
                    "value": "使用此技能有4%概率使体内瞬间凝聚一枚血毒"
                }],
                "require": {
                    "books": "初级链击卷一*业",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "毒刃状态下对敌人造成的伤害提升11%"
                },
                {
                    "layer": 9,
                    "value": "毒刃状态下对敌人造成的伤害提升22%"
                }],
                "require": {
                    "books": "中级链击卷一*业",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "对有中毒的敌人会使其有30%的概率受到断筋效果，移动速度降低50%，持续2秒。"
                },
                {
                    "layer": 14,
                    "value": "对有中毒的敌人会使其有60%的概率受到断筋效果，移动速度降低50%，持续2秒。"
                }],
                "require": {
                    "books": "高级链击卷一*业",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "血刺",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a014e803-ce33-4d87-bd7d-052a0d6fca4a_1705",
        "skillDescribe": {
            "main": "对目标和前方直线的敌人造成大量伤害",
            "static": ["在目标身后，伤害额外提升<em class='green'>20%</em>", "自身处于毒体状态下，技能伤害增加<em class='green'>20%</em>"],
            "addition": [{
                "initiative": "击中敌人可使自己获得<em class='green'>极限</em>效果，持续<em class='green'>3</em>秒，最多可叠加<em class='green'>2</em>层",
                "passivity": "打出最高伤害的概率提高5%"
            }],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "技能伤害提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "毒体状态下技能伤害额外提高11%"
                },
                {
                    "layer": 9,
                    "value": "毒体状态下技能伤害额外提高22%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "在目标身后攻击的额外伤害增加15%"
                },
                {
                    "layer": 14,
                    "value": "在目标身后攻击的额外伤害增加30%"
                },
                {
                    "layer": 15,
                    "value": "在目标身后攻击的额外伤害增加45%"
                }],
                "require": {
                    "books": "高级血刺卷一*刹",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提升7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提升15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "对生命值高于70%的敌人必定造成最大物理攻击的伤害"
                },
                {
                    "layer": 14,
                    "value": "对生命值高于50%的敌人必定造成最大物理攻击的伤害"
                },
                {
                    "layer": 15,
                    "value": "对生命值高于30%的敌人必定造成最大物理攻击的伤害"
                }],
                "require": {
                    "books": "高级血刺卷二*刹",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "使用此技能有4%概率使体内瞬间凝聚一枚血毒"
                },
                {
                    "layer": 4,
                    "value": "使用此技能有8%概率使体内瞬间凝聚一枚血毒"
                }],
                "require": {
                    "books": "初级血刺卷一*业",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成25%基础物理攻击力的伤害"
                },
                {
                    "layer": 9,
                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成50%基础物理攻击力的伤害"
                },
                {
                    "layer": 10,
                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成70%基础物理攻击力的伤害"
                }],
                "require": {
                    "books": "中级血刺卷一*刹",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "提升10%的引爆中毒伤害"
                },
                {
                    "layer": 14,
                    "value": "提升30%的引爆中毒伤害"
                },
                {
                    "layer": 15,
                    "value": "提升50%的引爆中毒伤害"
                }],
                "require": {
                    "books": "高级血刺卷一*业",
                    "preNum": 3,
                    "totolNum": 0,
                    "line": "69"
                }
            }], [{},
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "造成的伤害15%立即转化为自己的生命上限的血量，最多回复自身总血量5%的生命上限的血量"
                },
                {
                    "layer": 14,
                    "value": "造成的伤害30%立即转化为自己的生命上限的血量，最多回复自身总血量10%的生命上限的血量"
                }],
                "require": {
                    "books": "高级血刺卷二*业",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }]]
        }
    },
    {
        "skillName": "毒体",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9943704e-16bc-4ca1-98fd-7b9b51336a5c_1716",
        "skillDescribe": {
            "main": "以蝎毒浸体，施放体内“血毒”，是自己进入“毒体”/“毒刃”状态，强化自身战力。掌握“悟死而生”后，体内可以凝聚血毒",
            "static": ["释放毒体需要消耗<em class='green'>3</em>枚血毒", "释放毒刃需要消耗<em class='green'>1</em>枚血毒", "毒刃和毒体状态不可共存"],
            "addition": [{
                "initiative": "进入<em class='green'>毒体</em>状态，持续<em class='green'>10</em>秒",
                "passivity": "自身最大物理攻击力增加，暴击力增加"
            },
            {
                "initiative": "进入<em class='green'>毒刃</em>状态，持续<em class='green'>10</em>秒",
                "passivity": "自身破魔力增加，并对中毒的目标伤害增加10%"
            }],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "毒体状态下，轻功回复速度增加每秒1.2点"
                },
                {
                    "layer": 4,
                    "value": "毒体状态下，轻功回复速度增加每秒2.4点"
                },
                {
                    "layer": 5,
                    "value": "毒体状态下，轻功回复速度增加每秒3.6点"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "毒体状态下提升的暴击力额外增加15%"
                },
                {
                    "layer": 9,
                    "value": "毒体状态下提升的暴击力额外增加30%"
                }],
                "require": {
                    "books": "中级浸毒卷一*刹",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "毒体状态下，自身受到的法术伤害降低4.5%"
                },
                {
                    "layer": 14,
                    "value": "毒体状态下，自身受到的法术伤害降低9%"
                },
                {
                    "layer": 15,
                    "value": "毒体状态下，自身受到的法术伤害降低13.5%"
                }],
                "require": {
                    "books": "高级浸毒卷一*刹",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}], [{},
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "中毒时间增加1秒"
                },
                {
                    "layer": 4,
                    "value": "中毒时间增加3秒"
                },
                {
                    "layer": 5,
                    "value": "中毒时间增加5秒"
                }],
                "require": {
                    "books": "初级浸毒卷一*业",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "中毒状态的最多可叠加层数增加2层"
                },
                {
                    "layer": 9,
                    "value": "中毒状态的最多可叠加层数增加4层"
                },
                {
                    "layer": 10,
                    "value": "中毒状态的最多可叠加层数增加6层"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "中毒状态下敌人有7%概率打出最小攻击的伤害"
                },
                {
                    "layer": 14,
                    "value": "中毒状态下敌人有14%概率打出最小攻击的伤害"
                },
                {
                    "layer": 15,
                    "value": "中毒状态下敌人有20%概率打出最小攻击的伤害"
                }],
                "require": {
                    "books": "高级浸毒卷一*业",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "毒刃状态提升的破魔力额外增加30%"
                },
                {
                    "layer": 4,
                    "value": "毒刃状态提升的破魔力额外增加60%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "额外消耗1个血毒，使毒刃的持续时间增加10秒"
                },
                {
                    "layer": 9,
                    "value": "额外消耗1个血毒，使毒刃的持续时间增加20秒"
                }],
                "require": {
                    "books": "高级浸毒卷二*业",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}]]
        }
    },
    {
        "skillName": "链袭",
        "skillProperty": ["物理技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_133e6133-7fa0-47db-adb7-4351a275d01b_1713",
        "skillDescribe": {
            "main": "召唤3具暗影分身，向前方劈砍长链，对前方区域内敌人造成大量物理伤害",
            "static": ["自身处于<em class='green'>毒体</em>状态下，技能伤害增加<em class='green'>20%</em>"],
            "addition": [],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "技能伤害提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "产生暴击后获得暴击提升状态，增加5%的暴击率，持续5秒"
                },
                {
                    "layer": 9,
                    "value": "产生暴击后获得暴击提升状态，增加10%的暴击率，持续5秒"
                }],
                "require": {
                    "books": "中级链袭卷一*刹",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "产生暴击后，额外增加左右两系无双值各2点"
                },
                {
                    "layer": 14,
                    "value": "产生暴击后，额外增加左右两系无双值各4点"
                },
                {
                    "layer": 15,
                    "value": "产生暴击后，额外增加左右两系无双值各6点"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "毒体状态下，技能伤害提高11%"
                },
                {
                    "layer": 9,
                    "value": "毒体状态下，技能伤害提高22%"
                }],
                "require": {
                    "books": "中级链袭卷二*刹",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "降低链袭0.6秒的吟唱时间"
                }],
                "require": {
                    "books": "高级链袭卷一*悟",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "使用此技能有8%概率使体内瞬间凝聚一枚血毒"
                },
                {
                    "layer": 4,
                    "value": "使用此技能有16%概率使体内瞬间凝聚一枚血毒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成25%基础物理攻击力的伤害"
                },
                {
                    "layer": 9,
                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成50%基础物理攻击力的伤害"
                },
                {
                    "layer": 9,
                    "value": "自身处于毒刃状态下，使用此技能可引爆锁定目标身上的“中毒”状态，每层中毒状态造成70%基础物理攻击力的伤害"
                }],
                "require": {
                    "books": "中级链袭卷一*业",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "提升10%的引爆中毒伤害"
                },
                {
                    "layer": 14,
                    "value": "提升30%的引爆中毒伤害"
                },
                {
                    "layer": 15,
                    "value": "提升50%的引爆中毒伤害"
                }],
                "require": {
                    "books": "高级链袭卷一*业",
                    "preNum": 0,
                    "totolNum": 3,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "影杀",
        "skillProperty": ["物理技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_6de54a5f-969b-4bd7-9315-c45b0bb571d7_1702",
        "skillDescribe": {
            "main": "举刀刺向目标，穿过敌人后移动至身后处并将其<em class='green'>击倒</em>",
            "static": ["快速移动至目标身后<em class='green'>3</em>米处，并造成物理伤害", "隐身状态下使用此技能不会进入技能冷却", "自身处于<em class='green'>毒体状态下会使敌人减少<em class='green'>10</em>点轻功值"],
            "addition": [{
                "initiative": "使敌方被<em class='green'>击倒</em>，持续<em class='green'>3</em>秒",
                "passivity": "无法移动、使用技能和轻功"
            }],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能伤害提升14%"
                },
                {
                    "layer": 4,
                    "value": "技能伤害提升28%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "毒体状态下，技能有30%几率造成破甲效果，降低15%物理防御力，持续4秒"
                },
                {
                    "layer": 9,
                    "value": "毒体状态下，技能有60%几率造成破甲效果，降低15%物理防御力，持续4秒"
                },
                {
                    "layer": 10,
                    "value": "毒体状态下，技能有100%几率造成破甲效果，降低15%物理防御力，持续4秒"
                }],
                "require": {
                    "books": "中级影杀卷一*刹",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "破甲效果额外提升30%，持续时间增加1秒"
                },
                {
                    "layer": 14,
                    "value": "破甲效果额外提升30%，持续时间增加3秒"
                },
                {
                    "layer": 15,
                    "value": "破甲效果额外提升30%，持续时间增加5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的伤害额外提升21%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的伤害额外提升42%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {
                "effect": [{
                    "layer": 13,
                    "value": "毒体状态下施放此技能使自己在5秒内攻击力提升5%"
                },
                {
                    "layer": 14,
                    "value": "毒体状态下施放此技能使自己在5秒内攻击力提升10%"
                },
                {
                    "layer": 15,
                    "value": "毒体状态下施放此技能使自己在5秒内攻击力提升15%"
                }],
                "require": {
                    "books": "高级影杀卷二*刹",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "使用此技能时无需吟唱"
                }],
                "require": {
                    "books": "高级影杀卷一*悟",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能射程增加1米"
                },
                {
                    "layer": 4,
                    "value": "技能射程增加2米"
                },
                {
                    "layer": 5,
                    "value": "技能射程增加3米"
                }],
                "require": {
                    "books": "初级影杀卷一*业",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "毒体状态下额外减少敌人8点轻功值"
                },
                {
                    "layer": 9,
                    "value": "毒体状态下额外减少敌人16点轻功值"
                }],
                "require": {
                    "books": "中级影杀卷一*业",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "对中毒状态下的敌人使用此技能，有40%概率会对其造成“盲目”效果，技能射程降低50%，持续3秒"
                },
                {
                    "layer": 14,
                    "value": "对中毒状态下的敌人使用此技能，有70%概率会对其造成“盲目”效果，技能射程降低50%，持续3秒"
                },
                {
                    "layer": 15,
                    "value": "对中毒状态下的敌人使用此技能，有100%概率会对其造成“盲目”效果，技能射程降低50%，持续3秒"
                }],
                "require": {
                    "books": "高级影杀卷一*业",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "潜影",
        "skillProperty": ["物理技能", "吟唱技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_1f420f9b-7e75-4e63-abc5-3b406fbe45a5_1714",
        "skillDescribe": {
            "main": "化为暗影之体，使敌人无从发现",
            "static": ["发动攻击或治疗并产生效果后，隐身状态会被解除", "战斗状态下无法使用", "潜影技能等级越高越不容易被发现，观察者的人物等级越低越不容易被发现，观察者与隐身单位的距离越远越不容易被发现"],
            "addition": [{
                "initiative": "使自己进入<em class='green'>隐身</em>状态",
                "passivity": "使敌人无法看到自己，并吸收少量伤害，伤害吸收到达上限后状态提前解除"
            }],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "隐身状态下，自身的物理攻击力增加5%"
                },
                {
                    "layer": 4,
                    "value": "隐身状态下，自身的物理攻击力增加10%"
                },
                {
                    "layer": 4,
                    "value": "隐身状态下，自身的物理攻击力增加15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "隐身状态下，下一击的暴击概率增加7.5%"
                },
                {
                    "layer": 9,
                    "value": "隐身状态下，下一击的暴击概率增加15%"
                },
                {
                    "layer": 10,
                    "value": "隐身状态下，下一击的暴击概率增加22.5%"
                }],
                "require": {
                    "books": "中级潜影卷一*刹",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "隐身状态下，物理破防率增加7%"
                },
                {
                    "layer": 14,
                    "value": "隐身状态下，物理破防率增加14%"
                },
                {
                    "layer": 15,
                    "value": "隐身状态下，物理破防率增加21%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "隐身状态下，使用无双技能的无双值消耗减少5点"
                },
                {
                    "layer": 4,
                    "value": "隐身状态下，使用无双技能的无双值消耗减少12点"
                },
                {
                    "layer": 5,
                    "value": "隐身状态下，使用无双技能的无双值消耗减少20点"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "books": "中级潜影卷一*悟",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "隐身状态下，移动速度提升10%"
                },
                {
                    "layer": 4,
                    "value": "隐身状态下，移动速度提升20%"
                },
                {
                    "layer": 5,
                    "value": "隐身状态下，移动速度提升30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "隐身状态下，伤害吸收量提升25%"
                },
                {
                    "layer": 9,
                    "value": "隐身状态下，伤害吸收量提升50%"
                },
                {
                    "layer": 10,
                    "value": "隐身状态下，伤害吸收量提升75%"
                }],
                "require": {
                    "books": "中级潜影卷一*业",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "隐身状态下，受到伤害减免10%"
                },
                {
                    "layer": 14,
                    "value": "隐身状态下，受到伤害减免20%"
                },
                {
                    "layer": 15,
                    "value": "隐身状态下，受到伤害减免30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "链舞",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_38f6c673-8fad-49c6-9842-80cacd4e8cf1_1715",
        "skillDescribe": {
            "main": "极力向前挥舞链刃，对自身周围的敌人造成大量伤害",
            "static": ["每<em class='green'>0.2</em>秒造成一次物理伤害", "自身处于<em class='green'>毒刃</em>状态下，则使目标一定中毒"],
            "addition": [{
                "initiative": "释放过程中自身霸体",
                "passivity": "免疫晕眩、定身、减速等控制效果"
            },
            {
                "initiative": "有<em class='green'>30%</em>概率使敌人受到中毒效果，持续<em class='green'>5</em>秒,最多可叠加<em class='green'>3</em>层",
                "passivity": "5秒内每2秒受到10%的物理伤害"
            }],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能伤害提升5%"
                },
                {
                    "layer": 4,
                    "value": "技能伤害提升10%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能施放后，自身获得“风行”效果，移动速度提升50%，持续1秒"
                },
                {
                    "layer": 9,
                    "value": "本技能施放后，自身获得“风行”效果，移动速度提升50%，持续2秒"
                },
                {
                    "layer": 10,
                    "value": "本技能施放后，自身获得“风行”效果，移动速度提升50%，持续3秒"
                }],
                "require": {
                    "books": "中级链舞卷一*刹",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "使敌人获得破甲效果，物理和法术防御降低2%，最多可叠加4层，持续5秒"
                },
                {
                    "layer": 14,
                    "value": "使敌人获得破甲效果，物理和法术防御降低4%，最多可叠加4层，持续5秒"
                },
                {
                    "layer": 15,
                    "value": "使敌人获得破甲效果，物理和法术防御降低6%，最多可叠加4层，持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高7.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高15%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "毒刃状态下，造成伤害的10%立即转化为自己的生命值，单次攻击最多回复自己生命上限值的5%"
                },
                {
                    "layer": 9,
                    "value": "毒刃状态下，造成伤害的20%立即转化为自己的生命值，单次攻击最多回复自己生命上限值的5%"
                },
                {
                    "layer": 10,
                    "value": "毒刃状态下，造成伤害的30%立即转化为自己的生命值，单次攻击最多回复自己生命上限值的5%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "每次攻击降低敌人20%移动速度，最多可叠加4层，持续2秒"
                },
                {
                    "layer": 4,
                    "value": "每次攻击降低敌人20%移动速度，最多可叠加4层，持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "毒刃状态下对敌人造成的伤害提升11%"
                },
                {
                    "layer": 9,
                    "value": "毒刃状态下对敌人造成的伤害提升22%"
                }],
                "require": {
                    "books": "中级链舞卷一*业",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "使敌人获得迟钝效果，无法使用轻功，持续2秒"
                },
                {
                    "layer": 14,
                    "value": "使敌人获得迟钝效果，无法使用轻功，持续4秒"
                },
                {
                    "layer": 15,
                    "value": "使敌人获得迟钝效果，无法使用轻功，持续6秒"
                }],
                "require": {
                    "books": "高级链舞卷一*业",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "影袭",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_5a924cfe-2a99-4b5f-85fb-293f00571dbf_1703",
        "skillDescribe": {
            "main": "化为疾影，瞬间冲向前方",
            "static": ["对敌人造成少量物理伤害"],
            "addition": [{
                "initiative": "使周围敌人获得<em class='green'>定身</em>状态<em class='green'>1</em>秒",
                "passivity": "无法移动"
            },
            {
                "initiative": "毒体期间，会使敌人受到<em class='green'>麻痹</em>状态<em class='green'>3</em>秒",
                "passivity": "移动速度降低50%，无法使用轻功"
            }],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能伤害提升9%"
                },
                {
                    "layer": 4,
                    "value": "技能伤害提升18%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "使用此技能会减少旋刃1秒的冷却时间"
                },
                {
                    "layer": 9,
                    "value": "使用此技能会减少旋刃2秒的冷却时间"
                }],
                "require": {
                    "books": "中级影袭卷一*刹",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "施放影袭时，自身获得1秒的霸体效果"
                },
                {
                    "layer": 14,
                    "value": "施放影袭时，自身获得2秒的霸体效果"
                }],
                "require": {
                    "books": "高级影袭卷一*刹",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提升14%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提升28%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                }],
                "require": {
                    "books": "中级影袭卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "前冲距离增加1米"
                },
                {
                    "layer": 4,
                    "value": "前冲距离增加2米"
                },
                {
                    "layer": 5,
                    "value": "前冲距离增加3米"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "使中毒状态下的敌人的左右两系无双值减少1点"
                },
                {
                    "layer": 9,
                    "value": "使中毒状态下的敌人的左右两系无双值减少2点"
                },
                {
                    "layer": 10,
                    "value": "使中毒状态下的敌人的左右两系无双值减少3点"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "使中毒状态下的敌人获得弱疗效果，受到的治疗量下降10%，持续5秒"
                },
                {
                    "layer": 14,
                    "value": "使中毒状态下的敌人获得弱疗效果，受到的治疗量下降20%，持续5秒"
                },
                {
                    "layer": 14,
                    "value": "使中毒状态下的敌人获得弱疗效果，受到的治疗量下降30%，持续5秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "链缚",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_f9a41eb5-4a66-42e2-81cf-f917e2b37b61_1712",
        "skillDescribe": {
            "main": "向前方释出链刃，将前方敌人全部牵引至自身面前",
            "static": ["自身处于<em class='green'>毒体</em>状态下，会使敌人减少<em class='green'>10</em>点轻功值"],
            "addition": [{
                "initiative": "被牵引的敌人获得<em class='green'>晕眩</em>状态<em class='green'>3</em>秒",
                "passivity": "晕眩：无法移动、使用技能和轻功"
            }],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能伤害提升9%"
                },
                {
                    "layer": 4,
                    "value": "技能伤害提升18%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "本技能施放后，3秒内下一次使用吟唱技能时的吟唱时间降低0.3秒"
                },
                {
                    "layer": 9,
                    "value": "本技能施放后，3秒内下一次使用吟唱技能时的吟唱时间降低0.6秒"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "使敌人获得易伤效果，受到伤害提高5%，持续3秒"
                },
                {
                    "layer": 14,
                    "value": "使敌人获得易伤效果，受到伤害提高10%，持续3秒"
                }],
                "require": {
                    "books": "高级链缚卷一*刹",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提升14%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提升28%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "50%的概率驱散对方一个正面状态"
                },
                {
                    "layer": 4,
                    "value": "100%的概率驱散对方一个正面状态"
                }],
                "require": {
                    "books": "初级链缚卷一*业",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "毒体状态下额外减少敌人5点轻功值"
                },
                {
                    "layer": 9,
                    "value": "毒体状态下额外减少敌人10点轻功值"
                }],
                "require": {
                    "books": "中级链缚卷一*业",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "增加10的技能控制等级"
                },
                {
                    "layer": 14,
                    "value": "增加20的技能控制等级"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    },
    {
        "skillName": "旋刃",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_366dbe48-e00b-4135-b336-e3f58b8325d8_1704",
        "skillDescribe": {
            "main": "以刃护体，对周围敌人造成伤害并反噬敌人的攻击",
            "static": ["每<em class='green'>0.5</em>秒造成一次物理伤害", "解除自身控制状态"],
            "addition": [{
                "initiative": "期间自身获得<em class='green'>旋刃</em>效果，持续<em class='green'>5</em>秒",
                "passivity": "旋刃：自身的躲闪率提升30%，对给自己造成伤害的敌人反弹伤害"
            }],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "技能伤害提升15%"
                },
                {
                    "layer": 4,
                    "value": "技能伤害提升30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "弹射的伤害提升25%"
                },
                {
                    "layer": 9,
                    "value": "弹射的伤害提升50%"
                },
                {
                    "layer": 10,
                    "value": "弹射的伤害提升75%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "技能持续时间增加1秒"
                },
                {
                    "layer": 14,
                    "value": "技能持续时间增加2秒"
                },
                {
                    "layer": 15,
                    "value": "技能持续时间增加3秒"
                }],
                "require": {
                    "books": "高级旋刃卷一*刹",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "本技能对怪物造成的物理伤害额外提高22.5%"
                },
                {
                    "layer": 4,
                    "value": "本技能对怪物造成的物理伤害额外提高45%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级旋刃卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "额外增加技能5%的躲闪率"
                },
                {
                    "layer": 4,
                    "value": "额外增加技能10%的躲闪率"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "获得1秒的霸体状态"
                },
                {
                    "layer": 9,
                    "value": "获得2秒的霸体状态"
                },
                {
                    "layer": 10,
                    "value": "获得3秒的霸体状态"
                }],
                "require": {
                    "books": "中级旋刃卷一*业",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "旋刃期间，移动速度提升30%"
                },
                {
                    "layer": 14,
                    "value": "旋刃期间，移动速度提升60%"
                },
                {
                    "layer": 15,
                    "value": "旋刃期间，移动速度提升90%"
                }],
                "require": {
                    "books": "高级旋刃卷一*业",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{
                "effect": [{
                    "layer": 3,
                    "value": "受到来自怪物的伤害减少15%"
                },
                {
                    "layer": 4,
                    "value": "受到来自怪物的伤害减少30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {},
            {}]]
        }
    },
    {
        "skillName": "疾影",
        "skillProperty": ["物理技能", "瞬发技能"],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_52323c38-5395-4836-bfee-72e428c2cbab_1706",
        "skillDescribe": {
            "main": "激发体内潜能，短时间内大幅提升自己的移动和攻击速度",
            "static": ["解除自身控制状态", "降低大量仇恨值"],
            "addition": [{
                "initiative": "获得<em class='green'>疾影</em>状态，持续<em class='green'>10</em>秒",
                "passivity": "疾影：提升自己的移动速度和刃刺、链击的攻击速度"
            },
            {
                "initiative": "获得<em class='green'>霸体</em>状态，持续<em class='green'>3</em>秒",
                "passivity": "霸体：免疫所有控制效果"
            }],
            "trainingName": ["刹", "悟", "业"],
            "training": [[{
                "effect": [{
                    "layer": 3,
                    "value": "移动速度额外提升10%"
                },
                {
                    "layer": 4,
                    "value": "移动速度额外提升20%"
                },
                {
                    "layer": 5,
                    "value": "移动速度额外提升30%"
                }],
                "require": {
                    "books": "初级疾影卷一*刹",
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "疾影状态下增加战斗内轻功回复速度每秒2点"
                },
                {
                    "layer": 9,
                    "value": "疾影状态下增加战斗内轻功回复速度每秒4点"
                },
                {
                    "layer": 10,
                    "value": "疾影状态下增加战斗内轻功回复速度每秒6点"
                }],
                "require": {
                    "books": "中级疾影卷一*刹",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "降低自身7%的物理和法术防御力，增加7%的物理和法术攻击力"
                },
                {
                    "layer": 14,
                    "value": "降低自身14%的物理和法术防御力，增加14%的物理和法术攻击力"
                },
                {
                    "layer": 14,
                    "value": "降低自身20%的物理和法术防御力，增加20%的物理和法术攻击力"
                }],
                "require": {
                    "books": "高级疾影卷一*刹",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {
                "effect": [{
                    "layer": 8,
                    "value": "疾影状态下，对怪物的伤害提高20%"
                },
                {
                    "layer": 9,
                    "value": "疾影状态下，对怪物的伤害提高40%"
                },
                {
                    "layer": 10,
                    "value": "疾影状态下，对怪物的伤害提高60%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "技能获得无双值提高10%"
                },
                {
                    "layer": 4,
                    "value": "技能获得无双值提高20%"
                },
                {
                    "layer": 5,
                    "value": "技能获得无双值提高30%"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "技能冷却时间降低7%"
                },
                {
                    "layer": 9,
                    "value": "技能冷却时间降低14%"
                },
                {
                    "layer": 10,
                    "value": "技能冷却时间降低20%"
                }],
                "require": {
                    "books": "中级疾影卷一*悟",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {}], [{
                "effect": [{
                    "layer": 3,
                    "value": "疾影状态提升5%的躲闪率"
                },
                {
                    "layer": 4,
                    "value": "疾影状态提升10%的躲闪率"
                },
                {
                    "layer": 5,
                    "value": "疾影状态提升15%的躲闪率"
                }],
                "require": {
                    "preNum": 0,
                    "totolNum": 0,
                    "line": "49"
                }
            },
            {
                "effect": [{
                    "layer": 8,
                    "value": "霸体持续时间增加1秒"
                },
                {
                    "layer": 9,
                    "value": "霸体持续时间增加2秒"
                }],
                "require": {
                    "books": "中级疾影卷一*业",
                    "preNum": 0,
                    "totolNum": 2,
                    "line": "59"
                }
            },
            {
                "effect": [{
                    "layer": 13,
                    "value": "使用技能后瞬间回复1枚血毒"
                },
                {
                    "layer": 14,
                    "value": "使用技能后瞬间回复2枚血毒"
                }],
                "require": {
                    "books": "高级疾影卷一*业",
                    "preNum": 0,
                    "totolNum": 4,
                    "line": "69"
                }
            }], [{},
            {},
            {}]]
        }
    }]
};
data.tianzhao = tianzhao
data.shiyu = shiyu
module.exports=data;


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/calcData.js
// module id = 4
// module chunks = 0 1 3 4